/* GENTCREATE — The Leather Set (sections/gcls-set.liquid), in the live
   product page's design.

   THE SET IS BUILT FROM REAL PIECES (owner decision, 29 Sep 2026): the
   leather iPhone case, a card holder OR a bifold wallet, the passport holder
   and the keychain, in one leather (a piece the leather is not made in is
   not offered), plus any number of MORE pieces made in the same leather.
   Every piece goes in the cart as its own line (its own product, variant
   and SKU); all lines of one set carry the same hidden property _set_id.
   Each piece has its own color (the main color picker sets all of them).

   THE PRICE is what checkout will charge, and nothing else: the pieces'
   own prices, less the store's automatic discount as the Admin API states
   it (D.disc, from the gcx.i18n_keys metafield): rate% off every item of
   the eligible collection once the cart holds `min` of them. The store's
   other active automatic discount (buy X, get Y) is mirrored too; the two
   do not combine, so checkout applies the one that saves more, and so does
   this page. What is already in the cart counts, as it does at checkout.

   NEVER SOLD OUT AS A WHOLE: a piece that is not made or sold out in its
   color (or, the case, for the chosen model) says so, with one tap to the
   nearest color it is in stock in, and is left out; the rest stays buyable.

   EVERY LANGUAGE. State and logic use keys, never translated text:
     S.leather  leather key   (croco, lizard, saffiano)
     S.color    color key of the set's Color option (its family: black, ...)
     S.device   model key     (iphone-18-pro-max, ...)
     S.pc       piece kind -> color family chosen for that piece
   Pieces match colors by color family key (K.pieces). Names shown come from
   the page's language and every sentence is a template from the section
   settings; plurals are "one: … | other: …" forms (Intl.PluralRules).

   THE ADDRESS is written only after the shopper changes something (never
   on load). Deep links: variant=<id>, leather=<key>, color=<key> (old
   colour=), device=<model key>, pick=wallet, pc=<kind>:<color>,...,
   without=<slot>,..., add=<productId>:<color>, initials=, gift=1, logo=1
   (the Minimalist logo, Oct 2026). */
(function () {
  'use strict';

  var root = document.querySelector('[data-gcls]');
  if (!root) return;
  var D;
  try { D = JSON.parse(root.querySelector('[data-gcls-data]').textContent); } catch (e) { return; }
  var T = D.t || {};
  var DISC = D.disc && D.disc.pct ? D.disc : null;
  var RATE = DISC ? +DISC.pct.rate || 0 : (+D.rate || 0);
  var MIN = DISC ? +DISC.pct.min || 3 : (+D.min || 3);
  var ELIG = null;
  if (DISC && DISC.pct.ids && DISC.pct.ids.length) {
    ELIG = {};
    DISC.pct.ids.forEach(function (id) { ELIG[String(id)] = 1; });
  }
  function idSet(a) { var o = {}; (a || []).forEach(function (id) { o[String(id)] = 1; }); return o; }
  var BX = (DISC && DISC.bx ? DISC.bx : []).map(function (r) {
    return { t: r.t, buy: +r.buy || 0, get: +r.get || 0, pct: +r.pct || 0, lim: +r.lim || 0, b: idSet(r.b), g: idSet(r.g) };
  }).filter(function (r) { return r.buy > 0 && r.get > 0 && r.pct > 0; });
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HOVER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function G() { return window.GCX || null; }

  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function setText(el, txt) { if (typeof el === 'string') el = q(el); if (el && el.textContent !== txt) el.textContent = txt; }
  function setHTML(el, h) { if (el && el.getAttribute('data-h') !== h) { el.innerHTML = h; el.setAttribute('data-h', h); } }

  /* ---------- language: templates, numbers, lists, plurals ---------- */
  function lang() { return (document.documentElement.getAttribute('lang') || 'en').trim() || 'en'; }
  function tpl(s, o) {
    return String(s == null ? '' : s).replace(/\[([a-z0-9_]+)\]|\{([a-z0-9_]+)\}/gi, function (m, a, b) {
      var k = a || b;
      return o && Object.prototype.hasOwnProperty.call(o, k) && o[k] != null ? String(o[k]) : m;
    });
  }
  function num(n) { var g = G(); return g && g.num ? g.num(n, { maximumFractionDigits: 0 }) : String(n); }
  function list(a) { var g = G(); a = a.filter(Boolean); return g && g.list ? g.list(a) : a.join(', '); }
  /* "one: {n} piece | other: {n} pieces" (translators add zero/two/few/many);
     keywords a translation translated anyway are dropped (forms by position) */
  var CATS = ['zero', 'one', 'two', 'few', 'many', 'other'];
  function forms(str) {
    str = String(str == null ? '' : str);
    if (str.indexOf('|') === -1) {
      var one = /^\s*(zero|one|two|few|many|other)\s*[:：]\s*([\s\S]*?)\s*$/.exec(str);
      return one ? { other: one[2] } : null;
    }
    var o = {}, plain = [], any = false;
    str.split('|').forEach(function (x) {
      var m = /^\s*(zero|one|two|few|many|other)\s*[:：]\s*([\s\S]*?)\s*$/.exec(x);
      if (m) { o[m[1]] = m[2]; any = true; return; }
      x = x.trim();
      if (!x) return;
      var t = /^([^:：{}\[\]|]{1,20})[:：]\s*([\s\S]*)$/.exec(x);
      plain.push(t ? t[2].trim() : x);
    });
    if (plain.length) {
      var cats = null;
      try {
        var pc = new Intl.PluralRules(lang()).resolvedOptions().pluralCategories || [];
        cats = CATS.filter(function (c) { return pc.indexOf(c) !== -1; });
      } catch (e) {}
      if (!any && cats && cats.length === plain.length && plain.length > 2) {
        cats.forEach(function (c, i) { o[c] = plain[i]; });
      } else {
        if (o.other == null) o.other = plain[plain.length - 1];
        if (o.one == null && plain.length > 1) o.one = plain[0];
      }
    }
    if (o.other == null) o.other = o.one != null ? o.one : '';
    return o;
  }
  function P(str, n, map) {
    var f = forms(str), s = str;
    if (f) {
      var cat = 'other';
      if (n === 0 && f.zero != null) cat = 'zero';
      else { try { cat = new Intl.PluralRules(lang()).select(n); } catch (e) { cat = n === 1 ? 'one' : 'other'; } }
      s = f[cat] != null ? f[cat] : f.other;
    }
    var m = {};
    if (map) for (var k in map) if (Object.prototype.hasOwnProperty.call(map, k)) m[k] = map[k];
    if (m.n == null) m.n = num(n);
    return tpl(s, m);
  }
  function slug(v) {
    var g = G();
    if (g && g.slug) return g.slug(v);
    v = String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return v || null;
  }
  function norm(v) { return String(v || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function join2(a, b) {
    if (!a) return b || '';
    if (!b) return a;
    var j = T.sentences && T.sentences.indexOf('{a}') !== -1 && T.sentences.indexOf('{b}') !== -1 ? T.sentences : '{a} {b}';
    return tpl(j, { a: a, b: b });
  }

  /* ---------- money, in the shop's own format ---------- */
  function money(c, short) {
    c = Math.round(c || 0);
    var fmt = String(D.moneyFormat || '${{amount}}');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var k = m ? m[1] : 'amount';
    function f(dec, ts, ds) {
      var parts = (Math.abs(c) / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    }
    var v;
    switch (k) {
      case 'amount_no_decimals': v = f(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = f(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = f(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = f(2, "'", '.'); break;
      default: v = f(2, ',', '.');
    }
    /* every whole amount drops its ".00" now, not only the short chips (owner, 17 Oct 2026: "$89") */
    if (c % 100 === 0) v = v.replace(/[.,]00$/, '');
    return (c < 0 ? '−' : '') + fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function sized(url, w) {
    if (!url) return '';
    return /width=\d+/.test(url) ? url.replace(/width=\d+/, 'width=' + w) : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- the Minimalist logo (owner, 17 Oct 2026) ----------
     The gold GENTCREATE wordmark left off the outside of the set's iPhone
     case and pressed into the inside instead, in the same place, without
     foil: the $25 minimalist-logo add-on, one per set, on its case. D.logo
     (sections/gcls-set.liquid): the add-on's variant and price, the words of
     its summary line, and src: every photo the stage can show as the case
     (the case pieces' variant photos, the set's own) that has a logo-free
     twin, by file name -> [product id, media id], the key of that twin in
     the maps snippets/gc-logo-spot-kit.liquid puts in the page (GCLogo.twin
     and .spot, assets/gc-logo-spot.js). The add-ons row and the indicator on
     the case's photo ("Logo inside +$25" under the gold wordmark; on, one
     see-through "Logo inside" chip where it was) are one choice, S.logo, and
     the page's GCLogo state is this builder's (GCLogo.own, at "go"). Offered
     while the case is in the set and the photo the stage shows of it has a
     twin (every case photo here has one). While it is on, that photo, the
     "Your set" thumbnail, the sticky bar, the zoom and the case in "What's in
     the set" show the twin; the piece's box (data-want) and the initials'
     anchor stay those of the photo as shot. Totals: t.logo, outside the set
     discount and its "-N%". The cart: buildLines and send. */
  var LG = D.logo && D.logo.id && D.logo.src ? D.logo : null;
  var GL = LG ? window.GCLogo || null : null;
  var LT = (LG && LG.t) || {};
  function lgKey(u) { return String(u || '').split('?')[0].split('/').pop().toLowerCase(); }
  function lgRef(u) { var e = LG && u ? LG.src[lgKey(u)] : null; return e && e.length > 1 ? e : null; }
  /* a photo's logo-free twin ('' without one), and where its wordmark sits ({x, y, w, r}: % of the photo, tilt) */
  function lgTwin(u) { var e = GL ? lgRef(u) : null; return e ? GL.twin(e[0], e[1]) || '' : ''; }
  function lgPos(u) { var e = GL ? lgRef(u) : null; return e ? GL.spot(e[0], e[1]) : null; }
  /* the case's photo on the stage as shot, '' while the case is out of the set */
  function lgCaseSrc() { var c = cur().caseRow; return c && c.on ? stageCase(c).src : ''; }
  function lgOffered() { return !!lgTwin(lgCaseSrc()); }
  function logoOn() { return !!(S.logo && lgOffered()); }
  /* a case photo as the choice shows it: its twin while the logo goes inside */
  function lgPhoto(u) { var t = u && logoOn() ? lgTwin(u) : ''; return t || u; }
  /* the row's square, the indicator, the page (GCLogo): the whole page follows, and a change made while the Photos
     view is shown goes back to "Your set", where it shows (render) */
  var lgAt0 = 0;
  function lgSet(on, src) {
    on = !!on;
    if (!LG || logoOn() === on || (on && !lgOffered())) return;
    S.logo = on;
    lgAt0 = Date.now();
    touch();
    gcT({ name: 'addon_toggle', addon: 'minimal_logo', state: on ? 'on' : 'off', surface: 'set_builder', source: src || 'row' });
    msg('');
    render();
  }
  /* just after a press: the offer under the pointer gives way to the chip, and the photo under it must not take that
     for the pointer resting on the case (its color pop-up opens on hover) */
  function lgHeld() { return Date.now() - lgAt0 < 1200; }
  /* every renderStage: the indicator on the case's photo. Mounted once the picture has settled (.is-spot-on, with the
     stamp spot), moved with the photo; a new photo element (another color or model: setImg fades a new one in) gets
     it anew, while the logo's tick changes the photo in place and keeps it (and the focus on it). GCLogo hears of
     every change of the choice. */
  var lgSpot = null, lgImg = null, lgAt = '', lgShown = false, lgRaf = 0;
  function lgSync() {
    if (!LG || !GL) return;
    var on = logoOn();
    if (on !== lgShown) { lgShown = on; if (GL.changed) GL.changed(); }
    var card = cards['core:case'], src = lgCaseSrc();
    var frame = card && !card.classList.contains('is-leave') ? card.querySelector('[data-gcls-frame]') : null;
    var ims = frame ? frame.querySelectorAll('img') : [], im = ims.length ? ims[ims.length - 1] : null;
    var pos = src && elComp && elComp.classList.contains('is-spot-on') ? lgPos(src) : null;
    if (lgSpot && (!pos || !im || lgImg !== im)) {
      lgSpot.destroy(); lgSpot = null; lgImg = null; lgAt = '';
      if (card) card.classList.remove('gcls-lgs-pen'); /* the initials' note has its words back (lgSide) */
    }
    if (!pos || !im || !window.GCLogoSpot) return;
    if (!lgSpot) {
      lgSpot = window.GCLogoSpot.mount(frame, im, pos, {
        isOn: logoOn,
        toggle: function () { lgSet(!logoOn(), 'photo'); },
        price: function () { return money(LG.p); }
      });
      lgImg = lgSpot ? im : null;
      if (lgSpot && lgRO) {
        lgRO.observe(frame);
        [].forEach.call(lgSpot.el.querySelectorAll('.gc-lgs__pill,.gc-lgs__chip'), function (el) { lgRO.observe(el); });
      }
    } else if (src !== lgAt) lgSpot.update(pos);
    lgAt = lgSpot ? src : '';
    lgSideSoon();
  }
  /* Where the offer goes. The case card is small beside the other pieces (on a phone about 130px wide): its tag (name
     and price) and its color button sit at its bottom corners, under the wordmark, and the initials' stamp with its
     note ("Tap to add your initials") above it. The photo always carries the offer (Oct 2026: on a phone it was
     missing in half the languages, and a two-line lozenge on the wordmark hid what it offers to take off), and keeps
     the gold wordmark in sight wherever there is room: "Logo inside +$25" hangs under the wordmark where it clears
     the tag and the button and stays on the card (gcls-set.css .gcls-lgs-down), else above it, where it clears the
     stamp, its note and the letters (.gcls-lgs-up); first as the product page's pill, while that keeps to one line,
     then on one line in the card's own small type (.gcls-lgs-tight), then without its price (.gcls-lgs-bare: the
     add-ons row and the summary carry it, the button's name too). Only where neither place has room for even that
     (a 320-375px phone, while a note of two or three lines is shown) does it sit on the wordmark itself, small, in
     the place the "Logo inside" chip takes once it is ticked (.gcls-lgs-mark: no frame); on the narrowest card (a
     large set, a long language) a size smaller there (.gcls-lgs-tiny), at last on two lines inside the card
     (.gcls-lgs-wrap); and where it would not clear the note even there, the note gives way to its pencil (the
     card's .gcls-lgs-pen: the stamp's frame and its name stay). Measured from the boxes themselves, so it holds in
     every language and at every width; the classes only ever move the offer or shrink it, they never hide it.
     A way: [its type (0 the product page's pill, 1 small, 2 smaller, 3 smaller on two lines), price dropped, place]. */
  var lgRO = LG && window.ResizeObserver ? new ResizeObserver(function () { lgSideSoon(); }) : null;
  var LG_WAYS = [
    [0, 0, 'down'], [0, 0, 'up'],
    [1, 0, 'down'], [1, 1, 'down'], [1, 0, 'up'], [1, 1, 'up'],
    [1, 1, 'mark'], [2, 1, 'mark'], [3, 1, 'mark']
  ];
  var LG_PEN = [[1, 0, 'up'], [1, 1, 'up'], [1, 1, 'mark'], [2, 1, 'mark'], [3, 1, 'mark']];
  function lgSideSoon() {
    if (lgRaf || !lgSpot || !window.requestAnimationFrame) return;
    lgRaf = requestAnimationFrame(function () { lgRaf = 0; lgSide(); });
  }
  function lgSide() {
    var card = cards['core:case'];
    if (!lgSpot || !card) return;
    var L = lgSpot.el, b = lgSpot.button, pill = L.querySelector('.gc-lgs__pill'), chip = L.querySelector('.gc-lgs__chip'), cl = L.classList;
    if (!b.offsetHeight) return;
    var br = b.getBoundingClientRect(), cr = card.getBoundingClientRect(), drop = parseFloat(L.style.getPropertyValue('--gc-lgs-drop')) || 0;
    var cx = br.left + br.width / 2, cy = br.top + br.height / 2;
    function boxes(sel) {
      return sel.map(function (s) { return card.querySelector(s); }).filter(function (el) { return el && el.offsetWidth; })
        .map(function (el) { return el.getBoundingClientRect(); });
    }
    /* m: the room kept to the note, the stamp, the tag and the button (4px; the small offer 3px) */
    function fits(t, pw, ph, obst, m) {
      if (cx - pw < cr.left + 2 || cx + pw > cr.right - 2 || t < cr.top + 2 || t + ph > cr.bottom - 2) return false;
      return !obst.some(function (r) { return cx + pw > r.left - m && cx - pw < r.right + m && t + ph > r.top - m && t < r.bottom + m; });
    }
    var note = card.classList.contains('gcls-has-ini') ? [] : ['.gcls-spot__hint'];
    /* the logo inside: the chip on one line (gcls-set.css .gcls-lgs-cbare, .gcls-lgs-ctiny), and clear of the note
       (its pencil only while the chip would touch it; the offer's own way is measured again when it comes back) */
    if (chip && chip.offsetHeight) {
      var cmin = parseFloat(window.getComputedStyle(chip).minHeight) || 0, lv = 0;
      for (; lv < 3; lv++) {
        cl.toggle('gcls-lgs-cbare', lv > 0);
        cl.toggle('gcls-lgs-ctiny', lv > 1);
        if (lv === 2 || chip.offsetHeight <= cmin + 1) break;
      }
      var cw = chip.offsetWidth / 2, ch = chip.offsetHeight / 2;
      card.classList.remove('gcls-lgs-pen'); /* the note measured with its words */
      card.classList.toggle('gcls-lgs-pen', !!note.length && boxes(note).some(function (r) {
        return cx + cw > r.left - 3 && cx - cw < r.right + 3 && cy + ch > r.top - 3 && cy - ch < r.bottom + 3;
      }));
      return;
    }
    if (!pill || !pill.offsetHeight) return;
    var bot = boxes(['.gcls-card__tag', '.gcls-card__cbtn']);
    /* the pill's size in each type (layout sizes: its entry animation moves it, but never sizes it) */
    var size = {};
    function type(tight, bare) {
      cl.toggle('gcls-lgs-tight', tight > 0);
      cl.toggle('gcls-lgs-tiny', tight > 1);
      cl.toggle('gcls-lgs-wrap', tight > 2);
      cl.toggle('gcls-lgs-bare', !!bare);
    }
    function sizeOf(tight, bare) {
      var k = tight + '' + bare;
      if (!size[k]) {
        type(tight, bare);
        var min = parseFloat(window.getComputedStyle(pill).minHeight) || 0;
        size[k] = { w: pill.offsetWidth / 2, h: pill.offsetHeight, one: pill.offsetHeight <= min + 1 };
      }
      return size[k];
    }
    function pick(ways, pen) {
      card.classList.toggle('gcls-lgs-pen', pen);
      var top = boxes(note.concat(['.gcls-spot']));
      for (var i = 0; i < ways.length; i++) {
        var w = ways[i], s = sizeOf(w[0], w[1]), gap = w[0] ? 4 : 6; /* gcls-set.css --gcls-lgs-gap */
        if (!w[0] && !s.one) continue;
        var t = w[2] === 'down' ? br.bottom + gap + drop : w[2] === 'up' ? br.top - gap - drop - s.h : br.top + br.height / 2 - s.h / 2;
        if (fits(t, s.w, s.h, w[2] === 'down' ? bot : w[2] === 'up' ? top : top.concat(bot), w[0] ? 3 : 4)) return w;
      }
      return null;
    }
    var way = pick(LG_WAYS, false) || (note.length && pick(LG_PEN, true)) || LG_WAYS[LG_WAYS.length - 1];
    type(way[0], way[1]);
    cl.toggle('gcls-lgs-down', way[2] === 'down');
    cl.toggle('gcls-lgs-up', way[2] === 'up');
    cl.toggle('gcls-lgs-mark', way[2] === 'mark');
  }
  function lgNewId() { return 'lg' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  /* gc-logo-sync.js leaves a $25 line alone while its case is on the way (the product page's mark, gc_logo_pending) */
  function lgPending(id, on) {
    if (!id) return;
    try {
      var p = JSON.parse(sessionStorage.getItem('gc_logo_pending') || '{}');
      if (on) p[id] = Date.now(); else delete p[id];
      sessionStorage.setItem('gc_logo_pending', JSON.stringify(p));
    } catch (e) {}
  }
  /* the add failed: a $25 line that went in without its case comes straight back out (one request is all or nothing,
     so there should be none; gc-logo-sync.js would take it out too, once its grace has run). A case that did arrive
     keeps its line. */
  function lgBack(id) {
    if (!id) return;
    lgPending(id, false);
    if (!window.fetch) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var fee = null, kept = false;
        ((cart && cart.items) || []).forEach(function (it) {
          var p = it.properties || {};
          if (String(p._logo_link || '') === id) fee = it;
          if (String(p._logo_id || '') === id) kept = true;
        });
        if (!fee || kept) return;
        var x = new XMLHttpRequest();
        x.open('POST', base + 'cart/change.js');
        x.setRequestHeader('Content-Type', 'application/json');
        x.setRequestHeader('Accept', 'application/json');
        x.onloadend = function () { try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {} };
        x.send(JSON.stringify({ id: fee.key, quantity: 0 }));
      })
      .catch(function () {});
  }

  /* ---------- names in the page language, by key ---------- */
  var LNAME = {};
  (D.set.L || []).forEach(function (l) { LNAME[l.k] = l.n; });
  function LN(k) { return LNAME[k] || k || ''; }
  function MN(k) { return (D.set.M && D.set.M[k] && D.set.M[k].n) || k || ''; }
  function CN(k) { return (D.set.C && D.set.C[k] && D.set.C[k].n) || k || ''; }
  function CF(k) { return (D.set.C && D.set.C[k] && D.set.C[k].f) || k || ''; }
  function kindName(k) { return (T.kinds && T.kinds[k]) || (T.kinds && T.kinds.other) || k; }
  function kindMid(k) { return (T.kindsMid && T.kindsMid[k]) || (T.kindsMid && T.kindsMid.other) || kindName(k); }
  /* a piece's own short name: the section's "Piece name" blocks (by product
     id, translated with the page) tell apart two pieces of one kind, e.g.
     "6-slot card holder" and "Glossy card holder"; else the kind's name */
  var NAMES = D.names || {};
  function pName(p) { var x = p && NAMES[String(p.id)]; return (x && x.n) || kindName(p ? p.nk : ''); }
  function pMid(p) { var x = p && NAMES[String(p.id)]; return (x && (x.m || x.n)) || kindMid(p ? p.nk : ''); }

  /* ---------- which products the automatic discount counts ---------- */
  var XIDS = {};
  (D.xids || []).forEach(function (id) { if (id) XIDS[String(id)] = 1; });
  var EXCL = {};
  (D.excluded || []).forEach(function (t) { t = norm(t); if (t) EXCL[t] = 1; });
  var SKIP_TY = { 'add-on': 1, 'reward': 1 };
  /* Bags and backpacks get no gift box (owner, 4 Oct 2026: "Remove Gift packaging $15.00 for Bags,
     backpacks - leave for the other products"). The rule is snippets/gcx-is-bag.liquid's
     window.GC_isBagType(type, title), used when the page prints it; otherwise the same rule here: a
     "Luggage Accessories" type is never a bag (the leather luggage tag keeps its gift box), a type with
     "Luggage & Bags" or "Motorcycle Bags" is one, and else a title with the whole word bag, bags,
     backpack or backpacks. Mirrored in gc-cart-price.js, gc-cart-undo.js, gcls-set.js and
     gcsb-builder.js; keep them in step with the snippet. */
  function isBag(it) {
    var ty = String((it && it.product_type) || ''), ti = String((it && (it.product_title || it.title)) || '');
    if (typeof window.GC_isBagType === 'function') return !!window.GC_isBagType(ty, ti);
    if (/Luggage Accessories/i.test(ty)) return false;
    if (/Luggage & Bags|Luggage &amp; Bags|Motorcycle Bags/i.test(ty)) return true;
    return /(^|[^A-Za-z\u00C0-\u024F])(bags?|backpacks?)(?![A-Za-z\u00C0-\u024F])/i.test(ti);
  }
  /* by product id: the collection's own product ids (Admin API, K.disc);
     without them, the old rule (not an add-on or reward by id or type) */
  function eligId(pid, ty) {
    pid = String(pid);
    if (ELIG) return !!ELIG[pid];
    if (XIDS[pid]) return false;
    return !EXCL[norm(ty)];
  }

  /* ---------- the model: pieces ---------- */
  var ALL = {}, BYPID = {};
  var seq = 0;
  var KIND_OF = { card: 'cardholder' };
  function piece(p, leather) {
    if (!p || !p.v || !p.v.length) return null;
    var v = p.v.map(function (r) {
      return { id: r[0], price: r[1], avail: !!r[2], ck: r[3] || '', mk: r[4] || '', img: r[5] >= 0 ? p.im[r[5]] : '', cn: r[6] || '', mn: r[7] || '' };
    });
    var nocolor = v.length === 1 && !v[0].ck && !v[0].cn;
    var cols = [], seen = {};
    v.forEach(function (x) {
      if (!x.ck || seen[x.ck]) return;
      seen[x.ck] = 1; cols.push({ key: x.ck, val: x.cn || x.ck });
    });
    var o = {
      key: 'p' + (seq++), id: p.id, h: p.h, he: p.he, t: p.t, u: p.u, ty: p.ty,
      kind: KIND_OF[p.k] || p.k || 'other', v: v, colors: cols, nocolor: nocolor, img: p.fi,
      models: v.some(function (x) { return !!x.mk; }),
      leather: leather, rc: +p.rc || 0, rs: +p.rs || 0, cm: +p.cm || 0
    };
    o.nk = o.kind;
    ALL[o.key] = o;
    BYPID[String(p.id)] = o;
    return o;
  }
  var CORE_KINDS = ['case', 'cardholder', 'wallet', 'passport', 'keychain'];
  var SLOTS = ['case', 'second', 'passport', 'keychain'];
  var LEATHERS = {};
  (D.leathers || []).forEach(function (l) {
    var core = {};
    CORE_KINDS.forEach(function (k) { var o = l.core ? piece(l.core[k], l.k) : null; if (o) { o.kind = k; o.nk = k; core[k] = o; } });
    /* a more-piece is named by its kind; a wallet there is any wallet (a money-clip wallet is not a bifold) */
    var extras = (l.extras || []).map(function (p) { var o = piece(p, l.k); if (o && o.kind === 'wallet') o.nk = 'walletany'; return o; }).filter(Boolean);
    LEATHERS[l.k] = { k: l.k, note: l.note, core: core, extras: extras };
  });

  /* ---------- the set product's options (leathers, colors, models) ---------- */
  var SV = D.set.v.map(function (r) {
    return { id: r[0], price: r[1], cmp: r[2], avail: !!r[3], lk: r[4], mk: r[5], ck: r[6], img: r[7] >= 0 ? D.set.im[r[7]] : '', lo: r[8] === 1 };
  });
  var SCOLORS = {};
  SV.forEach(function (v) {
    (SCOLORS[v.lk] = SCOLORS[v.lk] || []);
    if (SCOLORS[v.lk].indexOf(v.ck) === -1) SCOLORS[v.lk].push(v.ck);
  });
  var MORDER = Object.keys(D.set.M || {});
  function colorImg(l, c) {
    var v = SV.filter(function (x) { return x.lk === l && x.ck === c && x.img; });
    return v.length ? v[0].img : '';
  }

  /* ---------- screen protector for the chosen model (by model key) ---------- */
  var PROT = (D.prot || []).map(function (r) { return { id: r[0], price: r[1], cmp: r[2], avail: !!r[3], mk: r[4], img: r[5] }; });
  function protFor(mk) {
    if (!mk) return null;
    var want = D.protBy ? D.protBy[mk] : null;
    for (var i = 0; i < PROT.length; i++) {
      var p = PROT[i];
      if (!p.avail) continue;
      if (want ? p.id === want : p.mk === mk) return p;
    }
    return null;
  }

  /* ---------- a piece's variants (by color family key and model key) ---------- */
  function colorVariants(p, ck) {
    if (p.nocolor) return p.v.slice();
    if (!ck) return [];
    return p.v.filter(function (x) { return x.ck && x.ck === ck; });
  }
  function hasColor(p, ck) {
    if (p.nocolor) return true;
    for (var i = 0; i < p.colors.length; i++) if (p.colors[i].key === ck) return true;
    return false;
  }
  function availIn(p, ck, mk) {
    return colorVariants(p, ck).some(function (x) { return x.avail && (!mk || !p.models || x.mk === mk); });
  }
  function colorLabel(p, ck) {
    for (var i = 0; i < p.colors.length; i++) if (p.colors[i].key === ck) return p.colors[i].val;
    return ck ? CN(ck) : '';
  }
  /* the variant for a color (and model, for a case); a case without a model
     yet: its lowest price in that color, marked "from" */
  function pickV(p, ck, mk) {
    var ls = colorVariants(p, ck);
    if (!ls.length) return null;
    if (p.models) {
      if (mk) return ls.filter(function (x) { return x.mk === mk; })[0] || null;
      var av = ls.filter(function (x) { return x.avail; });
      var pool = av.length ? av : ls;
      return pool.slice().sort(function (a, b) { return a.price - b.price; })[0];
    }
    return ls.filter(function (x) { return x.avail; })[0] || ls[0];
  }
  /* the color to offer instead: the nearest color (in the piece's own order)
     that is in stock, for the chosen model when it is a case */
  function altColor(p, ck, mk) {
    var cols = p.colors, at = -1, best = '', bd = 1e9;
    for (var i = 0; i < cols.length; i++) if (cols[i].key === ck) at = i;
    cols.forEach(function (c, i) {
      if (c.key === ck || !availIn(p, c.key, mk)) return;
      var d = at < 0 ? i : Math.abs(i - at);
      if (d < bd) { bd = d; best = c.key; }
    });
    return best;
  }
  function firstAvail(p) {
    var c = p.colors.filter(function (c) { return availIn(p, c.key); })[0];
    return c ? c.key : (p.colors[0] ? p.colors[0].key : '');
  }

  /* ---------- state ---------- */
  var S = {
    leather: '', color: '', device: '',
    pick: 'cardholder',   /* the second core piece: card holder or wallet */
    off: {},              /* core slot -> true when the shopper left it out */
    dq: {},               /* core slot -> true: left out of the page's no-choice set (D.set.defOff), no gap drawn */
    pc: {},               /* piece kind -> color family chosen for that piece */
    ex: {},               /* more-piece key -> { col } for pieces that are on */
    ini: '', gift: false, prio: false, prot: false, logo: false,
    view: 'set', cart: null, busy: false, touched: false
  };
  function L() { return LEATHERS[S.leather] || { core: {}, extras: [] }; }
  function FAM() { return CF(S.color); }
  function secondKind(l) {
    l = l || L();
    if (l.core[S.pick]) return S.pick;
    return l.core.cardholder ? 'cardholder' : (l.core.wallet ? 'wallet' : '');
  }
  function kindOf(slot, l) { return slot === 'second' ? secondKind(l) : slot; }
  function colOf(kind) { return S.pc[kind] || FAM(); }

  /* Everything the page shows is derived here, once per change. */
  var memo = null;
  function cur() {
    if (memo) return memo;
    var l = L();
    var o = { l: l };
    o.core = [];
    SLOTS.forEach(function (slot) {
      var kind = kindOf(slot, l), p = kind ? l.core[kind] : null;
      if (!p) return;
      var ck = colOf(kind);
      var mk = kind === 'case' ? S.device : '';
      var v = null, why = '', from = false;
      if (!hasColor(p, ck)) why = 'notMade';
      else {
        v = pickV(p, ck, mk);
        if (!v) why = p.models && mk ? 'noModel' : 'notMade';
        else if (p.models && !mk) { from = true; if (!availIn(p, ck)) why = 'soldOut'; }
        else if (!v.avail) why = 'soldOut';
      }
      var alt = why ? altColor(p, ck, mk) : '';
      o.core.push({ slot: slot, kind: kind, p: p, ck: ck, v: v, from: from, why: why, alt: alt, on: !why && !S.off[slot] });
    });
    o.extras = [];
    Object.keys(S.ex).forEach(function (key) {
      var p = ALL[key];
      if (!p || p.leather !== S.leather) return;
      var col = S.ex[key].col && hasColor(p, S.ex[key].col) ? S.ex[key].col : defaultCol(p);
      var v = pickV(p, col);
      o.extras.push({ kind: p.kind, p: p, v: v, ck: col, ok: !!(v && v.avail), extra: true });
    });
    o.caseRow = o.core.filter(function (c) { return c.kind === 'case'; })[0] || null;
    o.items = o.core.filter(function (c) { return c.on && c.v; }).concat(o.extras.filter(function (x) { return x.ok; }));
    o.prot = protFor(S.device);
    o.needModel = !!(o.caseRow && o.caseRow.on && !S.device);
    memo = o;
    return o;
  }
  /* a more-piece's color: the set's own when it is made and in stock, else the first in stock */
  function defaultCol(p) {
    var ck = FAM();
    return hasColor(p, ck) && availIn(p, ck) ? ck : firstAvail(p);
  }
  function changed() { memo = null; }
  function caseOn() { var o = cur(); return !!(o.caseRow && o.caseRow.on); }
  function needsModel() { return cur().needModel; }

  /* ---------- fees: tiers by fee variant id (Liquid), never by title ---------- */
  var FEES = (D.fee || []).filter(function (x) { return x.max > 0; }).sort(function (a, b) { return a.max - b.max; });
  /* the longest engraving the ladder covers (8 since Oct 2026) */
  var MAXC = FEES.length ? FEES[FEES.length - 1].max : 5;
  function iniInfo(s) {
    var g = G();
    if (g && g.cleanInfo) return g.cleanInfo(s);
    var up = String(s || '').toUpperCase(), kept = up.replace(/[^A-Z0-9]/g, '');
    return { value: kept.slice(0, MAXC), dropped: up.replace(/\s+/g, '').length !== kept.length };
  }
  function cleanIni(s) { return iniInfo(s).value; }
  function feeFor(ini) {
    var n = cleanIni(ini).length;
    if (!n || !FEES.length) return null;
    for (var i = 0; i < FEES.length; i++) if (n <= FEES[i].max) return FEES[i];
    return FEES[FEES.length - 1];
  }

  /* ---------- the cart: what checkout will count ---------- */
  var lastRead = 0;
  function readCartSoft() { if (Date.now() - lastRead > 1500) readCart(); }
  function readCart() {
    lastRead = Date.now();
    return fetch(D.cartJsUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var giftable = 0, units = [], giftLine = null, prioLine = null;
        (c.items || []).forEach(function (it) {
          if (D.gift && it.variant_id === D.gift.id) { giftLine = it; return; }
          if (D.prio && it.variant_id === D.prio.id) { prioLine = it; return; }
          var pid = String(it.product_id), ty = norm(it.product_type);
          if (!XIDS[pid] && !SKIP_TY[ty] && !isBag(it)) giftable += it.quantity;
          var price = it.original_price != null ? it.original_price : it.price;
          for (var i = 0; i < it.quantity; i++) units.push({ pid: pid, ty: ty, price: price, here: false });
        });
        S.cart = {
          orig: c.original_total_price != null ? c.original_total_price : c.total_price,
          giftable: giftable, units: units, giftLine: giftLine, prioLine: prioLine,
          elig: units.filter(function (u) { return eligId(u.pid, u.ty); }).length
        };
        changed();
        renderStage();
        renderSummary();
      })
      .catch(function () {});
  }

  /* ---------- the automatic discounts, as checkout applies them ---------- */
  /* buy X, get Y: the cheapest "get" items that leave `buy` other "buy" items */
  function bxSave(rule, all) {
    var gets = all.filter(function (u) { return rule.g[u.pid]; }).sort(function (a, b) { return a.price - b.price; });
    var chosen = [];
    var uses = rule.lim > 0 ? rule.lim : 99;
    for (var i = 0; i < gets.length && chosen.length < rule.get * uses; i++) {
      chosen.push(gets[i]);
      var buys = all.filter(function (u) { return rule.b[u.pid] && chosen.indexOf(u) === -1; }).length;
      if (buys < rule.buy * Math.ceil(chosen.length / rule.get)) chosen.pop();
    }
    if (chosen.length < rule.get) return null;
    var save = 0, here = 0, hereUnits = [];
    chosen.forEach(function (u) {
      var s = Math.round(u.price * rule.pct / 100);
      save += s;
      if (u.here) { here += s; hereUnits.push(u); }
    });
    return { rule: rule, save: save, here: here, units: hereUnits };
  }
  function discountFor(units) {
    var cartUnits = (S.cart && S.cart.units) || [];
    var all = cartUnits.concat(units);
    var e = all.filter(function (u) { return eligId(u.pid, u.ty); });
    var eHere = units.filter(function (u) { return eligId(u.pid, u.ty); });
    var r = { kind: '', here: 0, all: 0, eligN: e.length, eligHere: eHere.length, need: Math.max(0, MIN - e.length), units: [] };
    var pctOn = RATE > 0 && e.length >= MIN;
    var pctAll = 0, pctHere = 0;
    if (pctOn) {
      e.forEach(function (u) { var s = Math.round(u.price * RATE / 100); pctAll += s; if (u.here) { pctHere += s; u.cut = s; } });
    }
    var best = null;
    BX.forEach(function (rule) { var b = bxSave(rule, all); if (b && (!best || b.save > best.save)) best = b; });
    if (best && best.save > pctAll) {
      r.kind = 'bx'; r.all = best.save; r.here = best.here; r.bx = best; r.units = best.units;
      units.forEach(function (u) { u.cut = 0; });
      best.units.forEach(function (u) { u.cut = Math.round(u.price * best.rule.pct / 100); });
    } else if (pctOn) {
      r.kind = 'pct'; r.all = pctAll; r.here = pctHere;
    } else units.forEach(function (u) { u.cut = 0; });
    return r;
  }

  /* ---------- totals: what checkout will charge for this addition ---------- */
  function totals() {
    var o = cur();
    var t = { list: 0, disc: 0, fees: 0, gift: 0, prio: 0, protP: 0, units: 0 };
    var units = o.items.map(function (it) { return { pid: String(it.p.id), ty: norm(it.p.ty), price: it.v.price, here: true, it: it }; });
    var prot = S.prot && o.prot && o.items.length ? o.prot : null;
    if (prot) units.push({ pid: String(D.protId), ty: '', price: prot.price, here: true, prot: true });
    var d = discountFor(units);
    t.d = d;
    t.U = units;
    t.units = units.length;
    units.forEach(function (u) { t.list += u.price; if (u.prot) t.protP = u.price; });
    t.pieces = units.filter(function (u) { return !u.prot; });
    t.piecesList = t.pieces.reduce(function (a, u) { return a + u.price; }, 0);
    t.piecesCut = t.pieces.reduce(function (a, u) { return a + (u.cut || 0); }, 0);
    t.disc = d.here;
    t.prot = prot;
    var fee = caseOn() ? feeFor(S.ini) : null;
    t.fee = fee;
    if (fee) t.fees = fee.p;
    var cart = S.cart || { giftable: 0 };
    var giftForced = !!(cart.giftLine && D.gift);
    t.giftForced = giftForced;
    if (D.gift && (S.gift || giftForced) && t.units) {
      t.giftUnits = giftForced ? t.units : t.units + (cart.giftable || 0);
      t.gift = D.gift.p * t.giftUnits;
    }
    if (D.prio && S.prio && !cart.prioLine && t.units) t.prio = D.prio.p;
    /* the Minimalist logo: its own $25 on the set's case, outside the set discount (Oct 2026) */
    t.logo = logoOn() ? LG.p : 0;
    t.total = t.list - t.disc + t.fees + t.gift + t.prio + t.logo;
    t.basis = (cart.orig || 0) + t.list + t.fees + t.gift + t.prio + t.logo;
    return t;
  }

  /* ---------- elements ---------- */
  var elCore = q('[data-gcls-core]');
  var elMore = q('[data-gcls-more]');
  var elMoreWrap = q('[data-gcls-morewrap]');
  var elColors = q('[data-gcls-colors]');
  var elDevBtn = q('[data-gcls-devbtn]');
  var elPop = q('[data-gcls-pop]');
  var elDevList = q('[data-gcls-devlist]');
  var elIni = q('[data-gcls-ini]');
  /* the field on the picture (the stamp spot's twin of elIni, owner 1 Oct 2026) */
  var elEd = q('[data-gcls-ed]'), elEdIn = q('[data-gcls-ed-in]'), elEdN = q('[data-gcls-ed-n]'), elEdOk = q('[data-gcls-ed-ok]');
  var edOpen = false;
  var elAdd = q('[data-gcls-add]');
  var elMsg = q('[data-gcls-msg]');
  var elComp = q('[data-gcls-comp]');
  var elGallery = q('[data-gcls-gallery]');
  var elStage = q('[data-gcls-stage]');
  var elPhotos = q('[data-gcls-photos]');
  var elPhTrack = q('[data-gcls-phtrack]');
  var elThumbs = q('[data-gcls-thumbs]');
  var elCpop = q('[data-gcls-cpop]');

  function whyText(c, mid) {
    var col = colorLabel(c.p, c.ck);
    if (c.why === 'noModel') return tpl(mid ? T.notMadeMid : T.notMade, { color: MN(S.device) });
    if (c.why === 'notMade') return tpl(mid ? T.notMadeMid : T.notMade, { color: col });
    return tpl(mid ? T.soldOutInMid : T.soldOutIn, { color: col });
  }
  var CHECK_SVG = '<svg class="gc-addon-check__plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5.4V18.6"/><path d="M5.4 12h13.2"/></svg>' +
    '<svg class="gc-addon-check__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.6 9.6 17.2 19 7.8"/></svg>';
  var CARET_SVG = '<svg class="gcls-cchip__caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" stroke="currentColor" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* A color's look in a small round dot (the card's color button, a row's
     color chip, the one-tap color): the piece's own photo in that color (the
     PDP round-swatch recipe) as a tiny image, 48px (72px on 3x screens), the
     same URLs the server draws (sections/gcls-set.liquid), so a dot the
     server drew is never swapped. Until its photo is in, a dot is a quiet
     skeleton (gcls-set.css); owner, 30 Sep 2026: never a flat color that
     then turns into a photo. UX images: alt="" and no SEO role. */
  function baseU(u) { return String(u || '').split('?')[0].replace(/^https?:/, ''); }
  function thumbSrc(u) { return sized(u, 72); }
  function thumbSet(u) { return sized(u, 48) + ' 48w, ' + sized(u, 72) + ' 72w'; }
  function thumbImg(u, px) { return '<img src="' + esc(thumbSrc(u)) + '" srcset="' + esc(thumbSet(u)) + '" sizes="' + px + 'px" width="' + px + '" height="' + px + '" alt="" decoding="async">'; }
  function dotHTML(cls, p, ck, px) {
    var u = colorPhoto(p, ck);
    return '<span class="' + cls + '">' + (u ? thumbImg(u, px) : '') + '</span>';
  }
  /* dots drawn in a batch (rows, the "more" cards, a gap's one-tap color, the
     pop-up): a photo the browser already has (memory or disk cache) paints at
     once, no skeleton; only one still not in after a moment gets the skeleton
     and fades in (GCLSL.dot, snippets/gcls-layout) */
  function graceDot(im) { if (window.GCLSL && window.GCLSL.dot) window.GCLSL.dot(im); }
  function settleDots(el) {
    if (!el) return;
    qa('.gcls-cchip__dot > img, .gcls-alt__dot > img, .gcls-cpop__dot > img, .gcls-card__cdot > img', el).forEach(graceDot);
  }
  /* ---- a card's photo and its color dot change in the same frame ----
     Owner, 4 Oct 2026: the case card's dot still showed the old color for seconds after the photo had changed
     (its small image came last, at low priority). Every image one render pass gives a card (its photo,
     setImg; its dot, setDot) joins the card's group with what to do once it is in; the group commits them all
     in one animation frame once every image is loaded and decoded (the dot at most 1.2 s after the photo). */
  function inP(im) {
    return new Promise(function (r) {
      function go() { if (im.decode) im.decode().then(r, r); else r(); }
      if (im.complete) { go(); return; }
      function f() { im.removeEventListener('load', f); im.removeEventListener('error', f); go(); }
      im.addEventListener('load', f); im.addEventListener('error', f);
    });
  }
  function swapJoin(card, im, commit, lead) {
    if (!window.Promise) {
      var f0 = function () { requestAnimationFrame(commit); };
      if (im.complete) f0(); else { im.addEventListener('load', f0); im.addEventListener('error', f0); }
      return;
    }
    var g = card && card._gclsSw;
    if (!g || g.sealed) {
      g = { ps: [], fns: [], lead: null, sealed: false };
      if (card) card._gclsSw = g;
      Promise.resolve().then(function () {
        g.sealed = true;
        var all = Promise.all(g.ps);
        var cap = g.lead ? g.lead.then(function () { return new Promise(function (r) { setTimeout(r, 1200); }); }) : all;
        Promise.race([all, cap]).then(function () { requestAnimationFrame(function () { g.fns.forEach(function (f) { f(); }); }); });
      });
    }
    var pr = inP(im);
    g.ps.push(pr); g.fns.push(commit);
    if (lead) g.lead = pr;
  }
  /* a dot's image: the card's own photo when the dot shows that very file (its src, srcset and sizes: the
     browser picks the same file, so one download serves both and they paint in the same frame), else a small one */
  function dotImg(u, card) {
    var fi = card ? qa('[data-gcls-frame] img', card).pop() : null, want = card ? card.getAttribute('data-want') : '';
    if (fi && want && baseU(want) === baseU(u) && baseU(card._gclsPic || want) === baseU(want) && fi.getAttribute('srcset')) {
      var im = document.createElement('img');
      im.setAttribute('src', fi.getAttribute('src') || want);
      im.setAttribute('srcset', fi.getAttribute('srcset'));
      im.setAttribute('sizes', fi.getAttribute('sizes') || '');
      im.width = 24; im.height = 24; im.alt = ''; im.decoding = 'async';
      im._gclsSame = true;
      return im;
    }
    var tmp = document.createElement('span');
    tmp.innerHTML = thumbImg(u, 24);
    return tmp.firstChild;
  }
  /* a card's color button: its dot shows the piece in color ck. A dot that
     already shows a photo of this piece in this color stays (the server's
     first paint); a new color comes in with the card's new photo, in the
     same frame (swapJoin), the old photo staying until then (no blank, no
     flat color). A deep link's first draw (hidden): the new dot replaces the
     old one at once and the picture is shown once it is in (reveal). */
  function setDot(d, p, ck) {
    if (!d) return;
    if (d.hasAttribute('style')) d.removeAttribute('style');
    var vs = colorVariants(p, ck).filter(function (x) { return x.img; });
    var ims = qa('img', d), top = ims[ims.length - 1];
    if (!vs.length) { ims.forEach(function (im) { im.remove(); }); d.classList.remove('is-loading'); return; }
    if (top && vs.some(function (x) { return baseU(x.img) === baseU(top.getAttribute('src')); })) return;
    var u = vs[0].img, tok = d._gclsTok = (d._gclsTok || 0) + 1;
    var card = d.closest ? d.closest('.gcls-card') : null;
    var n = dotImg(u, card);
    if (n._gclsSame) d.setAttribute('data-gcls-same', ''); else d.removeAttribute('data-gcls-same');
    d.classList.remove('is-instant');
    if (card && elComp && elComp.contains(card) && elComp.classList.contains('is-pending')) {
      ims.forEach(function (im) { im.remove(); });
      d.classList.remove('is-loading'); d.classList.add('is-instant');
      d.appendChild(n);
      pend.imgs.push(n);
      return;
    }
    if (!top) { d.appendChild(n); if (!n._gclsSame) graceDot(n); return; }
    var instant = !!(n.complete && n.naturalWidth);
    n.classList.add('is-next');
    d.appendChild(n);
    swapJoin(card, n, function () {
      if (d._gclsTok !== tok) { if (n.parentNode) n.remove(); return; }
      if (instant) d.classList.add('is-instant');
      n.classList.remove('is-next');
      d.classList.remove('is-loading');
      if (instant) { qa('img', d).forEach(function (im) { if (im !== n) im.remove(); }); return; }
      setTimeout(function () { if (d._gclsTok === tok) qa('img', d).forEach(function (im) { if (im !== n) im.remove(); }); }, REDUCED ? 0 : 260);
    });
  }
  function pieceImg(c) {
    /* a case without a model yet: the photo of its newest model in that color (the first listed), never an older one */
    if (c.v && c.v.img && !(c.from && c.p.models)) return c.v.img;
    var vv = colorVariants(c.p, c.ck).filter(function (x) { return x.img; })[0];
    return vv ? vv.img : c.p.img;
  }

  /* ---------- rendering: leather, model, color ---------- */
  function renderLeathers() {
    qa('[data-gcls-leather]').forEach(function (b) {
      var on = b.getAttribute('data-gcls-leather') === S.leather;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    setText('[data-gcls-leathername]', LN(S.leather));
    var note = q('[data-gcls-leathernote]');
    if (note) {
      /* the text sits in its own span; the hidden copies of every leather's note beside it keep the height */
      var nt = q('[data-gcls-notetext]', note);
      if (!note.hasAttribute('data-base')) note.setAttribute('data-base', (nt || note).textContent);
      setText(nt || note, join2(L().note, note.getAttribute('data-base')));
    }
  }
  /* a color of the main picker is "out" only when no core piece of this
     leather is in stock in it (for the chosen model, for the case) */
  function colorAnyAvail(c) {
    var l = L(), fam = CF(c);
    return CORE_KINDS.some(function (k) { var p = l.core[k]; return p && availIn(p, fam, k === 'case' ? S.device : ''); });
  }
  function renderColors() {
    var cols = SCOLORS[S.leather] || [];
    var h = '';
    cols.forEach(function (c) {
      var on = c === S.color;
      var any = colorAnyAvail(c);
      var img = colorImg(S.leather, c);
      var lab = any ? CN(c) : tpl(T.reasonItem, { piece: CN(c), why: T.soldOut });
      h += '<span class="ProductForm__ColorSwatchWrapper gcls-sw' + (any ? '' : ' is-out') + '" role="presentation">' +
        '<span class="ProductForm__ColorSwatch" role="radio" tabindex="' + (on ? 0 : -1) + '" aria-checked="' + on + '" aria-pressed="' + on + '" aria-label="' + esc(lab) + '" title="' + esc(lab) + '" data-value="' + esc(CN(c)) + '" data-gcls-color="' + esc(c) + '" style="border: 2px solid ' + (on ? '#000' : '#ddd') + ';">' +
        (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" width="60" height="60" loading="lazy" decoding="async">' : '') + '</span>' +
        (on ? '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" class="checkmark"><circle cx="10" cy="10" r="10" fill="#1c1b1b"/><path d="M6 10l3 3 5-6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') +
        '</span>';
    });
    setHTML(elColors, h);
    /* mixed colors: the label names the main color; the pieces say their own */
    setText('[data-gcls-colorname]', CN(S.color));
    var note = q('[data-gcls-colornote]');
    if (note) note.hidden = true;
  }

  /* the case's first color (its own order, burgundy first) that is in stock for model mk */
  function caseColorFor(p, mk) {
    var c = p.colors.filter(function (x) { return availIn(p, x.key, mk); })[0];
    return c ? c.key : '';
  }
  function seriesOf(mk) { var m = D.set.M && D.set.M[mk]; return m && m.s ? m.s : 0; }
  /* The model list: the case's own variants in the case's color, in the
     set product's model order, at the case's own price. Updated in place
     when only the selection changed (gc-mobile-sticky.js reads the click). */
  var devSig = '';
  function caseModels() {
    var p = L().core['case'];
    if (!p) return [];
    var ck = colOf('case');
    var ls = colorVariants(p, ck).filter(function (x) { return x.mk; });
    return ls.slice().sort(function (a, b) {
      var ia = MORDER.indexOf(a.mk), ib = MORDER.indexOf(b.mk);
      return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
    });
  }
  function renderDevices() {
    var ls = caseModels();
    var sig = S.leather + '|' + colOf('case') + '|' + ls.map(function (v) { return v.id + (v.avail ? 'a' : 'x'); }).join(',');
    if (sig === devSig && elDevList.querySelector('[data-gcls-dev]')) {
      qa('[data-gcls-dev]', elDevList).forEach(function (b) {
        var on = !!S.device && b.getAttribute('data-gcls-dev') === S.device;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    } else {
      var h = '', last = '', cp = L().core['case'], cck = colOf('case');
      ls.forEach(function (v) {
        var ser = seriesOf(v.mk);
        if (!ser) { var m = /(\d+)/.exec(MN(v.mk) || v.mn); ser = m ? +m[1] : 0; }
        if (ser && ser !== last) { h += '<div class="gc-popover-group" aria-hidden="true">' + esc(tpl(T.series || 'iPhone [n] series', { n: ser })) + '</div>'; last = ser; }
        var sel = !!S.device && S.device === v.mk;
        var nm = D.set.M && D.set.M[v.mk] ? MN(v.mk) : (v.mn || v.mk);
        /* sold out in the case's color but made in another: not "Sold out" (owner, 1 Oct 2026: the
           Leather Set opened on Croco Brown, the only color with the whole set in stock, and the list
           read as if croco cases for iPhone 14-17 were sold out). The row says which color is out,
           shows the price, and choosing it moves the case to its first color in stock for that model (setDevice). */
        var alt = !v.avail && cp ? caseColorFor(cp, v.mk) : '';
        var av = alt ? pickV(cp, alt, v.mk) : null;
        h += '<button type="button" role="option" class="Popover__Value Heading Link Link--primary u-h6' + (sel ? ' is-selected' : '') + (v.avail ? '' : av ? ' is-other' : ' is-soldout') + '" aria-selected="' + (sel ? 'true' : 'false') + '" data-value="' + esc(nm) + '" data-action="select-value" data-series="' + ser + '" data-gcls-dev="' + esc(v.mk) + '">' +
          '<span class="gcls-pv__name">' + esc(nm) + (av ? '<span class="gcls-pv__note">' + esc(tpl(T.soldOutIn, { color: colorLabel(cp, cck) })) + '</span>' : '') + '</span>' +
          '<span class="gcls-pv__price">' + esc(v.avail ? money(v.price) : av ? money(av.price) : T.soldOut) + '</span></button>';
      });
      setHTML(elDevList, h);
      devSig = sig;
    }
    elDevList.setAttribute('data-gc-grouped', '1');
    var val = q('[data-gcls-devval]');
    setText(val, S.device ? MN(S.device) : T.devicePh);
    if (val) val.classList.toggle('is-placeholder', !S.device);
    var nb = q('[data-gcls-new]');
    if (nb) nb.hidden = !(S.device && D.set.newSeries && seriesOf(S.device) === +D.set.newSeries);
    var dev = q('[data-gcls-deviceslab]') || q('[data-gcls-deviceopt]');
    if (dev) dev.hidden = !L().core['case'];
  }
  function renderSteps() {
    var n = 0;
    qa('[data-gcls-step]').forEach(function (st) {
      if (st.hidden) return;
      n++;
      setText(q('[data-gcls-stepn]', st), num(n));
      setText(q('[data-gcls-stepsr]', st), num(n) + '. ');
    });
  }

  /* ---------- rendering: the pieces (PDP add-on rows) ---------- */
  function colorChip(kind, p, ck, key) {
    if (!p || p.nocolor || p.colors.length < 2) return '';
    var attr = key ? 'data-gcls-cbtn-ex="' + key + '"' : 'data-gcls-cbtn="' + kind + '"';
    return '<button type="button" class="gcls-cchip" ' + attr + ' aria-haspopup="dialog" aria-expanded="false" aria-label="' + esc(tpl(T.changeColor, { piece: pMid(p) })) + '">' +
      dotHTML('gcls-cchip__dot', p, ck, 18) + '<span class="gcls-cchip__name">' + esc(colorLabel(p, ck)) + '</span>' + CARET_SVG + '</button>';
  }
  function coreRowHTML(c) {
    var o = cur(), l = o.l;
    var title = pName(c.p);
    var sub = '';
    if (c.kind === 'case' && S.device) sub = MN(S.device);
    var price = '';
    if (c.v && !c.why) price = c.from ? tpl(T.fromPriceLc, { price: money(c.v.price, true) }) : money(c.v.price, true);
    var seg = '';
    if (c.slot === 'second' && l.core.cardholder && l.core.wallet) {
      seg = '<div class="gcls-seg" role="radiogroup" aria-label="' + esc(T.second) + '">';
      ['cardholder', 'wallet'].forEach(function (k) {
        var p = l.core[k], on = c.kind === k, ck = colOf(k);
        var v = pickV(p, ck) || pickV(p, firstAvail(p));
        seg += '<button type="button" role="radio" class="gcls-seg__opt" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-gcls-pick="' + k + '"><span>' + esc(kindName(k)) + '</span>' + (v ? '<b>' + esc(money(v.price, true)) + '</b>' : '') + '</button>';
      });
      seg += '</div>';
    }
    var na = '';
    if (c.why) {
      na = '<p class="gcls-row__na"><span>' + esc(whyText(c)) + '</span>' +
        (c.alt ? ' <button type="button" class="gcls-alt" data-gcls-alt="' + c.kind + ':' + esc(c.alt) + '">' + dotHTML('gcls-alt__dot', c.p, c.alt, 18) + esc(tpl(T.batchPick || '[color]', { color: colorLabel(c.p, c.alt) })) + '</button>' : '') + '</p>';
    }
    var h = '<div class="gc-sp-addon gcls-row gcls-row--core' + (c.on ? ' is-on' : ' is-off') + (c.why ? ' is-na' : '') + '" data-gcls-slot="' + c.slot + '">';
    h += '<div class="gc-sp-addon__inner" data-gcls-rowtap>';
    h += '<span class="gcls-row__img" style="background-image:url(\'' + esc(sized(pieceImg(c), 160)) + '\')" aria-hidden="true"></span>';
    /* the color chip sits under the piece's name, inside its row, in every row (owner, 29 Sep 2026) */
    h += '<span class="gcls-row__info"><span class="gcls-row__title">' + esc(title) + '</span>' + (sub ? '<span class="gcls-row__sub">' + esc(sub) + '</span>' : '') + colorChip(c.kind, c.p, c.ck) + '</span>';
    h += '<span class="gcls-row__price">' + esc(price) + '</span>';
    h += '<button type="button" class="gc-addon-check" role="checkbox" aria-checked="' + (c.on ? 'true' : 'false') + '" aria-label="' + esc(tpl(T.include, { piece: pMid(c.p) })) + '" data-gcls-core-check="' + c.slot + '"' + (c.why ? ' aria-disabled="true" tabindex="-1"' : '') + '>' + CHECK_SVG + '</button>';
    h += '</div>';
    h += '<div class="gcls-row__opts">' + seg + '</div>';
    h += na;
    return h + '</div>';
  }
  function renderPieces() {
    var o = cur();
    var focusSel = keepFocus(['data-gcls-core-check', 'data-gcls-pick', 'data-gcls-cbtn', 'data-gcls-alt', 'data-gcls-more-add', 'data-gcls-cbtn-ex']);
    setHTML(elCore, o.core.map(coreRowHTML).join(''));
    settleDots(elCore);
    renderMore();
    restoreFocus(focusSel);
  }
  function keepFocus(attrs) {
    var a = document.activeElement;
    if (!a || !root.contains(a)) return null;
    for (var i = 0; i < attrs.length; i++) if (a.hasAttribute(attrs[i])) return '[' + attrs[i] + '="' + a.getAttribute(attrs[i]) + '"]';
    return null;
  }
  function restoreFocus(sel) {
    if (!sel) return;
    var el = q(sel);
    if (el && el !== document.activeElement) try { el.focus({ preventScroll: true }); } catch (e) {}
  }

  /* MORE pieces made in this leather (gcls-more): the card holder or wallet
     the set does not use, then every piece of the leather's extras list
     that is in stock; the ones in stock in the set's color first, then by
     price. Each one goes in as its own line of the same set. */
  function morePieces() {
    var l = L(), o = cur(), out = [];
    var sk = secondKind(l);
    ['cardholder', 'wallet'].forEach(function (k) { if (k !== sk && l.core[k]) out.push({ p: l.core[k], alt: true }); });
    var rest = (l.extras || []).filter(function (p) { return p.v.some(function (x) { return x.avail; }); });
    var fam = FAM();
    rest.sort(function (a, b) {
      var ia = availIn(a, fam) ? 0 : 1, ib = availIn(b, fam) ? 0 : 1;
      if (ia !== ib) return ia - ib;
      var pa = (pickV(a, defaultCol(a)) || {}).price || 0, pb = (pickV(b, defaultCol(b)) || {}).price || 0;
      return pa - pb;
    });
    rest.forEach(function (p) { out.push({ p: p }); });
    return out;
  }
  function renderMore() {
    if (!elMore) return;
    var o = cur(), ls = morePieces();
    if (elMoreWrap) elMoreWrap.hidden = !ls.length;
    setText('[data-gcls-morelabel]', tpl(T.moreLabel, { leather: LN(S.leather) }));
    var h = '';
    /* every card has the same fixed structure (image, the short name on up
       to two lines, the price, the Add button across the card), and a slot
       under it that is always there, empty until the piece is added: its
       color, or why it is out. The product's own long title is the button's
       tooltip and part of its name for screen readers. */
    ls.forEach(function (m) {
      var p = m.p, e = S.ex[p.key], on = !!e;
      var x = on ? o.extras.filter(function (z) { return z.p === p; })[0] : null;
      var col = x ? x.ck : defaultCol(p);
      var v = pickV(p, col);
      var ok = !!(v && v.avail);
      var img = v && v.img ? v.img : p.img;
      var slot = on ? colorChip(p.nk, p, col, p.key) + (!ok ? '<span class="gcls-mc__na">' + esc(tpl(T.soldOutIn, { color: colorLabel(p, col) })) + '</span>' : '') : '';
      h += '<div class="gcls-mc' + (on && ok ? ' is-on' : '') + '" role="listitem">' +
        '<button type="button" class="gcls-mc__main" aria-pressed="' + (on && ok ? 'true' : 'false') + '" data-gcls-more-add="' + p.key + '"' + (ok || on ? '' : ' aria-disabled="true"') + ' aria-label="' + esc(tpl(T.include, { piece: pMid(p) }) + ' — ' + p.t) + '" title="' + esc(p.t) + '">' +
        '<span class="gcls-mc__img"><img src="' + esc(sized(img, 300)) + '" alt="" width="150" height="150" loading="lazy" decoding="async"></span>' +
        '<span class="gcls-mc__name">' + esc(pName(p)) + '</span>' +
        '<span class="gcls-mc__row"><bdi class="gcls-mc__price">' + esc(v ? money(v.price, true) : '') + '</bdi>' +
        '<span class="gcls-mc__pill">' + (on && ok ? CHECK_SVG.split('</svg>')[1] + '</svg>' : '') + '<span>' + esc(on && ok ? T.inSet : T.addPiece) + '</span></span></span>' +
        '</button>' +
        '<div class="gcls-mc__opt">' + slot + '</div>' +
        '</div>';
    });
    setHTML(elMore, h);
    settleDots(elMore);
  }

  /* ---------- rendering: initials ---------- */
  function renderInitials() {
    if (!elIni) return;
    var on = caseOn() && FEES.length > 0;
    elIni.disabled = !on;
    var off = q('[data-gcls-inioff]'), note = q('[data-gcls-ininote]'), hint = q('[data-gcls-inihint]'), fin = q('[data-gcls-inifinal]');
    if (off) off.hidden = on;
    if (note) note.hidden = !on;
    if (hint) hint.hidden = !on;
    if (fin) fin.hidden = !(on && cleanIni(S.ini));
    if (elIni.value !== S.ini && document.activeElement !== elIni) elIni.value = S.ini;
    if (elEdIn && elEdIn.value !== S.ini && document.activeElement !== elEdIn) elEdIn.value = S.ini;
    renderEdN();
  }
  var hintT = 0;
  function latinHint() {
    var el = q('[data-gcls-inirule]');
    if (!el || !T.latinOnly) return;
    if (!el.hasAttribute('data-base')) el.setAttribute('data-base', el.textContent);
    setText(el, T.latinOnly);
    el.classList.add('gcx-hint-on');
    clearTimeout(hintT);
    hintT = setTimeout(function () { setText(el, el.getAttribute('data-base')); el.classList.remove('gcx-hint-on'); }, 3000);
  }

  /* ---------- rendering: add-ons ---------- */
  function setCheck(el, on, disabled) {
    if (!el) return;
    el.setAttribute('aria-checked', on ? 'true' : 'false');
    if (disabled) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled');
  }
  /* The leather's MagSafe piece, offered as the product page offers it
     (sections/main-product): only for a model the screen protector is made
     for (D.protBy: the protector's variants by model key), in the case's
     color, while the case is in the set. It is the same piece as in the MORE
     row (S.ex), so both always agree. */
  function msOffer() {
    var o = cur(), l = o.l, c = o.caseRow;
    if (!S.device || !D.protBy || !D.protBy[S.device] || !c || !c.on) return null;
    var p = (l.extras || []).filter(function (x) { return x.kind === 'magsafe'; })[0];
    if (!p || !hasColor(p, c.ck) || !availIn(p, c.ck)) return null;
    var v = pickV(p, c.ck);
    return v && v.avail ? { p: p, ck: c.ck, v: v } : null;
  }
  function renderAddons(t) {
    var o = cur();
    var mrow = q('[data-gcls-msrow]');
    if (mrow) {
      var m = msOffer();
      mrow.hidden = !m;
      if (m) {
        setText('[data-gcls-mstitle]', pName(m.p));
        setText('[data-gcls-msprice]', money(m.v.price));
        setText('[data-gcls-mssub]', tpl(T.msSub, { color: colorLabel(m.p, m.ck) }));
        var mi = q('[data-gcls-msimg]'), mu = m.v.img ? "url('" + sized(m.v.img, 200) + "')" : '';
        if (mi && mi.style.backgroundImage !== mu) mi.style.backgroundImage = mu;
        var mc = q('[data-gcls-check="ms"]');
        setCheck(mc, !!S.ex[m.p.key], false);
        if (mc) mc.setAttribute('aria-label', pName(m.p));
      }
    }
    var row = q('[data-gcls-protrow]');
    if (row) {
      var p = o.prot;
      row.hidden = !p;
      if (p) {
        setText('[data-gcls-protprice]', money(p.price));
        var c = q('[data-gcls-protcmp]');
        if (c) { setText(c, p.cmp > p.price ? money(p.cmp) : ''); c.hidden = !(p.cmp > p.price); }
        setText('[data-gcls-protsub]', tpl(T.protSub, { device: MN(S.device) }));
        var im = q('[data-gcls-protimg]');
        if (im && p.img) im.style.backgroundImage = "url('" + p.img + "')";
      } else if (S.prot) S.prot = false;
      setCheck(q('[data-gcls-check="prot"]'), !!(p && S.prot), false);
    }
    var cart = S.cart || {};
    var g = q('[data-gcls-check="gift"]');
    if (g) {
      setCheck(g, !!(S.gift || t.giftForced), !!t.giftForced);
      var gsub = q('[data-gcls-giftsub]');
      if (gsub && D.gift) setText(gsub, P(T.giftSubPieces, Math.max(1, t.giftUnits || t.units || 1), { price: money(D.gift.p, true) }));
    }
    /* the Minimalist logo (Oct 2026): offered while the case is in the set and its photo has a logo-free twin; the
       row's picture is that twin, so it shows what the tick does */
    var lr = q('[data-gcls-logorow]');
    if (lr) {
      var lo = lgOffered(), ltw = lo ? lgTwin(lgCaseSrc()) : '', li = q('[data-gcls-logoimg]');
      if (lr.hidden !== !lo) lr.hidden = !lo;
      setCheck(q('[data-gcls-check="logo"]'), logoOn(), false);
      if (li && ltw) { var lbg = "url('" + sized(ltw, 200) + "')"; if (li._gclsBg !== lbg) { li._gclsBg = lbg; li.style.backgroundImage = lbg; } }
    }
    var pr = q('[data-gcls-check="prio"]');
    if (pr) {
      var inBag = !!cart.prioLine;
      setCheck(pr, !!(S.prio || inBag), inBag);
    }
  }

  /* ---------- rendering: the picture ---------- */
  var cards = {};
  var ghosts = {};
  function adoptServerCards() {
    var nx = 0;
    qa('[data-gcls-card]', elComp).forEach(function (c) {
      var k = c.getAttribute('data-gcls-card');
      var slot = k === 'cardholder' || k === 'wallet' ? 'second' : k;
      var key = 'core:' + slot;
      /* a "more" piece the server drew (a ?variant= link's wallet, gcls-set.liquid v_ok): adopted under the key
         readUrl gave that piece (S.ex), tilted as renderStage tilts it; one this page does not show is adopted
         under a key no piece has, so renderStage takes it away (while the picture is still hidden) */
      if (c.hasAttribute('data-gcls-ex')) {
        var ek = Object.keys(S.ex).filter(function (x) { var p = ALL[x]; return p && p.kind === k && p.leather === S.leather && !cards['ex:' + x]; })[0];
        key = ek ? 'ex:' + ek : 'ex:srv' + k;
        c._gclsTilt = ((nx++ % 3) - 1) * 1.8;
      }
      cards[key] = c;
      c._gclsCore = true;
      c.setAttribute('data-kind', k);
      var img = c.querySelector('[data-gcls-frame] img') || c.querySelector('img');
      if (img) c.setAttribute('data-want', sized(img.getAttribute('src'), k === 'case' ? 900 : 720));
      if (img) cardBox(c, img.getAttribute('src'));
    });
    /* the gaps the server drew for a ?variant= link (the passport holder and the keychain left out) */
    qa('[data-gcls-ghost]', elComp).forEach(function (g) {
      var k = g.getAttribute('data-gcls-ghost');
      ghosts['core:' + k] = g;
      g._gclsCore = true; g._gclsKind = k; g._gclsSlot = null;
    });
  }
  function place(el, s) {
    el._gclsSlot = el._gclsBase = s;
    el.style.setProperty('--r', s[4] + 'deg');
    hug(el);
  }
  /* ---- every piece's own cutout ----
     The card hugs its piece. The piece's box in its photo (width, height and
     center as fractions of the photo) is MEASURED here from the photo itself
     (a 96px copy drawn on a canvas; the background is read from the photo's
     border), so every product type fits, today's and future ones; until it is
     measured, the per-kind boxes in gcls-set.css apply. The slot is the most
     room the card may take: the card keeps the piece's own proportions plus
     the room for its tag, centered in the slot. */
  var BOX = {}, BOXW = {};
  try { BOX = JSON.parse(sessionStorage.getItem('gcls-box') || '{}') || {}; } catch (e) { BOX = {}; }
  var boxSave = 0;
  function boxKey(src) { return String(src || '').split('?')[0].replace(/^https?:/, ''); }
  function bbox(im) {
    var N = 96, w = im.naturalWidth, h = im.naturalHeight;
    if (!w || !h) return null;
    var k = N / Math.max(w, h), dw = Math.round(w * k), dh = Math.round(h * k), ox = (N - dw) / 2, oy = (N - dh) / 2;
    var cv = document.createElement('canvas'); cv.width = N; cv.height = N;
    var x = cv.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, ox, oy, dw, dh);
    var d = x.getImageData(0, 0, N, N).data;
    /* the background: the mean of the photo's own border pixels */
    var br = 0, bg = 0, bb = 0, bn = 0, i, px, py;
    for (py = Math.ceil(oy); py < oy + dh; py++) for (px = Math.ceil(ox); px < ox + dw; px++) {
      if (py > oy + 1 && py < oy + dh - 2 && px > ox + 1 && px < ox + dw - 2) continue;
      i = (py * N + px) * 4; br += d[i]; bg += d[i + 1]; bb += d[i + 2]; bn++;
    }
    if (!bn) return null;
    br /= bn; bg /= bn; bb /= bn;
    var cols = new Array(N).fill(0), rows = new Array(N).fill(0);
    for (py = 0; py < N; py++) for (px = 0; px < N; px++) {
      i = (py * N + px) * 4;
      if (d[i + 3] < 128) continue;
      if (Math.max(Math.abs(d[i] - br), Math.abs(d[i + 1] - bg), Math.abs(d[i + 2] - bb)) > 30) { cols[px]++; rows[py]++; }
    }
    function span(a) { var lo = -1, hi = -1; for (var j = 0; j < N; j++) if (a[j] > 1) { if (lo < 0) lo = j; hi = j; } return lo < 0 ? null : [lo, hi + 1]; }
    var sx = span(cols), sy = span(rows);
    if (!sx || !sy) return null;
    var bw = (sx[1] - sx[0]) / N, bh = (sy[1] - sy[0]) / N;
    /* a small margin keeps the soft shadow edge inside the card */
    var m = .02;
    bw = Math.min(1, bw + 2 * m); bh = Math.min(1, bh + 2 * m);
    if (bw * bh > .9) return [1, 1, .5, .5];
    return [+bw.toFixed(3), +bh.toFixed(3), +((sx[0] + sx[1]) / 2 / N).toFixed(3), +((sy[0] + sy[1]) / 2 / N).toFixed(3)];
  }
  function measure(src, cb) {
    var k = boxKey(src);
    if (!k) return;
    /* the store's photos are measured ahead (snippets/gcls-layout): no wait, no late reflow */
    var seed = window.GCLSL && GCLSL.B ? GCLSL.B[k.split('/').pop()] : null;
    if (seed) { cb(seed); return; }
    if (BOX[k]) { cb(BOX[k]); return; }
    if (BOXW[k]) { BOXW[k].push(cb); return; }
    BOXW[k] = [cb];
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.decoding = 'async';
    function done(r) {
      BOX[k] = r || [1, 1, .5, .5, 0];
      var ls = BOXW[k] || []; delete BOXW[k];
      ls.forEach(function (f) { f(BOX[k]); });
      clearTimeout(boxSave);
      boxSave = setTimeout(function () { try { sessionStorage.setItem('gcls-box', JSON.stringify(BOX)); } catch (e) {} }, 800);
    }
    im.onload = function () { var r = null; try { r = bbox(im); } catch (e) { r = null; } done(r); };
    im.onerror = function () { done(null); };
    im.src = sized(src, 96);
  }
  function cardBox(card, src) {
    if (!src) return;
    card._gclsSrc = boxKey(src);
    /* a photo not in GCLSL.B drawn while the picture is hidden (a deep link's first draw): the picture is shown
       only once its box is measured and the cards fitted to it (reveal), never refitted in view */
    var res = null;
    if (elComp && elComp.classList.contains('is-pending') && window.Promise) pend.boxes.push(new Promise(function (r) { res = r; }));
    measure(src, function (b) {
      if (res) { res(); res = null; }
      if (card._gclsSrc !== boxKey(src) || !b || b[4] === 0) return;
      var same = card._gclsBox && card._gclsBox.join() === b.join();
      card._gclsBox = b;
      card.style.setProperty('--gcls-bw', b[0]); card.style.setProperty('--gcls-bh', b[1]);
      card.style.setProperty('--gcls-cx', b[2]); card.style.setProperty('--gcls-cy', b[3]);
      if (card._gclsCore) { if (!same && !inStage) layoutSoon(); } else hug(card);
    });
  }
  function cssNum(el, v, d) { var x = parseFloat(getComputedStyle(el).getPropertyValue(v)); return isNaN(x) ? d : x; }
  function hug(el) {
    var s = el._gclsSlot;
    if (!s) return;
    var W = elComp.clientWidth, H = elComp.clientHeight;
    var x = s[0], y = s[1], w = s[2], h = s[3];
    if (W && H && el.classList.contains('gcls-card')) {
      var sw = w / 100 * W, sh = h / 100 * H;
      /* tiny cells (a large set): the photo alone, no tag or color button */
      var tiny = el.classList.contains('gcls-card--extra') && el._gclsGrid ? (sw < 112 || sh < 112) : (sw < 50 || sh < 60);
      el.classList.toggle('is-tiny', tiny);
      var bw = el._gclsBox ? el._gclsBox[0] : cssNum(el, '--gcls-bw', 1), bh = el._gclsBox ? el._gclsBox[1] : cssNum(el, '--gcls-bh', 1);
      var px = cssNum(el, '--gcls-px', .06), pt = cssNum(el, '--gcls-pt', .05);
      var th = tiny ? 6 : (el._gclsTagH || 46), tw = tiny ? 0 : (el._gclsTagW || 0);
      var cw = sw, chh = sh;
      var sA = sw * (1 - 2 * px) / bw, needH = (sA * bh + th) / (1 - pt);
      if (needH <= sh) chh = needH;
      else { var sB = (sh * (1 - pt) - th) / bh; cw = sB > 0 ? sB * bw / (1 - 2 * px) : sw; }
      /* never narrower than the tag's longest word (the name wraps at spaces, never cut):
         a narrow slot lends the card the room it needs, inside the picture */
      /* a card with a color button keeps the button's room beside the tag (a core card may lend itself that room);
         a "more" piece's cell too narrow for both (a phone's row of 4) shows the tag alone and its photo opens the
         colors (the rows and the "more" cards keep their color chips) */
      var cbw = 0, nob = false;
      if (!tiny && el.classList.contains('has-cbtn')) {
        var cbe = el.querySelector('.gcls-card__cbtn');
        cbw = ((cbe && cbe.offsetWidth) || (el.classList.contains('gcls-card--extra') ? 24 : 30)) + 6;
        if (el._gclsNob || (el.classList.contains('gcls-card--extra') && tw + 2 * (el._gclsTagInset || 8) + cbw > sw)) { nob = true; cbw = 0; }
      }
      if (el.classList.contains('is-nobtn') !== nob) { el.classList.toggle('is-nobtn', nob); var th3 = tagRoom(el, sw); if (th3) { el._gclsTagH = th3; el.style.setProperty('--gcls-tagh', th3 + 'px'); th = th3; } if (probe) probe.innerHTML = ''; }
      var need = tiny ? 44 : Math.max(44, tw + 2 * (el._gclsTagInset || 8) + cbw, el._gclsNeed || 0);
      cw = Math.min(Math.max(cw, need), Math.max(sw, Math.min(need, W)));
      if (!tiny && cw !== el._gclsTagAt) {
        var th2 = tagRoom(el, cw);
        if (th2 && th2 !== th) {
          el._gclsTagH = th2; el.style.setProperty('--gcls-tagh', th2 + 'px'); th = th2;
          var sC = cw * (1 - 2 * px) / bw; chh = Math.min(sh, (sC * bh + th) / (1 - pt));
        }
        if (probe) probe.innerHTML = '';
      }
      chh = Math.min(sh, Math.max(chh, th + 30));
      var cx0 = s[0] / 100 * W + sw / 2;
      var left = Math.max(0, Math.min(W - cw, cx0 - cw / 2));
      x = left / W * 100; y = s[1] + (sh - chh) / 2 / H * 100;
      w = cw / W * 100; h = chh / H * 100;
    }
    el.style.setProperty('--x', x.toFixed(3) + '%');
    el.style.setProperty('--y', y.toFixed(3) + '%');
    el.style.setProperty('--w', w.toFixed(3) + '%');
    el.style.setProperty('--h', h.toFixed(3) + '%');
  }
  function makeCard(kind) {
    var c = document.createElement('div');
    c.className = 'gcls-card is-enter';
    if (kind === 'case') {
      c.innerHTML = '<div class="gcls-card__frame gcx-engrave gcx-engrave--bare" data-gcls-frame><img class="gcls-card__img" alt="" decoding="async"><div class="gcx-engrave__mark" aria-hidden="true"><span class="gcx-engrave__text" data-gcls-letters></span></div>' + spotHTML() + '</div>';
    } else {
      c.innerHTML = '<div class="gcls-card__frame" data-gcls-frame><img class="gcls-card__img" alt="" decoding="async"></div>';
    }
    c.innerHTML += '<span class="gcls-card__tag"><span class="gcls-card__tn" data-gcls-tagname></span><bdi class="gcls-card__tp" data-gcls-tagprice></bdi></span>' +
      '<button type="button" class="gcls-card__cbtn" aria-haspopup="dialog" aria-expanded="false"><span class="gcls-card__cdot"></span></button>' +
      '<button type="button" class="gcls-card__rm" hidden><span class="gcls-card__rmdot"><svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span></button>';
    setKind(c, kind);
    return c;
  }
  /* a card changes kind in place (card holder <-> wallet): its class and piece box follow */
  function setKind(c, kind) {
    CORE_KINDS.concat(['magsafe', 'airpods', 'other']).forEach(function (k) { c.classList.remove('gcls-card--' + k); });
    c.classList.add('gcls-card--' + kind);
    c.setAttribute('data-kind', kind);
    if (kind !== 'case') {
      var fr = c.querySelector('.gcx-engrave'); if (fr) fr.classList.remove('gcx-engrave');
    }
  }
  function setImg(card, src, alt, w) {
    var frame = card.querySelector('[data-gcls-frame]');
    var imgs = frame.querySelectorAll('img');
    var top = imgs[imgs.length - 1];
    var want = sized(src, w);
    /* the Minimalist logo inside (Oct 2026): the case card shows the photo's logo-free twin (pic); data-want, the
       piece's box and the initials' anchor stay those of the photo as shot */
    var pic = card.classList.contains('gcls-card--case') ? lgPhoto(src) : src, wantPic = sized(pic, w);
    if (card.getAttribute('data-want') === want && (card._gclsPic || want) === wantPic) { if (top) top.alt = alt; return; }
    var srcset = sized(pic, Math.round(w * 0.6)) + ' ' + Math.round(w * 0.6) + 'w, ' + wantPic + ' ' + w + 'w';
    /* the same photo with or without its wordmark (the logo's tick): changed in place, so the indicator on it keeps
       its place and the focus, and the photo shown stays until the other one is in */
    if (card.getAttribute('data-want') === want && top && top.getAttribute('src')) {
      card._gclsPic = wantPic;
      top.alt = alt;
      top.setAttribute('srcset', srcset);
      top.src = wantPic;
      return;
    }
    card.setAttribute('data-want', want);
    card._gclsPic = wantPic;
    cardBox(card, src);
    var sizes = card.classList.contains('gcls-card--case') ? '(min-width: 1000px) 30vw, 60vw' : '(min-width: 1000px) 22vw, 45vw';
    var mark = frame.querySelector('.gcx-engrave__mark');
    var hidden = elComp.classList.contains('is-pending');
    if (!top || !top.getAttribute('src')) {
      if (!top) { top = document.createElement('img'); top.className = 'gcls-card__img'; frame.insertBefore(top, mark || null); }
      top.alt = alt; top.decoding = 'async';
      if (hidden && card.classList.contains('gcls-card--case')) top.setAttribute('fetchpriority', 'high');
      top.setAttribute('srcset', srcset); top.setAttribute('sizes', sizes);
      top.src = wantPic;
      if (hidden) pend.imgs.push(top);
      return;
    }
    if (top.getAttribute('src').split('?')[0] === wantPic.split('?')[0]) { top.alt = alt; return; }
    /* A deep link's first draw (hidden): the server's photo (the default
       set's color) is replaced by a NEW image element. The same element with
       a new src would keep painting the old photo until the new one arrives;
       a new one paints nothing until then. The picture stays hidden until
       these photos are in (see reveal), so the default set never flashes. */
    if (hidden) {
      qa('img', frame).forEach(function (im) { if (im !== top) im.remove(); });
      var fresh = document.createElement('img');
      fresh.className = 'gcls-card__img';
      fresh.alt = alt; fresh.decoding = 'async';
      if (card.classList.contains('gcls-card--case')) fresh.setAttribute('fetchpriority', 'high');
      ['width', 'height'].forEach(function (a) { if (top.hasAttribute(a)) fresh.setAttribute(a, top.getAttribute(a)); });
      fresh.setAttribute('srcset', srcset); fresh.setAttribute('sizes', sizes);
      fresh.src = wantPic;
      frame.replaceChild(fresh, top);
      pend.imgs.push(fresh);
      return;
    }
    var n = document.createElement('img');
    n.className = 'gcls-card__img is-next';
    n.alt = alt; n.decoding = 'async';
    n.setAttribute('srcset', srcset); n.setAttribute('sizes', sizes);
    frame.insertBefore(n, mark || null);
    var tok = card._gclsTok = (card._gclsTok || 0) + 1;
    n.src = wantPic;
    /* the new photo comes in once it is in, in the same frame as the card's new color dot (setDot, swapJoin) */
    swapJoin(card, n, function () {
      if (card._gclsTok !== tok) { n.remove(); return; }
      n.classList.remove('is-next');
      setTimeout(function () {
        if (card._gclsTok !== tok) return;
        qa('img', frame).forEach(function (im) { if (im !== n) im.remove(); });
      }, REDUCED ? 0 : 520);
    }, true);
  }
  /* the tag: the piece's name on one line (cut with an ellipsis when the
     card is narrow; the full name is its tooltip), its price on the next */
  function tag(card, name, price) {
    var n = card.querySelector('[data-gcls-tagname]');
    setText(n, name);
    /* Japanese and Chinese: break only between words (snippets/gcls-layout L.wbr) */
    if (window.GCLSL && GCLSL.wbr) GCLSL.wbr(n);
    if (n && n.getAttribute('title') !== name) n.setAttribute('title', name);
    setText(card.querySelector('[data-gcls-tagprice]'), price);
  }
  /* the card's color button: the piece's own photo in its color, and its name */
  function cardBtn(card, kind, p, ck, exKey) {
    var b = card.querySelector('.gcls-card__cbtn');
    if (!b) return;
    var many = p && !p.nocolor && p.colors.length > 1;
    b.hidden = !many;
    /* the button sits in the tag's row, at the card's other bottom corner: the tag leaves it room (gcls-set.css) */
    card.classList.toggle('has-cbtn', !!many);
    if (!many) return;
    b.removeAttribute('data-gcls-cbtn'); b.removeAttribute('data-gcls-cbtn-ex');
    if (exKey) b.setAttribute('data-gcls-cbtn-ex', exKey); else b.setAttribute('data-gcls-cbtn', kind);
    var lab = tpl(T.changeColor, { piece: pMid(p) });
    if (b.getAttribute('aria-label') !== lab) b.setAttribute('aria-label', lab);
    setDot(b.querySelector('.gcls-card__cdot'), p, ck);
  }
  /* The X at the card's top corner (owner, 1 Oct 2026: "so that users know they can remove any product from the
     bundle"): the summary's X on the picture, with its label ("Remove {piece} from the set"), shown wherever the
     piece's row may be unticked (as the color pop-up's "Remove from set"). The set has no smallest size to keep:
     the summary and the rows let every piece go too (with none left, the button asks to choose pieces). */
  function cardRm(card, key, p, can) {
    var b = card.querySelector('.gcls-card__rm');
    if (!b) return;
    if (b.getAttribute('data-gcls-rm') !== key) b.setAttribute('data-gcls-rm', key);
    var lab = tpl(T.rmLine || T.removePiece || '', { piece: pMid(p) });
    if (lab && b.getAttribute('aria-label') !== lab) { b.setAttribute('aria-label', lab); b.setAttribute('title', lab); }
    if (b.hidden === !!can) b.hidden = !can;
  }
  function removeEl(el) {
    el.classList.add('is-leave');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, REDUCED ? 0 : 480);
  }
  function enter(el) {
    el.getBoundingClientRect();
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-enter'); }); });
  }

  /* where the letters go on a photo: the first measured anchor whose match
     is part of the image URL, else the section's default (maybe none) */
  function anchorFor(src) {
    var s = String(src || '').toLowerCase().split('?')[0];
    var ls = D.anchors || [];
    for (var i = 0; i < ls.length; i++) if (ls[i][0] && s.indexOf(ls[i][0]) !== -1) return ls[i][1];
    return D.anchorDefault || '';
  }
  /* The case photo on the stage and where its letters go: the chosen
     variant's photo when it has a measured anchor; else another photo of the
     same case in the same color that has one (the letters never vanish while
     initials are typed); else the set's photo of that leather and color;
     else the variant's photo, without letters. */
  function stageCase(c) {
    var src = c ? pieceImg(c) : '';
    var a = src ? anchorFor(src) : '';
    if (a || !src) return { src: src, a: a };
    var vs = colorVariants(c.p, c.ck);
    for (var i = 0; i < vs.length; i++) { var b = vs[i].img ? anchorFor(vs[i].img) : ''; if (b) return { src: vs[i].img, a: b }; }
    for (var j = 0; j < SV.length; j++) {
      var v = SV[j];
      if (v.lk !== S.leather || CF(v.ck) !== c.ck || !v.img) continue;
      var b2 = anchorFor(v.img);
      if (b2) return { src: v.img, a: b2 };
    }
    return { src: src, a: '' };
  }
  var lastLetters = '';
  function renderEngrave() {
    var card = cards['core:case'];
    if (edOpen && (!card || !iniReady())) closeEd(false);
    if (!card) return;
    var frame = card.querySelector('[data-gcls-frame]');
    var src = card.getAttribute('data-want') || '';
    var a = anchorFor(src);
    card.classList.toggle('no-anchor', !a);
    var gx = G();
    if (a && frame && frame.getAttribute('data-gcx-anchor') !== a) {
      if (gx) gx.anchor(frame, a); else frame.setAttribute('data-gcx-anchor', a);
    }
    var ini = caseOn() ? cleanIni(S.ini) : '';
    card.classList.toggle('gcls-has-ini', !!ini);
    var spot = card.querySelector('[data-gcls-spot]');
    if (spot) { var son = iniReady(); if (spot.hidden === son) spot.hidden = !son; }
    var el = card.querySelector('[data-gcls-letters]');
    if (!el) return;
    if (gx) gx.engrave(frame, ini); else setText(el, ini);
    if (ini && ini !== lastLetters && !REDUCED) { el.classList.remove('is-struck'); void el.offsetWidth; el.classList.add('is-struck'); }
    lastLetters = ini;
    lgSideSoon();
  }

  /* ---- the stamp spot and the field on the picture (owner, 1 Oct 2026) ----
     The personalized case page's own module (gcpx-spot + gcpx-ed), the same way: a button over the stamp
     (placed by the same anchor as the gold letters, so it follows the photo in every reading direction; a
     glass "Tap / Click to add your initials" under it while there are none) opens a small glass field under
     the stamp (phones: a bar along the bottom of the picture, clear of the keyboard), so the gold preview on
     the case stays in view while the shopper types. The field is the initials step's twin: one state (S.ini),
     the same cleaning, Latin-only note, fee, summary, URL and cart line (onIniInput). Its count shows the
     length and the fee. Enter, Esc, the tick or leaving it closes it (the tick, Enter and Esc put the focus
     back on the spot). With initials the spot is a clear hit area over the letters, so a tap edits them. It is
     there only while the initials can be typed: the case is in the set and the initials are offered. */
  var PEN_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
  function spotHTML() {
    if (!T.spotTap || !elEd || !elEdIn) return '';
    return '<button type="button" class="gcls-spot" data-gcls-spot aria-controls="' + esc(elEd.id) + '" aria-expanded="false" aria-label="' + esc(T.spotAria || T.spotTap) + '">' +
      '<span class="gcls-spot__hint" aria-hidden="true">' + PEN_SVG + '<span class="gcls-spot__t gcls-spot__t--tap">' + esc(T.spotTap) + '</span>' +
      '<span class="gcls-spot__t gcls-spot__t--click">' + esc(T.spotClick || T.spotTap) + '</span></span></button>';
  }
  function iniReady() {
    var st = elIni && elIni.closest('[data-gcls-inistep]');
    return !!(st && !st.hidden && caseOn() && FEES.length > 0);
  }
  function spotEl() {
    var c = cards['core:case'];
    return c && !c.classList.contains('is-leave') ? c.querySelector('[data-gcls-spot]') : null;
  }
  /* "3/5  ·  $33.00": the length and the fee it costs (the step's own tiers, feeFor) */
  function renderEdN() {
    if (!elEdN) return;
    var n = cleanIni(S.ini).length, f = caseOn() ? feeFor(S.ini) : null;
    /* the fee in its own span (Oct 2026): gcls-set.css hides it on phones under 360px, where eight wide capitals
       need the room in the field */
    var fp = elEdN.querySelector('.gcls-ed__p');
    if (!fp) {
      elEdN.textContent = '';
      elEdN.appendChild(document.createTextNode(''));
      fp = elEdN.appendChild(document.createElement('span'));
      fp.className = 'gcls-ed__p';
    }
    setText(elEdN.firstChild, n + '/' + MAXC);
    setText(fp, f ? '  ·  ' + money(f.p) : '');
    elEdN.classList.toggle('is-full', n === MAXC);
    /* its width follows the count: it stays inside the picture */
    if (edOpen) placeEd();
  }
  /* the keyboard never covers the field (phones) */
  function vvKeep() {
    if (!edOpen || !elEd) return;
    var vv = window.visualViewport;
    var r = elEd.getBoundingClientRect(), bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    if (r.bottom > bottom - 12) window.scrollBy(0, r.bottom - bottom + 12);
  }
  /* under the stamp, inside the picture (wider screens; phones: CSS puts it along the bottom) */
  function placeEd() {
    var sp = spotEl();
    if (!elEd || !sp || !elStage) return;
    var S0 = elStage.getBoundingClientRect(), r = sp.getBoundingClientRect(), w = elEd.offsetWidth, m = 12;
    var x = r.left + r.width / 2 - S0.left;
    if (w && S0.width > w + 2 * m) x = Math.max(m + w / 2, Math.min(S0.width - m - w / 2, x));
    elEd.style.setProperty('--gcls-ed-x', Math.round(x) + 'px');
    elEd.style.setProperty('--gcls-ed-y', Math.round(r.bottom - S0.top + 8) + 'px');
  }
  function openEd() {
    var sp = spotEl();
    if (!elEd || !elEdIn || !sp || !iniReady()) return;
    if (cpop.open) closeCpop(false);
    gcT({ name: 'initials_spot_open', surface: 'set_builder', action: S.ini ? 'edit' : 'add' });
    edOpen = true;
    elEd.hidden = false;
    placeEd();
    if (elStage) elStage.classList.add('is-editing');
    sp.setAttribute('aria-expanded', 'true');
    elEdIn.value = S.ini;
    renderEdN();
    /* focus inside the tap itself, so phones open the keyboard */
    try { elEdIn.focus({ preventScroll: true }); } catch (e) { elEdIn.focus(); }
    try { elEdIn.setSelectionRange(elEdIn.value.length, elEdIn.value.length); } catch (e) {}
    setTimeout(vvKeep, 350);
  }
  function closeEd(back) {
    if (!edOpen) return;
    edOpen = false;
    elEd.hidden = true;
    if (elStage) elStage.classList.remove('is-editing');
    var sp = spotEl();
    if (sp) sp.setAttribute('aria-expanded', 'false');
    if (back && sp) try { sp.focus({ preventScroll: true }); } catch (e) {}
  }

  function nPieces(n) { return P(T.nPieces, n); }
  function captionParts(o) {
    var mixed = o.items.some(function (it) { return it.ck && it.ck !== FAM(); });
    return [LN(S.leather), mixed ? '' : CN(S.color), S.device && caseOn() ? MN(S.device) : '', nPieces(o.items.length)].filter(Boolean);
  }

  /* ---- every piece at its TRUE relative size ----
     Owner, 29 Sep 2026: the keychain looked larger than the passport holder
     and the wallet. Every piece on the picture (the case, the card holder or
     wallet, the passport holder, the keychain AND the "more" pieces) is laid
     out by snippets/gcls-layout (window.GCLSL, the same code that places the
     server's cards before the first paint): one centimeter is the same number
     of pixels for every piece, the composition is the largest that fits the
     picture, and the tags keep their size (compact, the name only, then none
     when they would cost the pieces too much of their size). */
  var inStage = false, layT = 0, exOrder = [];
  function layoutSoon() { cancelAnimationFrame(layT); layT = requestAnimationFrame(function () { layoutCore(); }); }
  /* Every piece on the picture, the core ones and the "more" ones, at ONE
     scale (px per cm): the more pieces sit in balanced rows under the core
     composition, or beside it when that lets every piece be larger. */
  function layoutCore() {
    var W = elComp.clientWidth, H = elComp.clientHeight, E = window.GCLSL;
    if (!W || !H || !E) return;
    var items = [];
    function add(k, el, ex) {
      if (!el || el.classList.contains('is-leave')) return;
      var kind = el.getAttribute('data-kind');
      var box = el._gclsBox || E.box(el.getAttribute('data-want'), kind);
      items.push({ el: el, slot: ex ? k : k.slice(5), kind: kind, cm: E.cm(kind, ex ? '' : S.device, el.getAttribute('data-cm')), box: box, tag: E.tag(el), ex: ex, tilt: ex ? el._gclsTilt : null });
    }
    Object.keys(cards).forEach(function (k) { if (k.indexOf('core:') === 0) add(k, cards[k], false); });
    exOrder.forEach(function (k) { add(k, cards[k], true); });
    Object.keys(ghosts).forEach(function (k) {
      var g = ghosts[k];
      if (!g || g.classList.contains('is-leave')) return;
      var kind = g._gclsKind || k.slice(5);
      items.push({ el: g, slot: k.slice(5), kind: kind, cm: E.cm(kind, S.device, g.getAttribute('data-cm')), box: E.box('', kind), tag: { f: [0, 6], c: [0, 6] }, ghost: true });
    });
    if (!items.length) return;
    /* the picture already drawn stays while nothing it was solved from changed and every tag still fits (the font
       in, a scrollbar come or gone): no card changes size after the page has loaded (snippets/gcls-layout L.valid) */
    var sig = E.sig ? E.sig(items) : '', wh = elComp._gclsWH;
    if (sig && sig === elComp._gclsSig && wh && Math.abs(W - wh[0]) <= wh[0] * .03 && Math.abs(H - wh[1]) <= wh[1] * .03 && E.valid(items, W)) return;
    /* solved, applied, and any tag drawn cut inside a word steps down its ladder (snippets/gcls-layout L.fit) */
    var r = E.fit(items, { x: 0, y: 0, w: W, h: H }, function (it, c, r) { E.apply(it.el, c, W, H, it.ghost ? 0 : r.mode, it.ghost ? null : it.box); });
    if (r) { elComp._gclsSig = sig; elComp._gclsWH = [W, H]; }
  }
  function cmOf(p) { return p && p.cm ? String(p.cm) : ''; }

  function renderStage() {
    var o = cur(), t = totals();
    var shownEx = o.extras.filter(function (x) { return x.ok; });
    var layout = shownEx.length ? 'extra' : 'core';
    /* more than 4 "more" pieces: no gap is drawn for a core piece taken out */
    var many = shownEx.length > 4;
    var pending = elComp.classList.contains('is-pending');
    exOrder = shownEx.map(function (x) { return 'ex:' + x.p.key; });
    inStage = true;
    elComp.classList.toggle('is-core', layout === 'core');
    elComp.classList.toggle('is-extra', layout === 'extra');
    var keep = {}, keepG = {};
    var z = 10;
    o.core.forEach(function (c) {
      var k = 'core:' + c.slot;
      /* once the piece is in the set again (another color), it is an ordinary piece: a gap says why it is out */
      if (c.on || !c.why) delete S.dq[c.slot];
      if (c.on) {
        keep[k] = 1;
        var card = cards[k];
        var fresh = false;
        if (!card || card.classList.contains('is-leave')) { card = makeCard(c.kind); elComp.appendChild(card); cards[k] = card; fresh = true; }
        else if (card.getAttribute('data-kind') !== c.kind) setKind(card, c.kind);
        var src = c.kind === 'case' ? stageCase(c).src : pieceImg(c);
        setImg(card, src, tpl(T.imgAlt, { title: c.p.t, color: colorLabel(c.p, c.ck) }), c.kind === 'case' ? 900 : 720);
        /* the case is priced by model: "from" its lowest price until one is chosen */
        tag(card, pName(c.p), c.v ? (c.from ? tpl(T.fromPriceLc, { price: money(c.v.price, true) }) : money(c.v.price, true)) : '');
        cardBtn(card, c.kind, c.p, c.ck);
        cardRm(card, k, c.p, !c.why);
        card._gclsCore = true; card._gclsSlot = null;
        if (card.getAttribute('data-cm') !== cmOf(c.p)) { if (cmOf(c.p)) card.setAttribute('data-cm', cmOf(c.p)); else card.removeAttribute('data-cm'); }
        card.style.zIndex = String(z++);
        if (fresh) { if (pending) card.classList.remove('is-enter'); else enter(card); }
      } else if (many) {
        /* a large set (the grid below): no gap is drawn; the piece's row says why it is out */
      } else if (S.dq[c.slot] && c.why) {
        /* an optional piece not made or sold out in the color the page opened on (D.set.defOff): left out of
           that set without a gap, as the server drew it (no layout shift); its row says why */
      } else {
        /* a gap where the piece was: why, with one tap to a color in stock, or a way to put it back */
        keepG[k] = 1;
        var g = ghosts[k];
        if (!g) {
          g = document.createElement('div');
          g.className = 'gcls-ghost is-enter';
          elComp.appendChild(g);
          ghosts[k] = g;
          enter(g);
        }
        /* the piece's name on its own line, what is wrong under it */
        var gh = c.why ? '<span class="gcls-ghost__t"><b class="gcls-ghost__n">' + esc(pName(c.p)) + '</b><span class="gcls-ghost__w">' + esc(whyText(c)) + '</span></span>' +
            /* on the picture the button is short (the color's name); its full sentence is its name for screen readers and stays in the row */
            (c.alt ? '<button type="button" class="gcls-ghost__btn gcls-ghost__btn--alt" data-gcls-alt="' + c.kind + ':' + esc(c.alt) + '" aria-label="' + esc(tpl(T.batchPick || '[color]', { color: colorLabel(c.p, c.alt) })) + '" title="' + esc(tpl(T.batchPick || '[color]', { color: colorLabel(c.p, c.alt) })) + '">' + dotHTML('gcls-alt__dot', c.p, c.alt, 18) + esc(colorLabel(c.p, c.alt)) + '</button>' : '') :
          '<button type="button" class="gcls-ghost__btn" data-gcls-restore="' + c.slot + '"><span aria-hidden="true">+</span>' + esc(tpl(T.ghostAdd, { piece: pMid(c.p) })) + '</button>';
        setHTML(g, gh);
        settleDots(g);
        g._gclsCore = true; g._gclsKind = c.kind; g._gclsSlot = null;
        if (cmOf(c.p)) g.setAttribute('data-cm', cmOf(c.p));
        g.style.zIndex = '5';
      }
    });
    shownEx.forEach(function (x, i) {
      var k = 'ex:' + x.p.key;
      keep[k] = 1;
      var card = cards[k];
      var fresh = false;
      if (!card || card.classList.contains('is-leave')) { card = makeCard(x.kind); card.classList.add('gcls-card--extra'); elComp.appendChild(card); cards[k] = card; fresh = true; }
      setImg(card, (x.v && x.v.img) || x.p.img, tpl(T.imgAlt, { title: x.p.t, color: colorLabel(x.p, x.ck) }), 720);
      tag(card, pName(x.p), money(x.v.price, true));
      cardBtn(card, x.p.nk, x.p, x.ck, x.p.key);
      cardRm(card, 'ex:' + x.p.key, x.p, !!S.ex[x.p.key]);
      /* drawn at the same scale as the core pieces (layoutCore) */
      card._gclsCore = true; card._gclsSlot = null;
      card._gclsTilt = ((i % 3) - 1) * 1.8;
      if (card.getAttribute('data-cm') !== cmOf(x.p)) { if (cmOf(x.p)) card.setAttribute('data-cm', cmOf(x.p)); else card.removeAttribute('data-cm'); }
      card.style.zIndex = String(20 + i);
      if (fresh) { if (pending) card.classList.remove('is-enter'); else enter(card); }
    });
    Object.keys(cards).forEach(function (k) { if (!keep[k]) { removeEl(cards[k]); delete cards[k]; } });
    Object.keys(ghosts).forEach(function (k) { if (!keepG[k]) { removeEl(ghosts[k]); delete ghosts[k]; } });

    var names = o.items.map(function (it) { return pMid(it.p); });
    elComp.setAttribute('aria-label', tpl(T.compLabel, { leather: LN(S.leather), color: CN(S.color), list: list(names) }));
    renderBadge(o, t);
    renderEngrave();
    lgSync();
    fitTags();
    inStage = false;
    /* a deep link's set: drawn while hidden (snippets/gcls-layout), then shown (no layout shift) */
    if (pending) reveal();
  }
  /* A deep link's picture is shown once its own photos are in (loaded and
     decoded), at most 1.5 s after the script drew it; the default set's
     photos, which the server sent, are never seen. */
  var pend = { imgs: [], boxes: [], tok: 0, cap: 0 };
  function reveal() {
    var tok = ++pend.tok;
    if (!pend.cap) pend.cap = setTimeout(unhide, 1500);
    var ims = pend.imgs.filter(function (im) { return im.isConnected; });
    if ((!ims.length && !pend.boxes.length) || !window.Promise) { unhide(); return; }
    /* its photos and color dots loaded and decoded, and the boxes of photos not in GCLSL.B measured */
    Promise.all(ims.map(inP).concat(pend.boxes)).then(function () { if (tok === pend.tok) unhide(); });
  }
  function unhide() {
    if (!elComp.classList.contains('is-pending')) return;
    clearTimeout(pend.cap);
    pend.imgs = []; pend.boxes = [];
    /* the picture as it will stay: a box measured while hidden is applied now, before it is shown */
    cancelAnimationFrame(layT);
    layoutCore();
    elComp.getBoundingClientRect();
    requestAnimationFrame(function () {
      elComp.classList.remove('is-pending');
      if (elStage) elStage.classList.remove('is-prep');
    });
  }

  /* Every piece is shown whole (CSS "every piece whole"); the room its tag
     takes (two lines: the name, then the price) is measured here at the
     card's final width and handed to CSS as --gcls-tagh. */
  var probe = null;
  function tagRoom(card, w) {
    var t = card.querySelector('.gcls-card__tag');
    if (!t || !(w > 0)) return null;
    if (!probe) {
      probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      elComp.appendChild(probe);
    }
    probe.className = card.className.replace(/\bis-(enter|leave|next)\b/g, '') + ' gcls-card--probe';
    probe.style.width = w + 'px';
    card._gclsTagAt = w;
    if (window.GCLSL && GCLSL.wbr) GCLSL.wbr(t.querySelector('.gcls-card__tn'));
    probe.innerHTML = '<span class="gcls-card__tag">' + t.innerHTML + '</span>';
    var pt = probe.firstChild, cs = window.getComputedStyle(pt);
    var r = pt.getBoundingClientRect();
    card._gclsTagInset = parseFloat(cs.left) || 8;
    /* the tag's longest word, unclamped (the tag's max-width leaves the color button's room) */
    pt.style.width = 'min-content'; pt.style.maxWidth = 'none';
    card._gclsTagW = Math.ceil(pt.getBoundingClientRect().width);
    /* and its width with the name on one line */
    pt.style.width = 'max-content';
    card._gclsTagW1 = Math.ceil(pt.getBoundingClientRect().width);
    pt.style.width = ''; pt.style.maxWidth = '';
    return Math.ceil(r.height + (parseFloat(cs.bottom) || 8) + 4);
  }
  function fitTags() {
    var W = elComp.clientWidth;
    if (!W) return;
    var live = Object.keys(cards).map(function (k) { return cards[k]; }).filter(function (c) { return c && !c.classList.contains('is-leave') && c._gclsSlot; });
    live.forEach(function (c) {
      var r = tagRoom(c, (c._gclsBase || c._gclsSlot)[2] / 100 * W);
      if (r) { c._gclsTagH = r; c.style.setProperty('--gcls-tagh', (c.classList.contains('is-tiny') ? 6 : r) + 'px'); }
    });
    live.forEach(hug);
    if (probe) probe.innerHTML = '';
    layoutCore();
  }
  /* ---- the passport holder and the keychain share a row (4 core pieces) ----
     Owner, 29 Sep 2026: the passport holder card looked squashed. Its slot was
     narrower than its name and color button, so the tag wrapped to three lines
     ("Passport / holder / $105") and took the photo's room; on a narrow picture
     the keychain card, widened for its own tag, covered it. The two cards now
     split their row by what their tags need, each name on one line beside its
     color button; the case lends the row what it needs while it keeps 44% of
     the picture's width. When that is not enough, the keychain card, then the
     passport holder card, shows its tag alone (the card itself opens its
     colors, as a small "more" card does; the rows keep their color chips) and
     the case keeps 42%, then 40%; only then do the names wrap. The passport
     holder takes the rest of the row, up to what its slot's height allows, and
     the gap between the two allows for their tilt, so they never overlap. */
  function rowFit() {
    var P = cards['core:passport'], K = cards['core:keychain'], C = cards['core:case'];
    [P, K, C].forEach(function (c) { if (c) { c._gclsNob = false; c._gclsNeed = 0; if (c._gclsBase) c._gclsSlot = c._gclsBase; } });
    /* the keychain taken out: its gap keeps its slot, the passport holder still gets its row */
    var KG = !K && ghosts['core:keychain'] && !ghosts['core:keychain'].classList.contains('is-leave') ? ghosts['core:keychain'] : null;
    if (KG) K = KG;
    if (!P || !K || !P._gclsBase || !K._gclsBase || P.classList.contains('is-leave') || K.classList.contains('is-leave')) return;
    var W = elComp.clientWidth, H = elComp.clientHeight;
    if (!W || !H) return;
    var pb = P._gclsBase, kb = K._gclsBase, cb = C && !C.classList.contains('is-leave') && C._gclsBase ? C._gclsBase : null;
    var rad = Math.PI / 180;
    var gap = Math.max(4, .008 * W) + Math.abs(kb[3] / 100 * H * Math.sin(kb[4] * rad) - pb[3] / 100 * H * Math.sin(pb[4] * rad)) / 2;
    var L = pb[0] / 100 * W, R = (kb[0] + kb[2]) / 100 * W;
    function needs(c) {
      var i = 2 * (c._gclsTagInset || 8), w1 = c._gclsTagW1 || c._gclsTagW || 0, wm = c._gclsTagW || 0;
      var cbe = c.querySelector('.gcls-card__cbtn'), btn = c.classList.contains('has-cbtn') ? ((cbe && cbe.offsetWidth) || 30) + 6 : 0;
      return { b: w1 + i + btn, n: w1 + i, w: wm + i + btn, wn: wm + i };
    }
    /* the widest the card gets from its piece in its slot's height */
    function natW(c, s) {
      var bw = c._gclsBox ? c._gclsBox[0] : cssNum(c, '--gcls-bw', 1), bh = c._gclsBox ? c._gclsBox[1] : cssNum(c, '--gcls-bh', 1);
      var px = cssNum(c, '--gcls-px', .06), pt = cssNum(c, '--gcls-pt', .05);
      var sB = (s[3] / 100 * H * (1 - pt) - (c._gclsTagH || 46)) / bh;
      return sB > 0 ? sB * bw / (1 - 2 * px) : s[2] / 100 * W;
    }
    var np = needs(P), nk = KG ? { b: kb[2] / 100 * W, n: kb[2] / 100 * W, w: kb[2] / 100 * W, wn: kb[2] / 100 * W } : needs(K);
    var pMax = natW(P, pb), kNat = KG ? kb[2] / 100 * W : Math.min(natW(K, kb), kb[2] / 100 * W);
    /* [passport need, keychain need, passport alone, keychain alone, the case's least width in % of the picture] */
    var modes = [[np.b, nk.b, 0, 0, 44], [np.b, nk.n, 0, 1, 42], [np.n, nk.n, 1, 1, 40], [np.w, nk.wn, 0, 1, 40], [np.wn, nk.wn, 1, 1, 40]];
    var m = null, pw = 0, kw = 0, lend = 0;
    for (var i = 0; i < modes.length && !m; i++) {
      kw = Math.max(modes[i][1], kNat);
      var free = R - L - kw - gap, may = cb ? Math.max(0, (cb[2] - modes[i][4]) / 100 * W) : 0, need = modes[i][0];
      if (need > free + may + .5 && i < modes.length - 1) continue;
      /* the passport holder fills the row, and is never narrower than its own slot while the case may lend
         (a long keychain name, as in German, does not shrink it); once its name must wrap (a narrow
         picture) it takes all the case may lend */
      pw = Math.min(Math.max(free, pb[2] / 100 * W, i >= 3 ? free + may : 0), free + may, pMax);
      pw = Math.max(pw, need);
      lend = Math.max(0, pw - free);
      m = modes[i];
    }
    P._gclsNob = !!m[2]; P._gclsNeed = m[0];
    var left = L - lend, right = R - kw - gap;
    P._gclsSlot = [(left + Math.max(0, (right - left - pw) / 2)) / W * 100, pb[1], pw / W * 100, pb[3], pb[4]];
    if (!KG) { K._gclsNob = !!m[3]; K._gclsNeed = m[1]; K._gclsSlot = [(R - kw) / W * 100, kb[1], kw / W * 100, kb[3], kb[4]]; }
    if (cb && lend > 0) C._gclsSlot = [cb[0], cb[1], cb[2] - lend / W * 100, cb[3], cb[4]];
  }
  var fitT = 0;
  window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitTags, 150); }, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitTags(); });

  /* the caption under the picture (no sticker: owner, 29 Sep 2026) */
  function renderBadge(o) {
    setText('[data-gcls-caption]', captionParts(o).join(' · '));
  }

  /* ---------- the gallery: the set, or the approved photos (Photos mode) ---------- */
  var SLIDES = elPhTrack ? qa('[data-gcls-slide]', elPhTrack) : [];
  var phSig = '';
  /* the photos of the chosen leather and color first, then that leather, then the rest (order kept otherwise) */
  function orderSlides() {
    if (!elPhTrack || !SLIDES.length) return;
    var fam = FAM(), lk = S.leather;
    var sig = lk + '|' + fam;
    if (sig === phSig) return;
    phSig = sig;
    var ranked = SLIDES.map(function (el, i) {
      var l = el.getAttribute('data-l'), f = el.getAttribute('data-f');
      return { el: el, i: i, r: l === lk && f === fam ? 0 : (l === lk ? 1 : 2) };
    }).sort(function (a, b) { return a.r - b.r || a.i - b.i; });
    var frag = document.createDocumentFragment();
    ranked.forEach(function (x) { frag.appendChild(x.el); });
    elPhTrack.appendChild(frag);
    if (S.view === 'photos') elPhTrack.scrollLeft = 0;
    renderThumbs();
  }
  function curSlides() { return elPhTrack ? qa('[data-gcls-slide]', elPhTrack) : []; }
  function renderThumbs() {
    if (!elThumbs) return;
    var o = cur();
    var c0 = o.caseRow || o.core[0];
    /* the set's case as the Minimalist logo shows it (Oct 2026) */
    var setImgSrc = c0 ? lgPhoto(pieceImg(c0)) : '';
    var h = '<div class="gcls-thumbwrap" role="listitem"><button type="button" class="gcls-thumb' + (S.view === 'set' ? ' is-on' : '') + '" data-gcls-thumb="set" aria-label="' + esc(T.viewSet) + '"' + (S.view === 'set' ? ' aria-current="true"' : '') + '>' +
      (setImgSrc ? '<img src="' + esc(sized(setImgSrc, 160)) + '" alt="" width="80" height="80" loading="lazy" decoding="async">' : '') +
      '<span class="gcls-thumb__label">' + esc(T.viewSet) + '</span></button></div>';
    curSlides().forEach(function (el) {
      var i = el.getAttribute('data-gcls-slide');
      var th = el.getAttribute('data-thumb');
      var lab = el.getAttribute('data-label') || '';
      h += '<div class="gcls-thumbwrap" role="listitem"><button type="button" class="gcls-thumb gcls-thumb--ph' + (el.getAttribute('data-type') === 'video' ? ' is-video' : '') + '" data-gcls-thumb="' + i + '" aria-label="' + esc(lab) + '">' +
        (th ? '<img src="' + esc(th) + '" alt="" width="80" height="80" loading="lazy" decoding="async">' : '') + '</button></div>';
    });
    setHTML(elThumbs, h);
    markThumb();
  }
  var phIdx = null;
  function markThumb() {
    qa('[data-gcls-thumb]', elThumbs).forEach(function (b) {
      var v = b.getAttribute('data-gcls-thumb');
      var on = S.view === 'set' ? v === 'set' : v === String(phIdx);
      b.classList.toggle('is-on', on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }
  /* the slide most in view */
  function visibleSlide() {
    if (!elPhTrack) return null;
    var tr = elPhTrack.getBoundingClientRect(), best = null, bw = 0;
    curSlides().forEach(function (el) {
      var r = el.getBoundingClientRect();
      var w = Math.min(r.right, tr.right) - Math.max(r.left, tr.left);
      if (w > bw) { bw = w; best = el; }
    });
    return best;
  }
  if (elPhTrack) {
    var phT = 0;
    elPhTrack.addEventListener('scroll', function () {
      clearTimeout(phT);
      phT = setTimeout(function () { if (SW.anim || SW.st) return; var el = visibleSlide(); if (el) { phIdx = el.getAttribute('data-gcls-slide'); markThumb(); zoomState(); } }, 90);
    }, { passive: true });
  }

  /* ---------- the view toggle (Your set / Photos) ----------
     Owner, 29 Sep 2026 (the toggle was sudden and sometimes showed photos
     still loading): the glass thumb glides to the view chosen (the Ladies &
     Gentlemen toggle's thumb, assets/gcpx-unisex.js) in the same frame as
     the click; the Photos panel is laid out ahead (idle time, or as soon as
     the pointer or focus comes near the toggle or a thumbnail) with its
     first photos loaded and decoded, and the two views cross-fade (400 ms)
     only once the photo to show is decoded (at most ~0.7 s): never a blank
     or half-loaded frame, nothing moves. Every heavy step runs after the
     frame that answers the click (INP). */
  var elToggle = q('.gcls__toggle'), elTThumb = elToggle && q('.gcls__tthumb', elToggle), tPos = {};
  function afterPaint(fn) { requestAnimationFrame(function () { setTimeout(fn, 0); }); }
  function measureToggle() {
    if (!elTThumb) return;
    qa('[data-gcls-view]', elToggle).forEach(function (b) { tPos[b.getAttribute('data-gcls-view')] = [b.offsetLeft, b.offsetTop, b.offsetWidth, b.offsetHeight]; });
  }
  function placeThumb(v, live) {
    if (!elTThumb) return;
    var p = tPos[v];
    if (!p || !p[2]) return;
    if (!live) elToggle.classList.remove('is-live');
    elToggle.style.setProperty('--thumb-x', p[0] + 'px'); elToggle.style.setProperty('--thumb-y', p[1] + 'px');
    elToggle.style.setProperty('--thumb-w', p[2] + 'px'); elToggle.style.setProperty('--thumb-h', p[3] + 'px');
    elToggle.classList.add('is-glide');
    if (!live) requestAnimationFrame(function () { requestAnimationFrame(function () { elToggle.classList.add('is-live'); }); });
  }
  function pressView(v) {
    qa('[data-gcls-view]').forEach(function (b) { var on = b.getAttribute('data-gcls-view') === v ? 'true' : 'false'; if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on); });
    placeThumb(v, true);
  }
  if (elTThumb) {
    measureToggle(); placeThumb('set', false);
    var reTog = function () { measureToggle(); placeThumb(S.view || 'set', false); };
    if ('ResizeObserver' in window) new ResizeObserver(reTog).observe(elToggle); else window.addEventListener('resize', reTog, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reTog);
  }
  /* the Photos panel, laid out and its first photos loaded before it is ever shown */
  var phWarm = false;
  function slideImgs(el) { return el ? qa('img', el) : []; }
  /* a slide's photos load now; its video loads in full only while the Photos view is shown (never from the
     warm-up behind the set: a video there would download for nothing) */
  function eagerSlide(el) {
    slideImgs(el).forEach(function (im) { if (im.loading !== 'eager') im.loading = 'eager'; });
    if (el && phShown()) qa('video', el).forEach(function (v) { if (v.preload !== 'auto') v.preload = 'auto'; });
  }
  function phShown() { return S.view === 'photos' && !!elPhotos && !elPhotos.hidden && elPhotos.classList.contains('is-on'); }
  /* the video player below (setupVideo) plays a video in this panel only while the panel is shown: told on every change */
  function phNotify() { if (!elPhotos) return; try { elPhotos.dispatchEvent(new CustomEvent('gcls:view', { detail: { shown: phShown() } })); } catch (e) {} }
  function warmPhotos() {
    if (phWarm || !elPhotos || !SLIDES.length) return;
    phWarm = true;
    elPhotos.classList.add('is-off');
    elPhotos.hidden = false;
    var gx = G(), row = elPhotos.querySelector('[data-gcx-scroll]');
    if (gx && gx.scrollRow && row) gx.scrollRow(row);
    var s = curSlides();
    eagerSlide(s[0]); eagerSlide(s[1]);
    coLayout();
  }
  /* ---------- Photos: the callouts on the photo in a small panel ----------
     Owner, 30 Sep 2026: on a phone the callout texts were listed under a smaller photo, and a slide without
     callouts kept an empty band for that list. In a panel under 540 x 722px (phones, tablets, most laptops;
     the CSS container query of .gcls__photos) every photo and the video now fill their frame to the bottom
     (cover), and the callouts sit on the photo, as on the large panel, as glass chips:
     - the crop (--gcls-fx / --gcls-fy, 0..1, read by the CSS) keeps every anchor (the dot on the piece)
       inside the frame with a margin, leaning toward the label points; the video keeps its CSS framing;
     - each chip starts where the large panel's label starts (its side of the label point), is kept inside
       the frame, off every anchor, off the gallery's chevrons and off the chips placed before it (it slides
       up or down, else goes to the other side of its anchor);
     - a thin white leader runs from the anchor to the chip, vertical then horizontal, as on the large panel.
     The photo is never mirrored in RTL (the anchors are points on it); a chip's text runs in the page's
     direction. Laid out with the panel (warm-up), on every resize of the panel and once the fonts are in. */
  var CO_M = 16, CO_P = 8, CO_GAP = 5;
  function coPct(el, v) { return (parseFloat(el.style.getPropertyValue(v)) || 0) / 100; }
  /* the slide's callouts, read once from its large-panel overlay (a label, then its dot; a dot alone has its text in the list) */
  function coData(sl) {
    if (sl._gclsCo) return sl._gclsCo;
    var ov = q('.gcls-ex__ov', sl), li = qa('.gcls-ex__list li', sl), out = [], lbl = null;
    if (ov) Array.prototype.forEach.call(ov.children, function (el) {
      if (el.classList.contains('gcls-ex__lbl')) { lbl = el; return; }
      if (!el.classList.contains('gcls-ex__dot')) return;
      var c = { ax: coPct(el, '--x'), ay: coPct(el, '--y'), lines: [] };
      if (lbl) {
        c.lx = coPct(lbl, '--x'); c.ly = coPct(lbl, '--y');
        c.al = lbl.classList.contains('gcls-ex__lbl--right') ? 'right' : lbl.classList.contains('gcls-ex__lbl--center') ? 'center' : 'left';
        c.lines = qa('b', lbl).map(function (b) { return b.textContent.trim(); }).filter(Boolean);
      }
      if (!c.lines.length && li[out.length]) c.lines = [li[out.length].textContent.trim()];
      out.push(c);
      lbl = null;
    });
    sl._gclsCo = out;
    return out;
  }
  /* where the frame's window starts along one side of the photo, 0..1 of what is cropped: every anchor inside
     with the margin when it fits, as near as that allows to the middle of the anchors and label points */
  function coWin(anch, all, len, view) {
    var over = len - view;
    if (over < 1 || !anch.length) return 0.5;
    var a0 = Math.min.apply(null, anch) * len - CO_M, a1 = Math.max.apply(null, anch) * len + CO_M;
    var lo = Math.max(0, a1 - view), hi = Math.min(over, a0);
    var mid = (Math.min.apply(null, all) + Math.max.apply(null, all)) / 2 * len - view / 2;
    var s = lo <= hi ? Math.min(hi, Math.max(lo, mid)) : (a0 + a1) / 2 - view / 2;
    return Math.min(over, Math.max(0, s)) / over;
  }
  /* a chip's line: a short hyphenated word (HOT-STAMPED) never breaks at its hyphen; a long compound (German) may */
  function coLine(t) { return String(t).split(/(\S*[^\s-]-[^\s-]\S*)/).map(function (p, i) { return i % 2 && p.length <= 16 ? '<span class="gcls-ex__nb">' + esc(p) + '</span>' : esc(p); }).join(''); }
  function coSmall() { return !!elPhotos && elPhotos.clientWidth > 0 && (elPhotos.clientWidth < 540 || elPhotos.clientHeight < 722); }
  function coLayout() {
    if (!elPhotos || !SLIDES.length || elPhotos.hidden) return;
    var small = coSmall();
    var jobs = [];
    SLIDES.forEach(function (sl) {
      var layer = sl._gclsLayer;
      if (!small) { if (layer) layer.hidden = true; return; }
      var data = coData(sl), fig = q('.gcls-ex__fig', sl);
      if (!data.length || !fig) return;
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'gcls-ex__co';
        layer.setAttribute('aria-hidden', 'true');
        layer.innerHTML = '<svg class="gcls-ex__cosvg" focusable="false"></svg>' + data.map(function (c) {
          return '<span class="gcls-ex__chip">' + c.lines.map(function (t) { return '<b>' + coLine(t) + '</b>'; }).join('') + '</span>';
        }).join('');
        fig.appendChild(layer);
        sl._gclsLayer = layer;
      }
      layer.hidden = false;
      jobs.push({ sl: sl, fig: fig, layer: layer, data: data });
    });
    if (!jobs.length) return;
    /* the chevrons over the photos (laid out from 700px; also while the panel is still hidden): chips keep off them */
    var pr = elPhotos.getBoundingClientRect();
    var chev = qa('.gcx-chev', elPhotos).filter(function (b) { return b.getClientRects().length > 0; })
      .map(function (b) { var r = b.getBoundingClientRect(); return [r.left - pr.left, r.top - pr.top, r.width, r.height]; });
    /* read everything first, then write (one layout): a chip whose text wraps is as wide as its longest line */
    jobs.forEach(function (j) { qa('.gcls-ex__chip', j.layer).forEach(function (c) { c.style.width = ''; }); });
    var rg = document.createRange();
    jobs.forEach(function (j) {
      var fr = j.fig.getBoundingClientRect(), sr = j.sl.getBoundingClientRect();
      j.W = j.fig.clientWidth; j.H = j.fig.clientHeight;
      j.off = [fr.left - sr.left, fr.top - sr.top];
      j.sizes = qa('.gcls-ex__chip', j.layer).map(function (c) {
        var w = c.offsetWidth, h = c.offsetHeight, cs = getComputedStyle(c), pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
        var l = Infinity, r = -Infinity, tw = document.createTreeWalker(c, 4), tn;
        while ((tn = tw.nextNode())) {
          rg.selectNodeContents(tn);
          Array.prototype.forEach.call(rg.getClientRects(), function (x) { if (x.width) { l = Math.min(l, x.left); r = Math.max(r, x.right); } });
        }
        var tight = r > l ? Math.ceil(r - l + pad + 1) : w;
        return [Math.min(w, tight), h, tight < w - 1];
      });
    });
    jobs.forEach(function (j) {
      var W = j.W, H = j.H, data = j.data;
      if (!W || !H) return;
      var ar = parseFloat(j.sl.style.getPropertyValue('--ar')) || 0.8;
      var IW = Math.max(W, H * ar), IH = IW / ar;
      var ax = data.map(function (c) { return c.ax; }), ay = data.map(function (c) { return c.ay; });
      var lxs = ax.concat(data.filter(function (c) { return c.lx != null; }).map(function (c) { return c.lx; }));
      var lys = ay.concat(data.filter(function (c) { return c.ly != null; }).map(function (c) { return c.ly; }));
      var fx = coWin(ax, lxs, IW, W), fy = coWin(ay, lys, IH, H);
      j.sl.style.setProperty('--gcls-fx', fx.toFixed(4));
      j.sl.style.setProperty('--gcls-fy', fy.toFixed(4));
      var sx = fx * Math.max(0, IW - W), sy = fy * Math.max(0, IH - H);
      var A = data.map(function (c) { return [c.ax * IW - sx, c.ay * IH - sy]; });
      var obst = chev.map(function (r) { return [r[0] - j.off[0], r[1] - j.off[1], r[2], r[3]]; });
      var placed = [];
      function hit(x, y, w, h) {
        var i;
        for (i = 0; i < placed.length; i++) { var p = placed[i]; if (x < p[0] + p[2] + CO_GAP && x + w + CO_GAP > p[0] && y < p[1] + p[3] + CO_GAP && y + h + CO_GAP > p[1]) return true; }
        for (i = 0; i < A.length; i++) { if (A[i][0] > x - 7 && A[i][0] < x + w + 7 && A[i][1] > y - 7 && A[i][1] < y + h + 7) return true; }
        for (i = 0; i < obst.length; i++) { var o = obst[i]; if (x < o[0] + o[2] + 4 && x + w + 4 > o[0] && y < o[1] + o[3] + 4 && y + h + 4 > o[1]) return true; }
        return false;
      }
      function clampX(x, w) { return Math.max(CO_P, Math.min(x, W - CO_P - w)); }
      function clampY(y, h) { return Math.max(CO_P, Math.min(y, H - CO_P - h)); }
      /* the chips from the top of the photo down, each where its label would start */
      var want = data.map(function (c, i) {
        var w = j.sizes[i][0], h = j.sizes[i][1], a = A[i], x, y, alt;
        if (c.lx != null) {
          var L = [c.lx * IW - sx, c.ly * IH - sy];
          if (c.al === 'right') { x = L[0] - w - 2; y = L[1] - h / 2; alt = a[0] + 14; }
          else if (c.al === 'center') { x = L[0] - w / 2; y = L[1] - h; alt = a[0] + 14; }
          else { x = L[0] + 2; y = L[1] - h / 2; alt = a[0] - 14 - w; }
        } else {
          x = a[0] + 14; y = a[1] - h / 2; alt = a[0] - 14 - w;
          if (x + w > W - CO_P) { var t = x; x = alt; alt = t; }
        }
        return { i: i, w: w, h: h, x: x, y: y, alt: alt };
      }).sort(function (m, n) { return m.y - n.y; });
      var pos = [];
      want.forEach(function (m) {
        var best = null, xs = [m.x, m.alt];
        for (var k = 0; k < xs.length && !best; k++) {
          var x = clampX(xs[k], m.w);
          for (var s = 0; s <= H && !best; s += 6) {
            var y1 = clampY(m.y + s, m.h), y2 = clampY(m.y - s, m.h);
            if (!hit(x, y1, m.w, m.h)) best = [x, y1];
            else if (!hit(x, y2, m.w, m.h)) best = [x, y2];
          }
        }
        if (!best) best = [clampX(m.x, m.w), clampY(m.y, m.h)];
        placed.push([best[0], best[1], m.w, m.h]);
        pos[m.i] = best;
      });
      /* write: the chips, then the leaders and the dots */
      var svg = '';
      qa('.gcls-ex__chip', j.layer).forEach(function (el, i) {
        var p = pos[i], a = A[i], w = j.sizes[i][0], h = j.sizes[i][1];
        el.style.width = j.sizes[i][2] ? w + 'px' : '';
        el.style.transform = 'translate(' + Math.round(p[0]) + 'px,' + Math.round(p[1]) + 'px)';
        var x0 = p[0], x1 = p[0] + w, y0 = p[1], y1 = p[1] + h, cy = (y0 + y1) / 2, pts;
        if (a[0] >= x0 + 6 && a[0] <= x1 - 6) pts = [a, [a[0], a[1] < y0 ? y0 : y1]];
        else {
          var ex = a[0] < x0 ? x0 : x1;
          pts = a[1] >= y0 + 4 && a[1] <= y1 - 4 ? [a, [ex, a[1]]] : [a, [a[0], cy], [ex, cy]];
        }
        svg += '<polyline points="' + pts.map(function (pt) { return Math.round(pt[0] * 2) / 2 + ',' + Math.round(pt[1] * 2) / 2; }).join(' ') + '"/>';
      });
      A.forEach(function (a) { svg += '<circle cx="' + Math.round(a[0] * 2) / 2 + '" cy="' + Math.round(a[1] * 2) / 2 + '" r="3.5"/>'; });
      var sv = q('.gcls-ex__cosvg', j.layer);
      if (sv) sv.innerHTML = svg;
    });
  }
  var coT = 0;
  function coSoon() { clearTimeout(coT); coT = setTimeout(coLayout, 60); }
  if (elPhotos && SLIDES.length) {
    if ('ResizeObserver' in window) new ResizeObserver(coSoon).observe(elPhotos); else window.addEventListener('resize', coSoon, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(coSoon);
  }
  function decoded(el) {
    var ims = slideImgs(el).filter(function (im) { return im.getClientRects().length || im.closest('[data-gcls-slide]'); });
    return Promise.all(ims.map(function (im) {
      if (im.complete && im.naturalWidth) return im.decode ? im.decode().catch(function () {}) : null;
      return new Promise(function (r) { im.addEventListener('load', r, { once: true }); im.addEventListener('error', r, { once: true }); }).then(function () { return im.decode ? im.decode().catch(function () {}) : null; });
    }));
  }
  var viewTok = 0;
  function setView(v, slideIdx) {
    if (v === 'photos' && !SLIDES.length) v = 'set';
    if (v !== 'set' && edOpen) closeEd(false);
    var was = S.view;
    S.view = v;
    pressView(v);
    var tok = ++viewTok;
    if (v === 'set') {
      if (elGallery && elGallery.getAttribute('data-view') !== 'set') elGallery.setAttribute('data-view', 'set');
      if (elStage) elStage.removeAttribute('aria-hidden');
      if (elPhotos && phWarm) { elPhotos.classList.remove('is-on'); elPhotos.classList.add('is-off'); }
      else if (elPhotos && !phWarm) elPhotos.hidden = true;
      markThumb(); zoomState();
      phNotify();
      return;
    }
    /* Photos: the answer to the click is the thumb and the pressed state (above); the rest after that frame */
    markThumbTo(slideIdx);
    afterPaint(function () {
      if (tok !== viewTok) return;
      warmPhotos();
      var s = curSlides(), i = 0;
      if (slideIdx != null) s.forEach(function (el, k) { if (el.getAttribute('data-gcls-slide') === String(slideIdx)) i = k; });
      else if (was === 'photos' || phIdx != null) s.forEach(function (el, k) { if (el.getAttribute('data-gcls-slide') === String(phIdx)) i = k; });
      if (was === 'photos' && elPhotos.classList.contains('is-on')) { glideTo(i, 380); return; }
      jumpTo(i);
      eagerSlide(s[i]); eagerSlide(s[i + 1]); eagerSlide(s[i - 1]);
      var shown = false;
      function show() {
        if (shown || tok !== viewTok) return;
        shown = true;
        requestAnimationFrame(function () {
          if (tok !== viewTok) return;
          if (elGallery) elGallery.setAttribute('data-view', 'photos');
          if (elStage) elStage.setAttribute('aria-hidden', 'true');
          elPhotos.classList.remove('is-off'); elPhotos.classList.add('is-on');
          markThumb(); zoomState();
          /* the slide shown (and its neighbors) get their videos now that the panel is seen */
          around(phAt(elPhTrack.scrollLeft));
          phNotify();
        });
      }
      decoded(s[i]).then(show, show);
      setTimeout(show, 700);
    });
  }
  function markThumbTo(slideIdx) {
    if (slideIdx != null) phIdx = String(slideIdx);
    else if (phIdx == null) { var s0 = curSlides()[0]; phIdx = s0 ? s0.getAttribute('data-gcls-slide') : null; }
    markThumb();
  }
  if (elPhotos && SLIDES.length) {
    /* laid out ahead: when the page is idle after load, or as soon as the pointer or focus comes near */
    var warmSoon = function () { warmPhotos(); };
    window.addEventListener('load', function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1500); })(warmSoon, { timeout: 4000 }); });
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (t) {
      [elToggle, elThumbs].forEach(function (el) { if (el) el.addEventListener(t, warmSoon, { passive: true, once: true }); });
    });
  }

  /* ---------- Photos: the swipe (the product page gallery's feel) ----------
     The photos sit on one track that follows the finger or mouse 1:1, so two
     neighbors show while it moves (hold halfway and see both). On release it
     settles on the next photo when it moved past 35% of the width or was
     flicked (fast at the end, or a short swipe over in under 280 ms), with an
     ease-out (about 380 ms); otherwise it springs back. Its
     ends stretch a little (rubber band). Vertical page scrolling stays
     native (touch-action: pan-y; the axis is decided after 8 px). A tap still
     plays or pauses a video. The chevrons and thumbnails glide the same
     track; the photos next to the one shown are loaded ahead. Right to left
     too (the track's scroll offsets run negative). Native snapping is off
     only while the track moves. */
  var SW = { anim: 0, st: null, band: 0, target: null, endT: 0 };
  function phW() { return elPhTrack.clientWidth || 1; }
  function phRtl() { return getComputedStyle(elPhTrack).direction === 'rtl'; }
  function phPos(i) { return (phRtl() ? -1 : 1) * i * phW(); }
  function phAt(left) { return Math.round(Math.abs(left) / phW()); }
  function snapOff(on) { if (on) elPhTrack.style.setProperty('scroll-snap-type', 'none', 'important'); else elPhTrack.style.removeProperty('scroll-snap-type'); }
  function band(px) { SW.band = px; elPhTrack.style.transform = Math.abs(px) > .2 ? 'translate3d(' + px.toFixed(1) + 'px,0,0)' : ''; }
  function stopGlide() { if (SW.anim) { cancelAnimationFrame(SW.anim); SW.anim = 0; } }
  function around(i) { var s = curSlides(); eagerSlide(s[i]); eagerSlide(s[i + 1]); eagerSlide(s[i - 1]); }
  function jumpTo(i) { stopGlide(); snapOff(true); elPhTrack.scrollLeft = phPos(i); band(0); settle(i); }
  function glideTo(i, dur) {
    var n = curSlides().length;
    i = Math.max(0, Math.min(n - 1, i));
    stopGlide();
    SW.target = i;
    around(i);
    var from = elPhTrack.scrollLeft, to = phPos(i), b0 = SW.band;
    if (REDUCED) dur = Math.min(dur, 120);
    if (Math.abs(to - from) < 1 && Math.abs(b0) < 1) { jumpTo(i); return; }
    snapOff(true);
    var t0 = performance.now();
    function step(now) {
      var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      elPhTrack.scrollLeft = from + (to - from) * e;
      band(b0 * (1 - e));
      if (p < 1) { SW.anim = requestAnimationFrame(step); return; }
      SW.anim = 0; elPhTrack.scrollLeft = to; band(0); settle(i);
    }
    SW.anim = requestAnimationFrame(step);
  }
  function settle(i) {
    SW.target = null;
    snapOff(false);
    var el = curSlides()[i];
    if (el) { phIdx = el.getAttribute('data-gcls-slide'); markThumb(); zoomState(); }
  }
  if (elPhTrack && elPhotos) {
    elPhTrack.style.scrollBehavior = 'auto';
    elPhTrack.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* in the capture phase on the panel: the kit's own mouse drag on this track stays out */
    elPhotos.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0) || !elPhTrack.contains(e.target)) return;
      if (e.target.closest('a[href], button, [data-gcls-vbtn]')) return;
      e.stopPropagation();
      var busy = !!SW.anim;
      stopGlide();
      SW.st = { id: e.pointerId, x: e.clientX, y: e.clientY, left: elPhTrack.scrollLeft - 0, b: SW.band, on: false, dead: false, busy: busy, pts: [[e.timeStamp, e.clientX]], pts0: e.timeStamp };
      if (busy) { SW.st.on = true; snapOff(true); try { elPhTrack.setPointerCapture(e.pointerId); } catch (x) {} }
    }, true);
    elPhotos.addEventListener('pointermove', function (e) {
      var st = SW.st;
      if (!st || e.pointerId !== st.id || st.dead) return;
      var dx = e.clientX - st.x, dy = e.clientY - st.y;
      if (!st.on) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) >= Math.abs(dx)) { st.dead = true; return; }
        st.on = true;
        snapOff(true);
        elPhotos.classList.add('is-dragging');
        try { elPhTrack.setPointerCapture(e.pointerId); } catch (x) {}
      }
      if (e.cancelable) e.preventDefault();
      st.pts.push([e.timeStamp, e.clientX]);
      while (st.pts.length > 2 && e.timeStamp - st.pts[0][0] > 100) st.pts.shift();
      var W = phW(), n = curSlides().length, rtl = phRtl();
      var lo = rtl ? -(n - 1) * W : 0, hi = rtl ? 0 : (n - 1) * W;
      var want = st.left - st.b - dx, over = 0;
      if (want < lo) { over = lo - want; want = lo; } else if (want > hi) { over = hi - want; want = hi; }
      elPhTrack.scrollLeft = want;
      /* past an end the track stretches, a third as far as the finger and less the farther it goes */
      band(over ? (over > 0 ? 1 : -1) * W * .33 * (1 - 1 / (Math.abs(over) / W * 1.2 + 1)) : 0);
    }, { passive: false });
    function swEnd(e) {
      var st = SW.st;
      if (!st || e.pointerId !== st.id) return;
      SW.st = null;
      elPhotos.classList.remove('is-dragging');
      if (!st.on) return;
      SW.endT = performance.now();
      var W = phW(), rtl = phRtl(), dx = e.clientX - st.x;
      var p0 = st.pts[0], p1 = st.pts[st.pts.length - 1], dt = Math.max(1, p1[0] - p0[0]), v = (p1[1] - p0[1]) / dt;
      var i = phAt(st.left - st.b), dir = 0;
      /* past 35%, or a flick: fast at the end, or a short swipe over in under 280 ms */
      var quick = e.timeStamp - st.pts0 < 280 && Math.abs(dx) > Math.max(24, .06 * W);
      if (e.type !== 'pointercancel' && (Math.abs(dx) > .35 * W || quick || (Math.abs(v) > .3 && Math.abs(dx) > 12 && (v > 0) === (dx > 0)))) dir = (dx < 0) !== rtl ? 1 : -1;
      if (st.busy && !dir && Math.abs(dx) < 8) i = phAt(elPhTrack.scrollLeft);
      var left = Math.abs(dx) / W;
      glideTo(i + dir, dir ? Math.round(Math.max(240, Math.min(420, 420 * (1 - left) + 140))) : 320);
    }
    elPhotos.addEventListener('pointerup', swEnd);
    elPhotos.addEventListener('pointercancel', swEnd);
    /* only the track's own capture ending (a touch's implicit capture on the photo moving to the track bubbles here too) */
    elPhTrack.addEventListener('lostpointercapture', function (e) { if (e.target === elPhTrack && SW.st && SW.st.on && e.pointerId === SW.st.id) swEnd(e); });
    /* a drag is not a tap: the click that ends it opens nothing */
    elPhotos.addEventListener('click', function (e) { if (performance.now() - SW.endT < 350) { e.preventDefault(); e.stopPropagation(); } }, true);
    /* the chevrons glide the same track (before the kit's own scroll) */
    var phRow = elPhotos.querySelector('[data-gcx-scroll]');
    if (phRow) phRow.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.gcx-chev') : null;
      if (!c || c.parentNode !== phRow) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var i = SW.target != null ? SW.target : phAt(elPhTrack.scrollLeft);
      glideTo(i + (c.classList.contains('gcx-chev--prev') ? -1 : 1), 380);
    }, true);
    /* the keyboard on the track: one photo per arrow, gliding */
    elPhTrack.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target !== elPhTrack) return;
      e.preventDefault();
      var fwd = (e.key === 'ArrowRight') !== phRtl();
      var i = SW.target != null ? SW.target : phAt(elPhTrack.scrollLeft);
      glideTo(i + (fwd ? 1 : -1), 380);
    });
  }

  /* ---------- rendering: price chip, saving line, summary ---------- */
  /* one line of the summary: the name, a sub-line (color, model), the price
     checkout charges for it, and when the automatic discount takes something
     off, the list price struck through and the rate */
  function sline(name, sub, val, was, off, rm, rmLabel) {
    return '<li class="gcls-line' + (rm ? ' has-rm' : '') + '"><span class="gcls-line__k"><span class="gcls-line__n">' + esc(name) + '</span>' + (sub ? '<small class="gcls-line__sub">' + esc(sub) + '</small>' : '') + '</span>' +
      '<span class="gcls-line__v">' + (was ? '<s class="gcls-line__was" aria-hidden="true">' + esc(was) + '</s>' : '') + '<bdi class="gcls-line__p">' + esc(val) + '</bdi>' +
      (off ? '<span class="gcls-line__off">' + esc(off) + '</span>' : '') + '</span>' +
      (rm ? '<button type="button" class="gcls-line__x" data-gcls-lrm="' + esc(rm) + '" aria-label="' + esc(rmLabel || '') + '" title="' + esc(rmLabel || '') + '"><svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' : '') + '</li>';
  }
  /* the X on a summary line: what takes that piece out (the same as unticking it), when the page lets it go */
  function lineRm(it) {
    if (it.extra) return 'ex:' + it.p.key;
    var c = cur().core.filter(function (z) { return z.kind === it.kind; })[0];
    return c && c.on && !c.why ? 'core:' + c.slot : '';
  }
  function rmLabel(it) { return tpl(T.rmLine || T.removePiece || '', { piece: pMid(it.p) }); }
  /* the cheapest more-piece in stock that the discount counts */
  function suggestion() {
    var best = null, bestV = null;
    morePieces().forEach(function (m) {
      var p = m.p;
      if (S.ex[p.key]) return;
      var v = pickV(p, defaultCol(p));
      if (v && v.avail && eligId(p.id, p.ty) && (!bestV || v.price < bestV.price)) { best = p; bestV = v; }
    });
    return best ? { p: best, v: bestV } : null;
  }
  /* The price under the title and the sticky bar's price are the summary's total (owner, 9 Oct 2026: the price
     did not follow the initials): the pieces after the automatic discount, plus the initials, the screen
     protector, gift packaging and priority processing once chosen. The struck price is that total before the set
     discount; the "-N%" chip is measured against it. With nothing extra chosen it is the pieces' price, as before. */
  function chipState() {
    var o = cur(), t = totals();
    return { from: o.needModel, price: t.total, cmp: t.disc > 0 ? t.total + t.disc : 0, n: t.pieces.length, lg: t.logo || 0 };
  }
  /* floored, as the PDP badge and the cart (owner, Oct 2026: never overstate a saving). Multiplied first, so an
     exact rate stays exact: 2900 / 10000 * 100 is 28.999999999999996 in floating point, 100 * 2900 / 10000 is 29 */
  function pctOf(part, whole) { return num(Math.floor(100 * part / whole)); }
  function saveText(t) {
    var d = t.d || {};
    if (!t.pieces.length) return '';
    if (d.kind === 'pct' && t.piecesCut > 0) return P(T.saveOn, d.eligHere, { rate: num(RATE) });
    if (d.kind === 'bx' && t.piecesCut > 0) {
      var u = d.units[0], it = u && u.it;
      return tpl(T.saveBx, { piece: it ? pMid(it.p) : '', amount: money(t.piecesCut), rate: num(RATE) });
    }
    if (d.need > 0 && RATE > 0) return P(T.saveAdd, d.need, { rate: num(RATE) });
    return '';
  }
  function renderPrice() {
    var c = chipState(), t = totals();
    var chip = q('[data-gcls-chip]');
    var amt = c.n ? money(c.price) : '—';
    var gx = G();
    if (chip) {
      if (gx && gx.priceChip) gx.priceChip(chip, amt, !!c.from && !!c.n);
      else setText(q('[data-gcx-chip-amt]', chip), amt);
    }
    var lst = q('[data-gcls-pricelist]');
    var cmp = q('[data-gcls-cmp]', lst), tok = q('.gcx-price-save', lst);
    if (c.cmp > c.price) {
      if (!cmp) { cmp = document.createElement('s'); cmp.className = 'gcx-price-compare'; cmp.setAttribute('data-gcls-cmp', ''); lst.appendChild(cmp); }
      cmp.innerHTML = '<span class="gcx-sr">' + esc(T.was || T.lineSeparately) + ' </span>' + esc(money(c.cmp));
      cmp.hidden = false;
      if (!tok) { tok = document.createElement('span'); tok.className = 'gcx-price-save'; lst.appendChild(tok); }
      /* the set's "-N%" leaves the Minimalist logo's $25 out (owner, Oct 2026): it is not part of what the set discount
         is taken from */
      setText(tok, tpl(T.offChip, { pct: pctOf(c.cmp - c.price, c.cmp - c.lg) }));
      tok.hidden = false;
    } else {
      if (cmp) cmp.hidden = true;
      if (tok) tok.hidden = true;
    }
    var sl = q('[data-gcls-saveline]');
    var txt = saveText(t);
    setText(sl, txt);
    if (sl) sl.hidden = !txt;
  }

  function renderSummary() {
    changed();
    var o = cur(), t = totals();
    var cart = S.cart || { elig: 0 };
    var d = t.d || {};
    var k = T.modeOwnK, ti = '', tx = '', h = '';
    ti = o.items.length ? P(T.modeOwnT, o.items.length) : T.choosePieces;
    if (o.items.length) {
      if (d.kind === 'pct' && t.disc > 0) tx = tpl(T.modeOwnOn, { rate: num(RATE) });
      else if (d.kind === 'bx' && t.disc > 0) {
        var u = d.units[0];
        tx = tpl(T.modeBx, { piece: u && u.it ? pMid(u.it.p) : '', rate: num(RATE) });
      } else if (d.need > 0) {
        tx = P(T.modeOwnFew, d.eligN, { min: num(MIN), rate: num(RATE) });
        var sg = suggestion();
        if (sg && d.need === 1) tx = join2(tx, tpl(T.modeOwnSuggest, { piece: pMid(sg.p), price: money(sg.v.price, true), rate: num(RATE) }));
      }
      if (cart.elig > 0) tx = join2(tx, P(T.modeInBag, cart.elig, { min: num(MIN) }));
    }
    var needs = needsModel();
    (t.U || []).forEach(function (u) {
      var cut = u.cut || 0, net = u.price - cut;
      var was = cut > 0 ? money(u.price) : '', off = cut > 0 ? tpl(T.offChip, { pct: pctOf(cut, u.price) }) : '';
      if (u.prot) { h += sline(T.lineProt, MN(S.device), money(net), was, off, 'prot', tpl(T.rmLine || '', { piece: T.lineProt })); return; }
      var it = u.it, sub = [colorLabel(it.p, it.ck), it.kind === 'case' && !it.extra && S.device ? MN(S.device) : ''].filter(Boolean).join(' · ');
      var val = it.from ? tpl(T.fromPriceLc, { price: money(net) }) : money(net);
      h += sline(pName(it.p), sub, val, was, off, lineRm(it), rmLabel(it));
    });
    /* the add-ons and the initials have their X too (owner, 30 Sep 2026): it unticks the add-on (clears the
       initials), as its own control does; gift packaging that the cart already carries cannot be taken off here */
    if (t.fee) h += sline(tpl(T.lineInitials, { initials: cleanIni(S.ini) }), '', money(t.fees), '', '', 'ini', T.rmIni || T.removePiece || '');
    if (t.logo) h += sline(LT.line || '', '', money(t.logo), '', '', 'logo', LT.rm || T.removePiece || '');
    if (t.gift) h += sline(P(T.lineGift, t.giftUnits), '', money(t.gift), '', '', t.giftForced ? '' : 'gift', T.rmGift || T.removePiece || '');
    if (t.prio) h += sline(T.linePrio, '', money(t.prio), '', '', 'prio', T.rmPrio || T.removePiece || '');
    setText('[data-gcls-mode-title]', ti);
    /* without a model the case (and so the total) is its lowest price in its color: "from" */
    if (needs) tx = T.sumWait;
    setText('[data-gcls-mode-text]', tx);
    setHTML(q('[data-gcls-lines]'), h);
    setText('[data-gcls-total]', !o.items.length ? '—' : needs ? tpl(T.fromPrice, { price: money(t.total) }) : money(t.total));
    var saveTpl = T.totalSave || (T.lineSave + ' {amount}');
    setText('[data-gcls-totalsub]', needs || !t.disc ? '' : tpl(saveTpl, { amount: money(t.disc) }));

    renderBadge(o, t);
    renderAddons(t);
    renderReward(t);
    renderPrice();
    renderInsetTotal();
    renderAtc();
    renderSticky();
    announcePieces(o);
  }

  function renderReward(t) {
    var el = q('[data-gcls-rewardtext]');
    if (!el || !D.rewards || !D.rewards.length) return;
    var rw = D.rewards.slice().sort(function (a, b) { return a.at - b.at; })[0];
    var basis = cur().items.length ? t.basis : ((S.cart && S.cart.orig) || 0);
    var txt = needsModel() ? tpl(T.rewardInfo, { at: money(rw.at, true), label: rw.label }) : basis >= rw.at ? tpl(T.rewardIn, { at: money(rw.at, true), label: rw.label }) :
      tpl(T.rewardAway, { at: money(rw.at, true), label: rw.label, amount: money(rw.at - basis, true) });
    setText(el, txt);
  }

  function renderAtc() {
    if (!elAdd) return;
    var n = cur().items.length;
    elAdd.classList.toggle('gcls-atc--wait', S.busy);
    elAdd.setAttribute('aria-disabled', !n ? 'true' : 'false');
  }

  /* gc-mobile-sticky.js presses the main button whatever the sticky shows:
     without a model yet, this page answers the press itself (model list) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cust-sticky-btn, #sticky-add-to-cart-bar [data-sticky-add-to-cart]');
    if (!b) return;
    if (needsModel()) {
      e.preventDefault();
      e.stopPropagation();
      report({ m: T.chooseDevice, el: elDevBtn, model: true });
    }
  }, true);

  function renderSticky() {
    var gx = G();
    if (!gx || !gx.setSticky) return;
    var o = cur(), c = chipState();
    var c0 = o.caseRow || o.core[0];
    var img = c0 ? sized(lgPhoto(pieceImg(c0)), 120) : '';
    gx.setSticky({
      title: D.set.t,
      options: needsModel() ? [] : captionParts(o),
      price: c.price,
      from: !!c.from,
      fromTpl: T.fromPrice,
      compareAt: c.cmp > c.price ? c.cmp : null,
      image: img,
      imageAlt: '',
      available: true,   /* no piece left: "Add to Cart", and a press glides to the pieces (not "Sold out") */
      needsSelection: needsModel(),
      selectLabel: T.chooseModel
    });
  }
  var stickyT = 0;
  function stickyAgain() { clearTimeout(stickyT); stickyT = setTimeout(renderSticky, 140); }

  /* ---------- rendering: what's in the set ---------- */
  /* WHAT'S IN THE SET: exactly the pieces in the shopper's set, in the
     summary's order, live (a piece taken out leaves the row, a "more" piece
     added joins it with its own photo, title and list price) */
  function renderInset() {
    var wrap = q('[data-gcls-inset]');
    if (!wrap) return;
    var o = cur(), list = q('[data-gcls-insetlist]', wrap);
    var want = [];
    o.items.forEach(function (it) {
      var card = null;
      if (it.extra) {
        card = q('[data-gcls-piece-ex="' + it.p.key + '"]', wrap);
        if (!card) {
          card = document.createElement('article');
          card.className = 'gcls-piece gcls-piece--ex';
          card.setAttribute('role', 'listitem');
          card.setAttribute('data-gcls-piece-ex', it.p.key);
          card.innerHTML = '<div class="gcls-piece__img"><img data-gcls-pieceimg alt="" width="480" height="480" loading="lazy" decoding="async"></div>' +
            '<h3 class="gcls-piece__name"></h3><p class="gcls-piece__title" data-gcls-piecetitle></p>' +
            '<p class="gcls-piece__price"><span class="gcls-piece__plabel"></span> <b data-gcls-pieceprice></b></p>';
          var lab = q('.gcls-piece__plabel', wrap);
          if (lab) card.querySelector('.gcls-piece__plabel').textContent = lab.textContent;
        }
        setText(card.querySelector('.gcls-piece__name'), pName(it.p));
      } else card = q('[data-gcls-piece="' + it.kind + '"]', wrap);
      if (!card) return;
      want.push(card);
      card.hidden = false;
      /* the set's case as the Minimalist logo shows it (Oct 2026) */
      var im = q('[data-gcls-pieceimg]', card), img = it.extra ? pieceImg(it) : lgPhoto(pieceImg(it));
      if (im && img) { var u = sized(img, 600); if (im.getAttribute('src') !== u) im.setAttribute('src', u); im.alt = it.p.t; }
      setText(q('[data-gcls-piecetitle]', card), it.p.t + ' · ' + colorLabel(it.p, it.ck));
      setText(q('[data-gcls-pieceprice]', card), it.v ? (it.from ? tpl(T.fromPriceLc, { price: money(it.v.price) }) : money(it.v.price)) : whyText(it));
    });
    if (list) {
      /* the set's order; everything else leaves the row (the server's kinds stay, hidden, for the next set) */
      qa('[data-gcls-piece], [data-gcls-piece-ex]', list).forEach(function (c) { if (want.indexOf(c) === -1) { if (c.hasAttribute('data-gcls-piece-ex')) c.remove(); else c.hidden = true; } });
      var kids = Array.prototype.slice.call(list.children).filter(function (c) { return !c.hidden; });
      var same = kids.length === want.length && kids.every(function (c, i) { return c === want[i]; });
      if (!same) want.forEach(function (c) { list.appendChild(c); });
    }
    renderInsetTotal();
  }
  /* Its totals are the summary's numbers, as the price under the title (owner, 9 Oct 2026): "At checkout" is the
     summary's total with the initials and the extras chosen, "Bought separately" that total before the set
     discount. renderSummary redraws them on every change (the cards above only change with the pieces). */
  function renderInsetTotal() {
    var tot = q('[data-gcls-insettotal]');
    if (!tot) return;
    var o = cur(), t = totals();
    tot.hidden = !t.pieces.length;
    if (!t.pieces.length) return;
    var sep = t.total + t.disc;
    setText(q('[data-gcls-insetlist-total]', tot), money(sep));
    setText(q('[data-gcls-insetset]', tot), money(t.total));
    setText(q('[data-gcls-insetsave]', tot), t.disc > 0 ? tpl(T.insetSave, { save: money(t.disc), pct: pctOf(t.disc, sep - (t.logo || 0)) }) : '—');
    setText(q('[data-gcls-insetfor]', tot), S.device ? tpl(T.insetFor, { device: MN(S.device) }) : (o.caseRow && o.caseRow.v ? tpl(T.insetFrom, { device: MN(o.caseRow.v.mk) }) : ''));
  }

  /* ---------- low stock: true stock only (snippets/gcx-batch) ---------- */
  var elBatch = q('[data-gcls-batch]'), elBatchOut = q('[data-gcls-batch-out]');
  function renderBatch() {
    var g = G();
    /* the per-piece notes say what is out; the set-level lines stay quiet */
    if (elBatch && g && g.batch) g.batch(elBatch, false);
    if (elBatchOut && g && g.batchOut) g.batchOut(elBatchOut, { show: false, text: '', pick: null });
  }

  /* The rating next to the price: the published Rapid Reviews ratings of the
     pieces in the set right now (the app's own counts per product, as the
     reviews section below sums them), so both say the same. Never structured
     data (data-nosnippet). Hidden while no piece in the set has a review. */
  var elRating = q('[data-gcls-rating]');
  function avgText(a) {
    var s = (Math.round(a * 10) / 10).toFixed(1);
    return /^(de|fr|es|it|nl|pt|da|no|nb|fi|sv|el)\b/.test(lang()) ? s.replace('.', ',') : s;
  }
  function renderTopRating(ps) {
    if (!elRating) return;
    /* review rollup (gcx.review_rollup, owner decision 1 Oct 2026): the server chip shows the rollup, the same
       rating and count as the Product JSON-LD and the reviews section; it does not follow the shopper's pieces */
    if (elRating.querySelector('.gcx-rating[data-gcx-fixed]')) { elRating.hidden = false; return; }
    var n = 0, sum = 0, names = [];
    ps.forEach(function (p) { if (p.rc > 0 && p.rs > 0) { n += p.rc; sum += p.rs; names.push(p.title + ' (' + num(p.rc) + ')'); } });
    if (!n) { elRating.hidden = true; return; }
    var a = sum / n, as = avgText(a);
    /* the server already drew these same numbers: keep its chip */
    var srv = elRating.querySelector('.gcx-rating');
    if (srv && !elRating.hasAttribute('data-drawn') && srv.getAttribute('data-gcx-count') === String(n) && srv.getAttribute('data-gcx-rating') === (Math.round(a * 10) / 10).toFixed(1)) {
      elRating.setAttribute('data-drawn', '');
      elRating.hidden = false;
      return;
    }
    var txt = tpl(n === 1 && T.ratingOne ? T.ratingOne : (T.rating || '[count]'), { count: num(n), avg: as });
    var h = '<a class="gcx-rating" href="' + esc(T.ratingUrl || '#gcls-reviews') + '" data-nosnippet data-gcx-rating="' + (Math.round(a * 10) / 10).toFixed(1) + '" data-gcx-avg="' + esc(as) + '" data-gcx-count="' + n + '" title="' + esc(tpl(T.ratingTip, { avg: as, count: num(n), list: names.join('; ') })) + '">' +
      '<span class="gcx-stars" style="--gcx-pct:' + (Math.round(a * 10) / 10 * 20) + '%" role="img" aria-label="' + esc(tpl(T.ratingAria, { avg: as })) + '"></span>' +
      '<span class="gcx-rating__txt"><span class="gcx-rating__val">' + esc(as) + '</span> <span class="gcx-rating__dot" aria-hidden="true">·</span> ' + esc(txt) + '</span></a>';
    if (elRating.getAttribute('data-sig') !== h) {
      elRating.innerHTML = h;
      elRating.setAttribute('data-sig', h);
      /* no entrance animation when only the numbers change */
      var r = elRating.firstChild; if (r && elRating.hasAttribute('data-drawn')) r.style.animation = 'none';
      elRating.setAttribute('data-drawn', '');
    }
    elRating.hidden = false;
  }

  /* the reviews section (sections/gcls-reviews) follows the pieces in the set */
  var piecesSig = '';
  function announcePieces(o) {
    var ps = o.items.map(function (it) { return { id: it.p.id, kind: it.kind, name: pName(it.p), mid: pMid(it.p), title: it.p.t, url: it.p.u, rc: it.p.rc, rs: it.p.rs }; });
    var sig = ps.map(function (p) { return p.id; }).join(',');
    if (sig === piecesSig) return;
    piecesSig = sig;
    window.__gclsPieces = ps;
    renderTopRating(ps);
    try { document.dispatchEvent(new CustomEvent('gcls:pieces', { detail: { pieces: ps } })); } catch (e) {}
  }

  var ready = false;
  function render() {
    changed();
    /* a change while the photos are shown: back to "Your set", so the change is seen */
    if (ready && S.view === 'photos') setView('set');
    renderLeathers();
    renderColors();
    renderDevices();
    renderPieces();
    renderInitials();
    renderStage();
    orderSlides();
    renderThumbs();
    renderInset();
    renderSummary();
    renderBatch();
    renderSteps();
    writeUrl();
  }

  /* ---------- the address: written only after the shopper changes something ---------- */
  var urlT = null;
  /* the builder's own parameters (feed and campaign parameters such as currency, country or utm_* stay) */
  var URLKEYS = ['variant', 'leather', 'color', 'colour', 'device', 'without', 'add', 'initials', 'gift', 'pick', 'pc', 'logo'];
  function touch() { S.touched = true; }
  /* analytics (assets/gc-track.js, docs/analytics/events-2026-10-04): one gc:track DOM event per step */
  function gcT(d) { try { document.dispatchEvent(new CustomEvent('gc:track', { detail: d })); } catch (e) {} }
  function writeUrl() {
    if (!S.touched) return;
    clearTimeout(urlT);
    urlT = setTimeout(function () {
      try {
        var u = new URL(window.location.href);
        URLKEYS.forEach(function (k) { u.searchParams.delete(k); });
        u.searchParams.set('leather', S.leather);
        u.searchParams.set('color', S.color);
        if (S.device) u.searchParams.set('device', S.device);
        var l = L();
        if (S.pick === 'wallet' && l.core.wallet) u.searchParams.set('pick', 'wallet');
        var inCore = {};
        cur().core.forEach(function (c) { inCore[c.kind] = 1; });
        var pcs = Object.keys(S.pc).filter(function (k) { return S.pc[k] && S.pc[k] !== FAM() && inCore[k]; }).map(function (k) { return k + ':' + S.pc[k]; });
        if (pcs.length) u.searchParams.set('pc', pcs.join(','));
        var without = SLOTS.filter(function (k) { return S.off[k]; });
        if (without.length) u.searchParams.set('without', without.join(','));
        var add = Object.keys(S.ex).map(function (key) {
          var p = ALL[key]; if (!p || p.leather !== S.leather) return '';
          return p.id + (S.ex[key].col ? ':' + S.ex[key].col : '');
        }).filter(Boolean);
        if (add.length) u.searchParams.set('add', add.join(','));
        if (cleanIni(S.ini)) u.searchParams.set('initials', cleanIni(S.ini));
        if (S.gift) u.searchParams.set('gift', '1');
        if (logoOn()) u.searchParams.set('logo', '1');
        var nu = u.pathname + u.search + u.hash;
        if (nu !== window.location.pathname + window.location.search + window.location.hash) history.replaceState(history.state, '', nu);
      } catch (e) {}
    }, 250);
  }
  function same(a, b) { return !!a && !!b && a === b; }
  function findLeather(x) {
    var s = slug(x);
    if (!s) return null;
    var ks = Object.keys(SCOLORS);
    for (var i = 0; i < ks.length; i++) { var k = ks[i]; if (same(s, k) || same(s, slug(LN(k)))) return k; }
    for (var j = 0; j < ks.length; j++) if (s.indexOf(ks[j] + '-') === 0) return ks[j];
    return null;
  }
  function findColor(lk, x) {
    var s = slug(x);
    if (!s) return null;
    var cs = SCOLORS[lk] || [];
    var s2 = s.replace(/^glossy-/, '').replace('grey', 'gray');
    for (var i = 0; i < cs.length; i++) {
      var k = cs[i], c = (D.set.C || {})[k] || {};
      if (same(s, k) || same(s2, k) || same(s2, c.f) || same(s, slug(c.n)) || same(s, slug(c.en))) return k;
    }
    return null;
  }
  function findDevice(x) {
    var s = slug(x);
    if (!s) return null;
    var ks = Object.keys(D.set.M || {});
    for (var i = 0; i < ks.length; i++) if (same(s, ks[i]) || same(s, slug(MN(ks[i]))) || same(s, slug((D.set.M[ks[i]] || {}).en))) return ks[i];
    return null;
  }
  function pieceColor(p, x) {
    var s = slug(x);
    if (!s) return null;
    var s2 = s.replace(/^glossy-/, '').replace('grey', 'gray');
    for (var i = 0; i < p.colors.length; i++) {
      var c = p.colors[i];
      if (same(s, c.key) || same(s2, c.key) || same(s, slug(c.val))) return c.key;
    }
    return null;
  }
  /* bare: read no parameter at all, i.e. the page as it opens without a choice ("Add & build another set") */
  function readUrl(bare) {
    var u;
    try { u = new URL(window.location.href); } catch (e) { return; }
    var sp = bare ? new URL(u.origin + u.pathname).searchParams : u.searchParams;
    var vid = +sp.get('variant');
    var v = null;
    if (vid) v = SV.filter(function (x) { return x.id === vid; })[0] || null;
    /* bare: the page without a choice (D.set.def, worked out by the server on every page), never the variant a
       ?variant= link (the Google Shopping landing) opened on, which is D.set.sel there */
    var bdef = bare && D.set.def ? SV.filter(function (x) { return x.id === D.set.def; })[0] || null : null;
    if (!v) v = bdef || SV.filter(function (x) { return x.id === D.set.sel; })[0] || SV[0];
    S.leather = v.lk; S.color = v.ck;
    var l = sp.get('leather'), c = sp.get('color') || sp.get('colour'), d = sp.get('device');
    /* the page without a choice opens on the newest model (D.set.defDev: the variant the server chose, gcls-set.liquid) */
    if (bdef) S.device = v.mk;
    else if ((vid && v.id === vid) || (!vid && (D.set.hasSel || (D.set.defDev && !l)) && v.id === D.set.sel)) S.device = v.mk;
    if (!vid && l) {
      var lk = findLeather(l);
      if (lk) {
        S.leather = lk;
        S.color = (c && findColor(lk, c)) || bestColor(lk);
      }
    } else if (!vid && c) {
      var cm2 = findColor(S.leather, c);
      if (cm2) S.color = cm2;
    }
    if (!vid && d) { var dk = findDevice(d); if (dk) S.device = dk; }
    var lo = L();
    /* GOOGLE SHOPPING LANDING (30 Sep 2026): a bare ?variant= link, which is what the
       Merchant Center feed and the Product JSON-LD offers point to, opens on exactly that
       bundle variant's pieces: the iPhone case (its model), the card holder and the bifold
       wallet, all in the variant's color. The total shown is then the variant's price (the
       three pieces less the automatic discount), as Google checks. Any other parameter
       (leather, color, device, pick, pc, without, add) keeps the normal deep-link behavior. */
    if (vid && v.id === vid && !['leather', 'color', 'colour', 'device', 'pick', 'pc', 'without', 'add'].some(function (k) { return sp.has(k); })) {
      S.off.passport = true;
      S.off.keychain = true;
      if (lo.core.wallet && secondKind(lo) !== 'wallet') S.ex[lo.core.wallet.key] = { col: null };
    }
    /* the page without a choice (no builder parameter): its optional pieces that are not made or sold out in its
       color are left out quietly, as the server drew them (gcls-set.liquid d_off) */
    if ((bdef || (!vid && D.set.defDev && v.id === D.set.def)) && !['leather', 'color', 'colour', 'device', 'pick', 'pc', 'without', 'add'].some(function (k) { return sp.has(k); })) {
      (D.set.defOff || []).forEach(function (k) { if (SLOTS.indexOf(k) !== -1) S.dq[k] = true; });
    }
    if (sp.get('pick') === 'wallet' && lo.core.wallet) S.pick = 'wallet';
    (sp.get('pc') || '').split(',').forEach(function (x) {
      var pr = x.split(':'), k = pr[0], p = lo.core[k];
      if (p && pr[1]) { var ck = pieceColor(p, pr[1]); if (ck) S.pc[k] = ck; }
    });
    /* without=: slots; the old kinds (cardholder, wallet) still work */
    (sp.get('without') || '').split(',').forEach(function (k) {
      if (k === 'cardholder' || k === 'wallet') k = 'second';
      if (SLOTS.indexOf(k) !== -1) S.off[k] = true;
    });
    (sp.get('add') || '').split(',').forEach(function (s) {
      if (!s) return;
      var parts = s.split(':'), id = parts[0], col = parts[1] || '';
      var ids = slug(id);
      Object.keys(ALL).forEach(function (key) {
        var p = ALL[key];
        if (!(String(p.id) === id || same(ids, p.h) || same(ids, p.he))) return;
        if (p.leather !== S.leather) return;
        /* a core kind named in add=: the card holder or wallet the set does not use */
        if (lo.core[p.kind] === p) {
          if ((p.kind === 'cardholder' || p.kind === 'wallet') && secondKind(lo) !== p.kind) S.ex[key] = { col: col ? pieceColor(p, col) : null };
          return;
        }
        S.ex[key] = { col: col ? pieceColor(p, col) : null };
      });
    });
    S.ini = cleanIni(sp.get('initials') || '');
    S.gift = sp.get('gift') === '1';
    S.logo = sp.get('logo') === '1';
  }
  function bestColor(l) {
    var cols = SCOLORS[l] || [];
    var save = S.leather; S.leather = l;
    for (var i = 0; i < cols.length; i++) if (colorAnyAvail(cols[i])) { S.leather = save; return cols[i]; }
    S.leather = save;
    return cols[0] || '';
  }

  /* ---------- behavior ---------- */
  function msg(t, bad) {
    if (!elMsg) return;
    elMsg.textContent = t || '';
    elMsg.classList.toggle('is-bad', !!bad);
  }
  function setLeather(l) {
    if (l === S.leather || !SCOLORS[l]) return;
    touch();
    S.leather = l;
    gcT({ name: 'builder_choice', builder: 'set', step: 'leather', value_key: l });
    if (SCOLORS[l].indexOf(S.color) === -1) S.color = bestColor(l);
    /* colors and more-pieces belong to a leather */
    S.pc = {};
    var keepKinds = {};
    Object.keys(S.ex).forEach(function (key) { var p = ALL[key]; if (p) keepKinds[p.kind] = 1; delete S.ex[key]; });
    morePieces().forEach(function (m) { if (keepKinds[m.p.kind] && !S.ex[m.p.key]) { S.ex[m.p.key] = { col: null }; keepKinds[m.p.kind] = 0; } });
    if (S.device && !caseModels().some(function (v) { return v.mk === S.device; })) S.device = '';
    msg('');
    render();
    stickyAgain();
  }
  /* the main color: every piece follows it (its own choice is reset) */
  function setColor(c) {
    if (c === S.color && !Object.keys(S.pc).length) return;
    touch();
    S.color = c;
    gcT({ name: 'builder_choice', builder: 'set', step: 'color', value_key: c });
    S.pc = {};
    Object.keys(S.ex).forEach(function (key) { S.ex[key].col = null; });
    msg('');
    render();
    stickyAgain();
  }
  function setDevice(d) {
    touch();
    S.device = d;
    gcT({ name: 'builder_choice', builder: 'set', step: 'device', value_key: d });
    /* a model whose case is sold out in the case's color: the case moves to its first color
       that has it (the model list said so, renderDevices); the other pieces keep theirs */
    var cp = L().core['case'], cck = colOf('case');
    if (cp && cp.models && !availIn(cp, cck, d)) {
      var alt = caseColorFor(cp, d);
      if (alt) { if (alt === FAM()) delete S.pc['case']; else S.pc['case'] = alt; }
    }
    msg('');
    render();
    stickyAgain();
  }
  /* one piece's own color */
  function setPieceColor(kind, ck) {
    touch();
    if (ck === FAM()) delete S.pc[kind]; else S.pc[kind] = ck;
    gcT({ name: 'builder_choice', builder: 'set', step: 'piece_color', value_key: kind + ':' + ck });
    var slot = kind === 'cardholder' || kind === 'wallet' ? 'second' : kind;
    if (secondKind() === kind || slot !== 'second') delete S.off[slot];
    msg('');
    render();
    stickyAgain();
  }
  function setExColor(key, ck) {
    touch();
    if (S.ex[key]) S.ex[key].col = ck;
    render();
  }

  /* ---------- the color popover of one piece ---------- */
  var cpop = { open: false, kind: '', key: '', anchor: null, btn: null, t: 0 };
  function cpopPiece() {
    if (cpop.key) return ALL[cpop.key] || null;
    return L().core[cpop.kind] || null;
  }
  function cpopCur() {
    if (cpop.key) { var x = cur().extras.filter(function (z) { return z.p.key === cpop.key; })[0]; return x ? x.ck : ''; }
    return colOf(cpop.kind);
  }
  /* the photo of a piece in a color: its first variant photo in that color */
  function colorPhoto(p, ck) {
    var vv = colorVariants(p, ck).filter(function (x) { return x.img; })[0];
    return vv ? vv.img : '';
  }
  /* The swatch photos are drawn at 44px: the 88px copy (2x) with a 132px one
     for 3x screens; they are preloaded for every piece in the set once the
     page is idle, so a popover opens with its photos ready. Until a photo
     has arrived its swatch is a quiet skeleton (never a flat color that
     then turns into a photo). */
  var PRE = {};
  function preload(url) { if (!url || PRE[url]) return; PRE[url] = 1; var im = new Image(); im.decoding = 'async'; im.src = url; }
  function swatchUrl(img) { return sized(img, (window.devicePixelRatio || 1) > 2 ? 132 : 88); }
  function preloadSwatches(p) { if (p && !p.nocolor) p.colors.forEach(function (c) { preload(swatchUrl(colorPhoto(p, c.key))); }); }
  /* opening a piece's colors also fetches each color's photo at the card's own size, so a choice shows at once */
  function preloadCards(p) {
    if (!p || p.nocolor) return;
    var w = p.kind === 'case' ? 900 : 720;
    var c = cards['core:' + (p.kind === 'cardholder' || p.kind === 'wallet' ? 'second' : p.kind)] || cards['ex:' + p.key];
    var fw = c ? c.getBoundingClientRect().width * (window.devicePixelRatio || 1) : w;
    var use = fw <= w * 0.6 ? Math.round(w * 0.6) : w;
    p.colors.forEach(function (x) { var u = colorPhoto(p, x.key); if (u) preload(sized(u, use)); });
  }
  function fillCpop() {
    var p = cpopPiece();
    if (!p || !elCpop) return false;
    var ck = cpopCur(), mk = p.kind === 'case' ? S.device : '';
    setText(q('[data-gcls-cpoptitle]', elCpop), tpl(T.colorOf, { piece: pName(p), color: colorLabel(p, ck) }));
    var h = '';
    p.colors.forEach(function (c) {
      var on = c.key === ck, out = !availIn(p, c.key, mk);
      var lab = out ? tpl(T.reasonItem, { piece: c.val, why: T.soldOut }) : c.val;
      var img = colorPhoto(p, c.key);
      h += '<button type="button" role="radio" class="gcls-cpop__opt' + (out ? ' is-out' : '') + '" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-gcls-cpopc="' + esc(c.key) + '"' + (out ? ' aria-disabled="true"' : '') + ' title="' + esc(lab) + '" aria-label="' + esc(lab) + '">' +
        '<span class="gcls-cpop__dot">' + (img ? '<img src="' + esc(sized(img, 88)) + '" srcset="' + esc(sized(img, 88)) + ' 88w, ' + esc(sized(img, 132)) + ' 132w" sizes="44px" width="44" height="44" alt="" decoding="async">' : '') + '</span><span class="gcls-cpop__name">' + esc(c.val) + '</span></button>';
    });
    var lst = q('[data-gcls-cpoplist]', elCpop);
    setHTML(lst, h);
    /* "Remove from set" (owner, 29 Sep 2026): only where the piece's row may be unticked (it is in the set) */
    var rm = q('[data-gcls-cpoprm]', elCpop);
    if (rm) {
      var canRm = false;
      if (cpop.key) canRm = !!S.ex[cpop.key];
      else { var cr = cur().core.filter(function (z) { return z.kind === cpop.kind; })[0]; canRm = !!(cr && cr.on && !cr.why); }
      rm.hidden = !canRm;
    }
    settleDots(lst);
    return true;
  }
  /* Where the popover goes. It is sized to its swatches (a grid of up to 5
     columns; 6 colors split 3 + 3) and placed OUTSIDE the piece it edits,
     beside the piece's color button, inside the gallery panel: on desktop
     to the right or left of the card (else below or above it); on touch
     below or above the card (else beside it). Where no side has room for
     it, fewer columns are tried; the last resort is just under the button,
     still inside the panel. A color chip in the buying column opens it
     below the chip (else above), inside the screen. */
  function cpopColsFor(n) { if (n <= 5) return n; var rows = Math.ceil(n / 5); return Math.ceil(n / rows); }
  function cpopSize(c) {
    elCpop.style.setProperty('--gcls-cpop-cols', String(c));
    return { w: elCpop.offsetWidth, h: elCpop.offsetHeight };
  }
  function placeCpop() {
    if (!cpop.open || !cpop.anchor) return;
    elCpop.style.left = '0px'; elCpop.style.top = '0px';
    var btn = cpop.btn && cpop.btn.isConnected ? cpop.btn : cpop.anchor;
    var card = btn.closest ? btn.closest('.gcls-card') : null;
    var vw = document.documentElement.clientWidth, vh = window.innerHeight, m = 8;
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var B = btn.getBoundingClientRect();
    var C = card ? card.getBoundingClientRect() : B;
    /* a small tile shows no color button: the pop-up takes its place from the tile itself */
    if (!B.width || !B.height) B = C;
    /* the room: the gallery panel (a card) or the screen (a chip), never past the screen */
    var bx = { l: m, t: header + m, r: vw - m, b: vh - m };
    if (card && elStage) {
      var G = elStage.getBoundingClientRect();
      bx = { l: Math.max(G.left + m, bx.l), t: Math.max(G.top + m, bx.t), r: Math.min(G.right - m, bx.r), b: Math.min(G.bottom - m, bx.b) };
    }
    var n = qa('.gcls-cpop__opt', elCpop).length || 1;
    var c0 = cpopColsFor(n), cols = [];
    for (var c = c0; c >= Math.min(n, 2); c--) if (cols.indexOf(c) === -1) cols.push(c);
    var order = !card ? ['below', 'above'] : (cpop.hover || HOVER) ? ['right', 'left', 'below', 'above'] : ['below', 'above', 'right', 'left'];
    var sizes = {};
    function size(c) { return sizes[c] || (sizes[c] = cpopSize(c)); }
    function clampX(x, w) { return Math.max(bx.l, Math.min(x, bx.r - w)); }
    function clampY(y, h) { return Math.max(bx.t, Math.min(y, bx.b - h)); }
    function at(side, z) {
      var w = z.w, h = z.h;
      if (w > bx.r - bx.l || h > bx.b - bx.t) return null;
      if (side === 'right') { var x = C.right + m; return x + w <= bx.r ? { x: x, y: clampY(Math.min(B.top - 6, C.top + C.height / 2 - 24), h) } : null; }
      if (side === 'left') { var x2 = C.left - m - w; return x2 >= bx.l ? { x: x2, y: clampY(Math.min(B.top - 6, C.top + C.height / 2 - 24), h) } : null; }
      if (side === 'below') { var y = C.bottom + m; return y + h <= bx.b ? { x: clampX(B.left + B.width / 2 - w / 2, w), y: y } : null; }
      var y2 = C.top - m - h; return y2 >= bx.t ? { x: clampX(B.left + B.width / 2 - w / 2, w), y: y2 } : null;
    }
    var pos = null, use = c0;
    for (var i = 0; i < order.length && !pos; i++) {
      for (var k = 0; k < cols.length && !pos; k++) { var z = size(cols[k]); var p0 = at(order[i], z); if (p0) { pos = p0; use = cols[k]; } }
    }
    if (!pos) {
      /* no side has room: just under the button, as wide as the room allows */
      for (var k2 = 0; k2 < cols.length; k2++) { use = cols[k2]; if (size(use).w <= bx.r - bx.l) break; }
      var zz = size(use);
      var fitsBox = zz.h <= bx.b - bx.t;
      if (!fitsBox) bx = { l: m, t: header + m, r: vw - m, b: vh - m };
      pos = { x: clampX(C.left + C.width / 2 - zz.w / 2, zz.w), y: clampY(C.bottom + 6 <= bx.b - zz.h ? C.bottom + 6 : C.top - 6 - zz.h, zz.h) };
    }
    size(use);
    elCpop.style.setProperty('--gcls-cpop-cols', String(use));
    elCpop.style.left = Math.round(pos.x) + 'px';
    elCpop.style.top = Math.round(pos.y) + 'px';
  }
  /* the color buttons' heartbeat (CSS) says "tap me" until the shopper has opened any color pop-up once (this session) */
  function beatStop() {
    if (root.classList.contains('gcls-cb-seen')) return;
    root.classList.add('gcls-cb-seen');
    try { sessionStorage.setItem('gcls-cb-seen', '1'); } catch (e) {}
  }
  try { if (sessionStorage.getItem('gcls-cb-seen')) root.classList.add('gcls-cb-seen'); } catch (e) {}
  function openCpop(opts, focus) {
    if (!elCpop) return;
    clearTimeout(cpop.t);
    beatStop();
    if (cpop.btn && cpop.btn !== opts.btn) cpop.btn.setAttribute('aria-expanded', 'false');
    cpop.kind = opts.kind || ''; cpop.key = opts.key || ''; cpop.anchor = opts.anchor; cpop.btn = opts.btn || null;
    if (!fillCpop()) return;
    preloadCards(cpopPiece());
    cpop.open = true;
    cpop.hover = !!opts.hover;
    elCpop.hidden = false;
    if (cpop.btn) cpop.btn.setAttribute('aria-expanded', 'true');
    placeCpop();
    requestAnimationFrame(placeCpop);
    if (focus) {
      var sel = q('.gcls-cpop__opt[aria-checked="true"]', elCpop) || q('.gcls-cpop__opt', elCpop);
      if (sel) try { sel.focus({ preventScroll: true }); } catch (e) {}
    }
  }
  function closeCpop(refocus) {
    clearTimeout(cpop.t);
    if (!cpop.open) return;
    cpop.open = false;
    elCpop.hidden = true;
    if (cpop.btn) {
      cpop.btn.setAttribute('aria-expanded', 'false');
      if (refocus) try { cpop.btn.focus({ preventScroll: true }); } catch (e) {}
    }
  }
  function laterClose() { clearTimeout(cpop.t); cpop.t = setTimeout(function () { if (cpop.hover) closeCpop(false); }, 320); }
  /* the button that re-opens after a re-render (the stage and rows are redrawn) */
  function cpopBtnFor() {
    if (cpop.key) return q('.gcls-card [data-gcls-cbtn-ex="' + cpop.key + '"]') || q('[data-gcls-cbtn-ex="' + cpop.key + '"]');
    return q('.gcls-card [data-gcls-cbtn="' + cpop.kind + '"]') || q('[data-gcls-cbtn="' + cpop.kind + '"]');
  }
  /* the next control in page order after el (for Tab out of the popover) */
  function focusAfter(el) {
    var all = Array.prototype.slice.call(document.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'));
    for (var i = 0; i < all.length; i++) {
      var f = all[i];
      if (f === el || el.contains(f) || elCpop.contains(f)) continue;
      if (!(el.compareDocumentPosition(f) & 4)) continue;
      if (f.disabled || f.tabIndex < 0 || f.closest('[hidden], [inert], [aria-hidden="true"]')) continue;
      if (!f.getClientRects().length || getComputedStyle(f).visibility === 'hidden') continue;
      try { f.focus({ preventScroll: false }); } catch (e) {}
      if (document.activeElement === f) return;
    }
  }
  if (elCpop) {
    /* the popover lives in <body> (position: fixed, never clipped); clicks on its options land here */
    document.body.appendChild(elCpop);
    /* a swatch photo has arrived: the skeleton gives way to it */
    elCpop.addEventListener('load', function (e) { var d = e.target.parentNode; if (d && d.classList) d.classList.remove('is-loading'); }, true);
    elCpop.addEventListener('error', function (e) { var d = e.target.parentNode; if (d && d.classList) d.classList.remove('is-loading'); }, true);
    /* choosing a color: the piece takes it and the popover closes (focus back
       on the piece's color button when the choice came from the keyboard);
       the arrow keys (below) move the choice and keep it open */
    function pickCpop(ck, stay, kb) {
      var wasKey = cpop.key, wasKind = cpop.kind;
      if (wasKey) setExColor(wasKey, ck); else setPieceColor(wasKind, ck);
      var nb = cpopBtnFor();
      if (nb) { cpop.btn = nb; if (!cpop.hover) cpop.anchor = nb; }
      if (!stay) { closeCpop(kb); return; }
      if (fillCpop()) { placeCpop(); var sel = q('.gcls-cpop__opt[aria-checked="true"]', elCpop); if (sel) sel.focus(); }
    }
    /* taking the piece out: exactly as unticking its row (or its "more" card). The page never moves (owner,
       30 Sep 2026: on a phone, removing a piece from the picture scrolled the page down to the MORE row, where
       the focus was sent). When the pop-up had the focus (keyboard, or a tap on the piece's color button), the
       focus goes, without scrolling, to a control in view: from the picture, the gap's "+ add" where the piece
       was, else the next piece's color button on the picture (else the previous one, else the view toggle);
       from a color chip in the buying column, what puts the piece back there (its own row or MORE card). */
    function stageBtnNear(card) {
      var all = qa('.gcls-card', elComp), at = all.indexOf(card), ok = function (c) {
        if (!c || c === card || c.classList.contains('is-leave')) return null;
        var b = c.querySelector('[data-gcls-cbtn], [data-gcls-cbtn-ex]');
        return b && !b.hidden && b.offsetWidth > 0 ? b : null;
      };
      if (at < 0) return null;
      for (var i = at + 1; i < all.length; i++) { var n = ok(all[i]); if (n) return n; }
      for (var k = at - 1; k >= 0; k--) { var p = ok(all[k]); if (p) return p; }
      return null;
    }
    function removeFromCpop(kb) {
      var key = cpop.key, kind = cpop.kind, fromStage = !!(cpop.btn && elComp.contains(cpop.btn));
      var slot = kind === 'cardholder' || kind === 'wallet' ? 'second' : kind;
      var card = fromStage ? cpop.btn.closest('.gcls-card') : null, y0 = window.pageYOffset;
      closeCpop(false);
      touch();
      if (key) delete S.ex[key]; else S.off[slot] = true;
      msg('');
      quickGlide();
      render();
      if (kb) {
        var g = !key && q('.gcls-ghost [data-gcls-restore="' + slot + '"]', elComp);
        var t = fromStage ? ((g && g.offsetWidth ? g : null) || stageBtnNear(card) || q('[data-gcls-view="set"]'))
          : (key ? q('[data-gcls-more-add="' + key + '"]') : q('[data-gcls-core-check="' + slot + '"]'));
        if (t) try { t.focus({ preventScroll: true }); } catch (x) {}
      }
      if (Math.abs(window.pageYOffset - y0) > 1) window.scrollTo(window.pageXOffset, y0);
    }
    elCpop.addEventListener('click', function (e) {
      if (e.target.closest('[data-gcls-cpopx]')) { closeCpop(true); return; }
      if (e.target.closest('[data-gcls-cpoprm]')) { removeFromCpop(e.detail === 0 || elCpop.contains(document.activeElement)); return; }
      var b = e.target.closest('[data-gcls-cpopc]');
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      pickCpop(b.getAttribute('data-gcls-cpopc'), !!b._gclsStay, e.detail === 0);
      b._gclsStay = false;
    });
    elCpop.addEventListener('mouseenter', function () { clearTimeout(cpop.t); });
    elCpop.addEventListener('mouseleave', function (e) {
      if (!cpop.hover) return;
      /* back onto its own piece: stay open */
      if (e.relatedTarget && cpop.anchor && cpop.anchor.contains && cpop.anchor.contains(e.relatedTarget)) return;
      laterClose();
    });
    /* ARIA radio group: the arrows move the choice and the focus together
       (colors that are out are skipped), Space and Enter choose. Tab leaves
       the popover in page order: it closes, and focus goes to the control
       after the piece's color button (Shift+Tab: back to that button). */
    elCpop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeCpop(true); return; }
      if (e.key === 'Tab') {
        e.preventDefault();
        /* the swatches, then "Remove from set" (when shown), then out */
        var rmb = q('[data-gcls-cpoprm]', elCpop), onRm = rmb && e.target.closest && e.target.closest('[data-gcls-cpoprm]');
        if (rmb && !rmb.hidden && !onRm && !e.shiftKey) { rmb.focus(); return; }
        if (onRm && e.shiftKey) { var sel0 = q('.gcls-cpop__opt[aria-checked="true"]', elCpop) || q('.gcls-cpop__opt', elCpop); if (sel0) sel0.focus(); return; }
        var from = cpop.btn;
        closeCpop(true);
        if (!e.shiftKey && from) focusAfter(from);
        return;
      }
      if (e.target.closest && e.target.closest('[data-gcls-cpopx], [data-gcls-cpoprm]')) return;
      var btns = qa('.gcls-cpop__opt', elCpop), i = btns.indexOf(document.activeElement);
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(e.key) === -1 || i === -1) return;
      e.preventDefault();
      var ok = btns.map(function (b) { return b.getAttribute('aria-disabled') !== 'true'; });
      var n = -1, L = btns.length;
      if (e.key === 'Home') { for (n = 0; n < L && !ok[n]; n++); }
      else if (e.key === 'End') { for (n = L - 1; n >= 0 && !ok[n]; n--); }
      else {
        var d = (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1;
        for (var s2 = 1; s2 < L; s2++) { var x = (i + d * s2 + L * 2) % L; if (ok[x]) { n = x; break; } }
      }
      if (n < 0 || n >= L || n === i) return;
      btns[n]._gclsStay = true;
      btns[n].click();
    });
    document.addEventListener('click', function (e) {
      if (!cpop.open) return;
      if (elCpop.contains(e.target) || (cpop.btn && cpop.btn.contains(e.target))) return;
      closeCpop(false);
    }, true);
    window.addEventListener('scroll', function () { if (cpop.open) requestAnimationFrame(placeCpop); }, { passive: true });
    window.addEventListener('resize', function () { if (cpop.open) placeCpop(); }, { passive: true });
    /* desktop: hovering a piece's photo on the stage opens its colors */
    if (HOVER) {
      /* Hover intent. A piece opens its colors after a short rest on it; moving
         on to another piece switches only after a grace delay (320ms), and not
         at all while the pointer travels inside the "safe triangle" between
         where it left the piece and the pop-up's near edge, so a diagonal move
         over other pieces reaches the pop-up. Leaving both the piece and the
         pop-up closes it after the same grace delay; X, Esc and a choice close
         it at once. */
      var GRACE = 320, pt = null, exitPt = null;
      function inTri(p, a, b, c) {
        function sg(p1, p2, p3) { return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y); }
        var d1 = sg(p, a, b), d2 = sg(p, b, c), d3 = sg(p, c, a);
        return !((d1 < 0 || d2 < 0 || d3 < 0) && (d1 > 0 || d2 > 0 || d3 > 0));
      }
      function towardPop() {
        if (!cpop.open || !exitPt || !pt) return false;
        var r = elCpop.getBoundingClientRect(), a = exitPt, pad = 6, b, c;
        if (r.left >= a.x) { b = { x: r.left, y: r.top - pad }; c = { x: r.left, y: r.bottom + pad }; }
        else if (r.right <= a.x) { b = { x: r.right, y: r.top - pad }; c = { x: r.right, y: r.bottom + pad }; }
        else if (r.top >= a.y) { b = { x: r.left - pad, y: r.top }; c = { x: r.right + pad, y: r.top }; }
        else { b = { x: r.left - pad, y: r.bottom }; c = { x: r.right + pad, y: r.bottom }; }
        return inTri(pt, a, b, c);
      }
      function overPop() { if (!pt) return false; var r = elCpop.getBoundingClientRect(); return pt.x >= r.left && pt.x <= r.right && pt.y >= r.top && pt.y <= r.bottom; }
      document.addEventListener('mousemove', function (e) {
        pt = { x: e.clientX, y: e.clientY };
        if (cpop.open && cpop.hover && cpop.anchor && cpop.anchor.contains && cpop.anchor.contains(e.target)) exitPt = pt;
      }, { passive: true });
      function later(fn) {
        clearTimeout(cpop.t);
        cpop.t = setTimeout(function again() {
          if (towardPop()) { cpop.t = setTimeout(again, 120); return; }
          if (overPop()) return;
          fn();
        }, GRACE);
      }
      elComp.addEventListener('mouseover', function (e) {
        var card = e.target.closest && e.target.closest('.gcls-card');
        if (!card || card.classList.contains('is-leave')) return;
        /* the stamp spot is its own control (the initials): resting on it never opens the colors; nor on the Minimalist
           logo's indicator (Oct 2026), a control of its own too, nor just after a press on it (lgHeld) */
        if (edOpen || lgHeld() || e.target.closest('[data-gcls-spot], [data-gcls-rm], [data-gc-logo-spot-btn]')) { if (!cpop.open || !cpop.hover) clearTimeout(cpop.t); return; }
        var b = card.querySelector('.gcls-card__cbtn');
        if (!b || b.hidden) return;
        if (cpop.open && cpop.anchor === card) { clearTimeout(cpop.t); return; }
        if (cpop.open && !cpop.hover) return;
        var hk = b.getAttribute('data-gcls-cbtn-ex');
        preloadSwatches(hk ? ALL[hk] : L().core[b.getAttribute('data-gcls-cbtn')]);
        function go() {
          if (!card.isConnected || card.classList.contains('is-leave')) return;
          /* the pointer moved on from this piece meanwhile: no switch (and no pop-up left behind) */
          if (!card.matches(':hover')) { if (cpop.open && cpop.hover && !overPop()) closeCpop(false); return; }
          exitPt = null;
          openCpop({ kind: b.getAttribute('data-gcls-cbtn'), key: b.getAttribute('data-gcls-cbtn-ex'), anchor: card, btn: b, hover: true }, false);
        }
        if (cpop.open) later(go);
        else { clearTimeout(cpop.t); cpop.t = setTimeout(go, 180); }
      });
      elComp.addEventListener('mouseout', function (e) {
        var card = e.target.closest && e.target.closest('.gcls-card');
        if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
        if (e.relatedTarget && elCpop.contains(e.relatedTarget)) return;
        if (!cpop.open) { clearTimeout(cpop.t); return; }
        if (cpop.hover && cpop.anchor === card) later(function () { if (cpop.hover) closeCpop(false); });
      });
    }
  }

  /* ---------- the zoom: the PDP's own full-screen PhotoSwipe (snippets/gcx-pswp, GCX.zoom) ---------- */
  var ZL = [];
  function zoomList() {
    if (S.view === 'photos') {
      /* photos only: the video has no data-full (the PDP's zoom skips videos too) */
      return curSlides().filter(function (el) { return el.getAttribute('data-full'); }).map(function (el) {
        return { src: el.getAttribute('data-full'), w: +el.getAttribute('data-w') || 0, h: +el.getAttribute('data-h') || 0, alt: el.getAttribute('data-label') || '', slide: el.getAttribute('data-gcls-slide') };
      });
    }
    var o = cur();
    return o.items.map(function (it) {
      var src = it.kind === 'case' ? stageCase(it).src : pieceImg(it);
      /* the set's case zooms as the Minimalist logo shows it (Oct 2026) */
      if (it.kind === 'case' && !it.extra) src = lgPhoto(src);
      return { src: src, w: 0, h: 0, alt: tpl(T.imgAlt, { title: it.p.t, color: colorLabel(it.p, it.ck) }) };
    }).filter(function (z) { return z.src; });
  }
  function zoomState() {
    var b = q('[data-gcls-zoom]');
    if (!b) return;
    var el = S.view === 'photos' && phIdx != null && elPhTrack ? q('[data-gcls-slide="' + phIdx + '"]', elPhTrack) : null;
    var ok = S.view === 'photos' ? !!(el && el.getAttribute('data-full')) : cur().items.length > 0;
    /* the button keeps its place in the bar (the video has no full-size photo: it only dims) */
    b.hidden = false;
    b.disabled = !ok;
    b.setAttribute('aria-disabled', ok ? 'false' : 'true');
  }
  function openZoom() {
    ZL = zoomList();
    if (!ZL.length) return;
    var start = 0;
    if (S.view === 'photos') ZL.forEach(function (z, i) { if (z.slide === String(phIdx)) start = i; });
    /* the PDP's zoom (kit: snippets/gcx-pswp + GCX.zoom); the store's product photos are square, 2048 when the size is not known */
    if (window.GCX && GCX.zoom) {
      GCX.zoom(ZL.map(function (z) { return { src: sized(z.src, 4096), w: z.w || 2048, h: z.h || z.w || 2048 }; }), start, { from: q('[data-gcls-zoom]') });
    }
  }

  /* ---------- the model popover (PDP look: side panel on desktop, sheet below 1008px) ---------- */
  var overlay = document.querySelector('.PageOverlay');
  var popOpen = false;
  function isDesk() { return window.innerWidth >= 1008; }
  function placePop() {
    if (!popOpen) return;
    if (!isDesk()) { elPop.style.top = ''; elPop.style.left = ''; return; }
    var r = elDevBtn.getBoundingClientRect();
    var w = elPop.offsetWidth || 375, hgt = elPop.offsetHeight || 300;
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 72;
    var left = r.left - w - 16, top;
    if (left < 16) {
      left = Math.max(16, Math.min(r.left, window.innerWidth - w - 16));
      top = r.bottom + 8;
      if (top + hgt > window.innerHeight - 12) top = Math.max(header + 12, r.top - hgt - 8);
    } else {
      top = r.top + r.height / 2 - hgt / 2;
      top = Math.max(header + 12, Math.min(top, window.innerHeight - hgt - 12));
    }
    elPop.style.left = Math.round(left) + 'px';
    elPop.style.top = Math.round(top) + 'px';
  }
  function openPop() {
    if (popOpen) return;
    popOpen = true;
    renderDevices();
    var slab = elPop.closest('.gcx-slab');
    if (slab) slab.classList.add('gcx-popover-live');
    elPop.setAttribute('aria-hidden', 'false');
    elDevBtn.setAttribute('aria-expanded', 'true');
    if (!isDesk() && overlay) overlay.classList.add('is-visible');
    placePop();
    requestAnimationFrame(placePop);
    var selV = q('.Popover__Value.is-selected', elPop) || q('.Popover__Value', elPop);
    if (selV) {
      try { selV.focus({ preventScroll: true }); } catch (e) {}
      var lst = elDevList;
      if (lst && selV.offsetTop > lst.clientHeight) lst.scrollTop = selV.offsetTop - lst.clientHeight / 2;
    }
  }
  function closePop(refocus) {
    if (!popOpen) return;
    popOpen = false;
    elPop.setAttribute('aria-hidden', 'true');
    elDevBtn.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-visible');
    var slab = elPop.closest('.gcx-slab');
    if (slab) setTimeout(function () { if (!popOpen) slab.classList.remove('gcx-popover-live'); }, 220);
    if (refocus) try { elDevBtn.focus({ preventScroll: true }); } catch (e) {}
  }
  window.addEventListener('resize', placePop, { passive: true });
  window.addEventListener('scroll', function () { if (popOpen) requestAnimationFrame(placePop); }, { passive: true });
  document.addEventListener('click', function (e) {
    if (!popOpen) return;
    if (elPop.contains(e.target) || elDevBtn.contains(e.target)) return;
    closePop(false);
  }, true);
  if (overlay) overlay.addEventListener('click', function () { if (popOpen) closePop(true); });
  document.addEventListener('keydown', function (e) {
    if (!popOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); closePop(true); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
      var vals = qa('.Popover__Value', elPop);
      var i = vals.indexOf(document.activeElement);
      e.preventDefault();
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? vals.length - 1 : (e.key === 'ArrowDown' ? Math.min(vals.length - 1, i + 1) : Math.max(0, i - 1));
      if (vals[n]) vals[n].focus();
    }
    if (e.key === 'Tab' && elPop.contains(document.activeElement)) closePop(false);
  });

  /* ---------- clicks ---------- */
  function toggleCheck(which) {
    if (which === 'logo') { lgSet(!logoOn(), 'row'); return; }
    if (which === 'gift') { var t = totals(); if (t.giftForced) return; S.gift = !S.gift; }
    else if (which === 'prio') { if (S.cart && S.cart.prioLine) return; S.prio = !S.prio; }
    else if (which === 'prot') { S.prot = !S.prot; }
    if (which !== 'ms') gcT({ name: 'addon_toggle', addon: { gift: 'gift_packaging', prio: 'priority_processing', prot: 'screen_protector' }[which], state: S[which] ? 'on' : 'off', surface: 'set_builder' });
    else if (which === 'ms') {
      var m = msOffer();
      if (!m) return;
      touch();
      if (S.ex[m.p.key]) delete S.ex[m.p.key]; else S.ex[m.p.key] = { col: m.ck };
      gcT({ name: 'addon_toggle', addon: 'magsafe_wallet', state: S.ex[m.p.key] ? 'on' : 'off', surface: 'set_builder' });
      msg(''); render(); return;
    }
    touch();
    changed();
    renderStage();
    renderSummary();
    writeUrl();
  }

  /* a row's or a gap's color dot: its photo fades in over the skeleton once it is in (settleDots: at once when cached) */
  function dotIn(e) {
    var im = e.target, d = im && im.parentNode;
    if (im.nodeName === 'IMG' && d && d.classList && d.classList.contains('is-loading') && (d.classList.contains('gcls-cchip__dot') || d.classList.contains('gcls-alt__dot'))) d.classList.remove('is-loading');
  }
  root.addEventListener('load', dotIn, true);
  root.addEventListener('error', dotIn, true);
  /* a change above an element keeps that element where it is on screen (the summary when its X clears the
     initials, which shortens the step above it): the browser's own scroll anchoring is paused for that change
     (it may hold on to the other column), and the page is scrolled by exactly what the element moved, in the
     same frame */
  function keepPlace(el, fn) {
    if (!el) { fn(); return; }
    var de = document.documentElement, bd = document.body;
    de.style.overflowAnchor = 'none'; if (bd) bd.style.overflowAnchor = 'none';
    var t0 = el.getBoundingClientRect().top;
    fn();
    var d = el.getBoundingClientRect().top - t0;
    if (Math.abs(d) > 1) window.scrollBy(0, d);
    requestAnimationFrame(function () { requestAnimationFrame(function () { de.style.overflowAnchor = ''; if (bd) bd.style.overflowAnchor = ''; }); });
  }
  /* taking a piece out: the picture's glide ends inside the half second after the tap, so the pieces moving
     into their new places never count as a layout shift (CLS 0); other changes keep the usual glide */
  var quickT = 0;
  function quickGlide() {
    if (!elComp || REDUCED) return;
    elComp.classList.add('is-quick');
    clearTimeout(quickT);
    quickT = setTimeout(function () { elComp.classList.remove('is-quick'); }, 700);
  }
  /* the X on a card: the piece leaves the set, as with the summary's X (no scroll; the focus goes to the piece's
     "+ Add" gap where it was, else to the nearest piece's color button, else to the view toggle) */
  function stageRm(b) {
    var rk = b.getAttribute('data-gcls-rm'), card = b.closest('.gcls-card');
    if (!rk || b.hidden || !card || card.classList.contains('is-leave')) return;
    var y0 = window.pageYOffset, hadFocus = document.activeElement === b;
    if (cpop.open) closeCpop(false);
    if (edOpen) closeEd(false);
    touch();
    var slot = '';
    if (rk.indexOf('ex:') === 0) delete S.ex[rk.slice(3)];
    else { slot = rk.slice(5); S.off[slot] = true; }
    gcT({ name: 'builder_choice', builder: 'set', step: 'piece_off', value_key: slot || rk.slice(3) });
    msg('');
    quickGlide();
    render();
    var all = qa('.gcls-card', elComp), at = all.indexOf(card);
    function near() {
      for (var d = 1; d < all.length; d++) for (var s2 = 0; s2 < 2; s2++) {
        var c = all[s2 ? at - d : at + d];
        if (!c || c === card || c.classList.contains('is-leave')) continue;
        var cb = c.querySelector('[data-gcls-cbtn], [data-gcls-cbtn-ex]'), x = c.querySelector('[data-gcls-rm]');
        if (cb && !cb.hidden && cb.offsetWidth) return cb;
        if (x && !x.hidden && x.offsetWidth) return x;
      }
      return null;
    }
    var g = slot && q('.gcls-ghost [data-gcls-restore="' + slot + '"]', elComp);
    var f = (g && g.offsetWidth ? g : null) || near() || q('[data-gcls-view="set"]');
    if (f && (hadFocus || !document.activeElement || document.activeElement === document.body || card.contains(document.activeElement))) try { f.focus({ preventScroll: true }); } catch (x) {}
    if (Math.abs(window.pageYOffset - y0) > 1) window.scrollTo(window.pageXOffset, y0);
  }
  root.addEventListener('click', function (ev) {
    var t = ev.target, b;
    if ((b = t.closest('[data-gcls-rm]'))) { ev.preventDefault(); stageRm(b); return; }
    if ((b = t.closest('[data-gcls-spot]'))) { ev.preventDefault(); if (edOpen) closeEd(true); else openEd(); return; }
    if ((b = t.closest('[data-gcls-devbtn]'))) { if (popOpen) closePop(true); else openPop(); return; }
    if ((b = t.closest('[data-gcls-popclose]'))) { closePop(true); return; }
    if ((b = t.closest('[data-gcls-dev]'))) { var d = b.getAttribute('data-gcls-dev'); closePop(true); setDevice(d); return; }
    if ((b = t.closest('[data-gcls-leather]'))) { setLeather(b.getAttribute('data-gcls-leather')); return; }
    if ((b = t.closest('[data-gcls-color]'))) { setColor(b.getAttribute('data-gcls-color')); return; }
    if ((b = t.closest('[data-gcls-zoom]'))) { openZoom(); return; }
    if ((b = t.closest('[data-gcls-view]'))) { setView(b.getAttribute('data-gcls-view')); return; }
    if ((b = t.closest('[data-gcls-lrm]'))) {
      var rk = b.getAttribute('data-gcls-lrm'), kb0 = ev.detail === 0;
      var li = b.closest('.gcls-line'), nextLi = li && (li.nextElementSibling || li.previousElementSibling);
      var nextRm = nextLi ? nextLi.querySelector('[data-gcls-lrm]') : null, nextKey = nextRm ? nextRm.getAttribute('data-gcls-lrm') : '';
      if (b.getAttribute('aria-disabled') === 'true') return;
      /* the answer to the tap is the line going (this frame); the set is redrawn right after it (INP) */
      b.setAttribute('aria-disabled', 'true');
      if (li) li.classList.add('is-going');
      afterPaint(function () {
        touch();
        if (rk === 'prot') { S.prot = false; }
        else if (rk === 'gift') { S.gift = false; }
        else if (rk === 'prio') { S.prio = false; }
        else if (rk === 'logo') { S.logo = false; }
        else if (rk === 'ini') { S.ini = ''; if (elIni) elIni.value = ''; }
        else if (rk.indexOf('ex:') === 0) { delete S.ex[rk.slice(3)]; quickGlide(); }
        else if (rk.indexOf('core:') === 0) { S.off[rk.slice(5)] = true; quickGlide(); }
        msg('');
        /* the summary stays where it is on screen (clearing the initials shortens the step above it) */
        keepPlace(q('.gcls-sumslab'), render);
        /* the focus stays in the list: on the next line's X, else on the summary */
        var f = (nextKey && q('.gcls-sumslab [data-gcls-lrm="' + nextKey + '"]')) || q('.gcls-sumslab [data-gcls-lrm]');
        if (f) try { f.focus({ preventScroll: true }); } catch (x) {}
        else if (kb0) { var sl = q('.gcls-sumslab'); if (sl) { sl.setAttribute('tabindex', '-1'); try { sl.focus({ preventScroll: true }); } catch (x) {} } }
      });
      return;
    }
    if ((b = t.closest('[data-gcls-thumb]'))) {
      var th = b.getAttribute('data-gcls-thumb');
      if (th === 'set') setView('set'); else setView('photos', th);
      return;
    }
    if ((b = t.closest('[data-gcls-cbtn], [data-gcls-cbtn-ex]'))) {
      ev.preventDefault();
      var kind = b.getAttribute('data-gcls-cbtn'), key = b.getAttribute('data-gcls-cbtn-ex');
      if (cpop.open && cpop.btn === b && !cpop.hover) { closeCpop(true); return; }
      var card = b.closest('.gcls-card');
      openCpop({ kind: kind, key: key, anchor: card && HOVER ? card : b, btn: b, hover: false }, ev.detail === 0 || !HOVER);
      return;
    }
    if ((b = t.closest('.gcls-card')) && elComp.contains(b) && !t.closest('button, a') && !b.classList.contains('is-leave')) {
      var cb = b.querySelector('.gcls-card__cbtn');
      if (cb && !cb.hidden) {
        var ck2 = cb.getAttribute('data-gcls-cbtn'), ek2 = cb.getAttribute('data-gcls-cbtn-ex');
        if (cpop.open && cpop.btn === cb && !cpop.hover) { closeCpop(false); return; }
        openCpop({ kind: ck2, key: ek2, anchor: HOVER || !cb.offsetWidth ? b : cb, btn: cb, hover: false }, ev.detail === 0);
      }
      return;
    }
    if ((b = t.closest('[data-gcls-alt]'))) {
      var pr = b.getAttribute('data-gcls-alt').split(':');
      setPieceColor(pr[0], pr[1]);
      var again = q('[data-gcls-slot] [data-gcls-cbtn="' + pr[0] + '"]');
      if (again && b.closest('[data-gcls-core]')) again.focus({ preventScroll: true });
      return;
    }
    if ((b = t.closest('[data-gcls-pick]'))) {
      var k = b.getAttribute('data-gcls-pick');
      if (k === S.pick) return;
      touch();
      /* the piece that was chosen can still be added from MORE */
      Object.keys(S.ex).forEach(function (key) { if (ALL[key] && ALL[key].kind === k) delete S.ex[key]; });
      S.pick = k;
      gcT({ name: 'builder_choice', builder: 'set', step: 'pick', value_key: k });
      delete S.off.second;
      msg(''); render(); return;
    }
    if ((b = t.closest('[data-gcls-more-add]'))) {
      if (b.getAttribute('aria-disabled') === 'true') return;
      var mk = b.getAttribute('data-gcls-more-add');
      if (b.getAttribute('aria-busy') === 'true') return;
      /* the pill answers this frame; the set is redrawn right after it (INP) */
      b.setAttribute('aria-busy', 'true');
      b.classList.add('is-busy');
      afterPaint(function () {
        touch();
        if (S.ex[mk]) delete S.ex[mk]; else S.ex[mk] = { col: null };
        gcT({ name: 'builder_choice', builder: 'set', step: 'extra_piece', value_key: mk, state: S.ex[mk] ? 'on' : 'off' });
        /* the pieces make room inside the half second after the tap (never counted as a layout shift) */
        quickGlide();
        msg(''); render();
        var nb = q('[data-gcls-more-add="' + mk + '"]');
        if (nb) { nb.removeAttribute('aria-busy'); nb.classList.remove('is-busy'); }
      });
      return;
    }
    if ((b = t.closest('[data-gcls-tip]'))) {
      ev.preventDefault();
      var open = !b.classList.contains('is-open');
      qa('[data-gcls-tip].is-open').forEach(function (x) { x.classList.remove('is-open'); });
      if (open) fitTip(b);
      b.classList.toggle('is-open', open);
      return;
    }
    if ((b = t.closest('[data-gcls-check]'))) { if (b.getAttribute('aria-disabled') !== 'true') toggleCheck(b.getAttribute('data-gcls-check')); return; }
    if ((b = t.closest('[data-gcls-core-check]'))) {
      if (b.getAttribute('aria-disabled') === 'true') { naColors(b, ev); return; }
      var sl = b.getAttribute('data-gcls-core-check');
      touch();
      if (b.getAttribute('aria-checked') === 'true') S.off[sl] = true; else delete S.off[sl];
      gcT({ name: 'builder_choice', builder: 'set', step: S.off[sl] ? 'piece_off' : 'piece_on', value_key: sl });
      quickGlide();
      msg(''); render(); return;
    }
    /* the WHOLE sold-out row opens the piece's colors: its photo, name, price,
       the "Sold out in ..." note and the room around them (its own buttons,
       such as "Available now in ...", keep their action) */
    if ((b = t.closest('.gcls-row--core.is-na')) && !t.closest('button, a, input, select, textarea, label')) { naColors(b, ev); return; }
    if ((b = t.closest('[data-gcls-rowtap], .gcls-addon .gc-sp-addon__main')) && !t.closest('button, a, input, select, textarea, label')) {
      if (naColors(b, ev)) return;
      var sq = b.closest('.gc-sp-addon') && b.closest('.gc-sp-addon').querySelector('.gc-addon-check');
      if (sq && sq.getAttribute('aria-disabled') !== 'true') sq.click();
      return;
    }
    if ((b = t.closest('[data-gcls-restore]'))) {
      touch();
      delete S.off[b.getAttribute('data-gcls-restore')];
      gcT({ name: 'builder_choice', builder: 'set', step: 'piece_on', value_key: b.getAttribute('data-gcls-restore') });
      msg('');
      /* putting a piece back (the gap's "+ Add", after an X): the others make room inside the half second, as when it left */
      quickGlide();
      render();
      return;
    }
    if (t.closest('[data-gcls-add]')) { ev.preventDefault(); if (!cfmQuick(ev)) onAdd(); return; }
    if (t.closest('[data-gcls-confirm-add]')) { ev.preventDefault(); if (cfm.open && !cfmQuick(ev)) onAdd(); return; }
    if (t.closest('[data-gcls-confirm-again]')) { ev.preventDefault(); if (cfm.open && !cfmQuick(ev)) onAdd(true); return; }
    if (t.closest('[data-gcls-confirm-edit]')) { ev.preventDefault(); if (cfmQuick(ev)) return; gcT({ name: 'order_check', surface: 'set_builder', action: 'edit' }); closeConfirm(true); return; }
  });
  /* Owner, 29 Sep 2026: tapping a piece's row that is not available (not
     made or sold out in its color) opens that piece's colors, as its color
     chip does; the chip is its keyboard way (a button), and its disabled
     checkbox, pressed, does the same. */
  function naColors(el, ev) {
    var row = el.closest && el.closest('.gcls-row--core.is-na');
    var chip = row && row.querySelector('[data-gcls-cbtn]');
    if (!chip) return false;
    if (cpop.open && cpop.btn === chip) { closeCpop(false); return true; }
    openCpop({ kind: chip.getAttribute('data-gcls-cbtn'), anchor: chip, btn: chip, hover: false }, ev.detail === 0 || !HOVER);
    return true;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-gcls-tip]')) qa('[data-gcls-tip].is-open').forEach(function (x) { x.classList.remove('is-open'); });
  });
  function fitTip(btn) {
    var bub = btn.querySelector('.gc-sp-addon__tipbubble');
    if (!bub) return;
    bub.style.setProperty('--gcls-tip-dx', '0px');
    var r = bub.getBoundingClientRect(), vw = document.documentElement.clientWidth, m = 12, dx = 0;
    if (r.width + 2 * m >= vw) dx = m - r.left;
    else if (r.left < m) dx = m - r.left;
    else if (r.right > vw - m) dx = vw - m - r.right;
    bub.style.setProperty('--gcls-tip-dx', Math.round(dx) + 'px');
  }
  root.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('[data-gcls-tip]'); if (b && !b.contains(e.relatedTarget)) fitTip(b); });
  root.addEventListener('focusin', function (e) { var b = e.target.closest && e.target.closest('[data-gcls-tip]'); if (b) fitTip(b); });

  /* the initials, typed in the step's field or in the field on the picture: one state, one path */
  /* e.isComposing: a composing keyboard (Gboard writes lowercase letters as a composition) is mid-word; rewriting
     the field then repeats letters (a, ab -> AAB). The state, price and preview follow anyway; compositionend
     cleans the field. */
  function onIniInput(src, e) {
    var info = iniInfo(src.value);
    var clean = info.value;
    if (info.dropped) latinHint();
    if (src.value !== clean && !(e && e.isComposing)) {
      var pos = src.selectionStart;
      src.value = clean;
      try { src.setSelectionRange(Math.min(pos, clean.length), Math.min(pos, clean.length)); } catch (e) {}
    }
    S.ini = clean;
    gcT({ name: 'initials_input', surface: 'set_builder', initials_len: clean.length });
    touch();
    if (elMsg && elMsg.classList.contains('is-bad')) msg('');
    renderEngrave();
    renderInitials();
    renderSummary();
    writeUrl();
  }
  if (elIni) elIni.addEventListener('input', function (e) { onIniInput(elIni, e); });
  if (elIni) elIni.addEventListener('compositionend', function () { onIniInput(elIni); });
  /* Enter (the keyboard's Go / Done) closes the keyboard, as on the personalized case: the floating bar comes back
     (assets/gcx-kit.js steps it aside while a field has the keyboard) */
  if (elIni) elIni.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); elIni.blur(); } });

  /* the field on the picture (see openEd) */
  if (elEd && elEdIn) {
    /* while it is open, a press on the spot keeps the focus in the field, so its click closes it (no blur race) */
    root.addEventListener('pointerdown', function (e) { if (edOpen && e.target.closest && e.target.closest('[data-gcls-spot]')) e.preventDefault(); });
    elEdIn.addEventListener('input', function (e) { onIniInput(elEdIn, e); });
    elEdIn.addEventListener('compositionend', function () { onIniInput(elEdIn); });
    elEd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || (e.key === 'Enter' && e.target === elEdIn)) { e.preventDefault(); e.stopPropagation(); closeEd(true); }
    });
    /* focus leaving the field or its tick (Tab, Shift+Tab, a press anywhere else) closes it */
    elEd.addEventListener('focusout', function (e) {
      if (e.relatedTarget && elEd.contains(e.relatedTarget)) return;
      setTimeout(function () { if (edOpen && !elEd.contains(document.activeElement)) closeEd(false); }, 120);
    });
    /* a tap outside closes it too, also where a tap does not take the focus (iOS keeps it in the field) */
    document.addEventListener('click', function (e) {
      if (!edOpen || !e.target || !e.target.closest || e.target.closest('[data-gcls-ed],[data-gcls-spot]')) return;
      closeEd(false);
    }, true);
    if (elEdOk) {
      /* the tick keeps the focus in the field while pressed (iOS: no blur first), then closes */
      elEdOk.addEventListener('pointerdown', function (e) { e.preventDefault(); });
      elEdOk.addEventListener('click', function (e) { e.preventDefault(); closeEd(true); });
    }
    /* a press on the glass around the field (the count, the padding) keeps the focus in the field */
    elEd.addEventListener('pointerdown', function (e) { if (e.target !== elEdIn) e.preventDefault(); });
    elEd.addEventListener('click', function (e) { e.stopPropagation(); });
    window.addEventListener('resize', function () { if (edOpen) placeEd(); }, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { if (edOpen) setTimeout(vvKeep, 60); });
  }

  /* arrow keys inside the radio groups (leather tiles, swatches, card holder or wallet) */
  root.addEventListener('keydown', function (ev) {
    var t = ev.target;
    if ((ev.key === 'Enter' || ev.key === ' ') && t.matches && t.matches('.ProductForm__ColorSwatch[data-gcls-color]')) { ev.preventDefault(); t.click(); return; }
    var group = t.closest && t.closest('[role="radiogroup"]');
    if (!group || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(ev.key) === -1) return;
    var btns = qa('[role="radio"]', group);
    var i = btns.indexOf(t);
    if (i === -1) return;
    ev.preventDefault();
    var n = ev.key === 'Home' ? 0 : ev.key === 'End' ? btns.length - 1 :
      (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') ? (i - 1 + btns.length) % btns.length : (i + 1) % btns.length;
    btns[n].click();
    var again = qa('[role="radio"]', group)[n];
    if (again) again.focus();
  });

  /* ---------- Add to Cart: one request, every piece its own line ---------- */
  function linkId() { return 'p_' + Date.now() + '_' + Math.random().toString(36).slice(2, 11); }
  function setId() { return 's_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10); }

  /* why validate() refused, as a fixed key for analytics */
  function gcWhy(b) { return b.model ? 'choose_device' : b.m === T.choosePieces ? 'choose_pieces' : (elIni && b.el === elIni) ? 'fix_initials' : 'sold_out'; }
  function validate() {
    var o = cur();
    if (!o.items.length) return { m: T.choosePieces, el: elCore };
    if (needsModel()) return { m: T.chooseDevice, el: elDevBtn, model: true };
    for (var i = 0; i < o.items.length; i++) {
      var it = o.items[i];
      if (!it.v || !it.v.avail) return { m: tpl(T.reasonItem, { piece: pName(it.p), why: T.soldOut }) };
    }
    if (S.ini && !new RegExp('^[A-Z0-9]{1,' + MAXC + '}$').test(S.ini)) return { m: T.fixInitials, el: elIni };
    return null;
  }
  function report(bad) {
    msg(bad.m, true);
    if (bad.el) {
      bad.el.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
      if (bad.model) {
        elDevBtn.classList.add('is-attn');
        setTimeout(function () { elDevBtn.classList.remove('is-attn'); }, 2600);
        setTimeout(openPop, REDUCED ? 0 : 450);
      } else {
        setTimeout(function () { try { bad.el.focus({ preventScroll: true }); } catch (e) {} }, 350);
      }
    }
  }
  function busyOff() {
    S.busy = false;
    root.classList.remove('is-busy');
    if (elAdd) elAdd.removeAttribute('aria-busy');
    renderAtc();
  }
  /* ---------- check before adding (owner, 29 Sep 2026) ----------
     "When selecting Add to Cart: confirm the summary, scroll to it and
     showcase it with blur outside, with its small fields marked, then show
     Add to Cart there again to proceed." The first valid press (the main
     button or a sticky, which presses it) glides the summary into view, dims
     and blurs the rest of the page (one fixed veil), marks each line's piece
     and its color and model (gcls-line__n, gcls-line__sub) one after another
     and shows a panel under the summary with Add to Cart and a quiet Edit.
     That Add to Cart adds exactly as before; a failed add closes it and the
     usual error shows. Esc, Edit or a tap on the veil closes it and gives
     the focus back. Nothing moves (the panel lies over the page) and nothing
     is remembered. Same look as the personalized case page. */
  var elSumSlab = q('.gcls-sumslab'), elCfm = q('[data-gcls-confirm]'), elCfmLive = q('[data-gcls-confirm-live]');
  var cfm = { open: false, opener: null, veil: null, role: null };
  /* what Tab can reach in the panel: shown, and not visibility:hidden (the summary's remove buttons, gcls-line__x,
     are hidden while the panel is open; focusing one does nothing, so the trap would never reach the buttons) */
  function cfmFocusables() {
    return qa('button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])', elSumSlab).filter(function (el) {
      if (el.closest('[hidden]') || !el.getClientRects().length) return false;
      return el.checkVisibility ? el.checkVisibility({ visibilityProperty: true }) : getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function cfmKey(e) {
    if (!cfm.open) return;
    if (e.key === 'Escape') { e.preventDefault(); gcT({ name: 'order_check', surface: 'set_builder', action: 'dismiss' }); closeConfirm(true); return; }
    if (e.key !== 'Tab') return;
    var f = cfmFocusables();
    if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  }
  /* A quick second tap (a double tap on the bar or the page's Add to Cart) lands on the veil, which would close the
     check, or on the check's own buttons (Add to Cart, Add another, Edit) as they glide past: within 450ms of the
     check opening, timed by the tap itself (Event.timeStamp, the same clock as performance.now()), and within 200ms
     of the page still moving, those taps are ignored. Each ignored tap restarts the window (a triple tap). */
  function cfmQuick(ev) {
    if (!cfm.open || !ev || typeof ev.timeStamp !== 'number') return false;
    var t = ev.timeStamp;
    if (t - (cfm.at || 0) < 450 || t - (cfm.moved || 0) < 200) { if (t > cfm.at) cfm.at = t; return true; }
    return false;
  }
  window.addEventListener('scroll', function () { if (cfm.open) cfm.moved = performance.now(); }, { passive: true });
  function openConfirm() {
    cfm.open = true;
    cfm.at = performance.now();
    gcT({ name: 'order_check', surface: 'set_builder', action: 'open', path: 'add' });
    var a = document.activeElement;
    cfm.opener = a && a !== document.body && !elSumSlab.contains(a) ? a : elAdd;
    closeCpop(false);
    if (!cfm.veil) {
      cfm.veil = document.createElement('div');
      cfm.veil.className = 'gcls-veil';
      cfm.veil.setAttribute('aria-hidden', 'true');
      cfm.veil.addEventListener('click', function (e) { if (cfmQuick(e)) return; gcT({ name: 'order_check', surface: 'set_builder', action: 'dismiss' }); closeConfirm(true); });
      document.body.appendChild(cfm.veil);
    }
    cfm.veil.hidden = false;
    cfm.role = [elSumSlab.getAttribute('role'), elSumSlab.getAttribute('aria-labelledby')];
    elSumSlab.setAttribute('role', 'dialog');
    elSumSlab.setAttribute('aria-modal', 'true');
    elSumSlab.setAttribute('aria-labelledby', elCfm.querySelector('.gcls-confirm__h').id);
    elCfm.hidden = false;
    elSumSlab.classList.add('is-confirm');
    void cfm.veil.offsetWidth;
    cfm.veil.classList.add('is-on');
    qa('.gcls-line__n, .gcls-line__sub', elSumSlab).filter(function (el) { return el.textContent.trim(); })
      .forEach(function (el, i) { el.style.setProperty('--i', i); el.classList.add('is-hl'); });
    var r = elSumSlab.getBoundingClientRect(), pr = elCfm.getBoundingClientRect();
    var h = Math.max(r.bottom, pr.bottom) - r.top, vh = window.innerHeight || 0;
    var y = window.pageYOffset + r.top - Math.max(12, (vh - h) / 2);
    try { window.scrollTo({ top: Math.max(0, y), behavior: REDUCED ? 'auto' : 'smooth' }); } catch (x) { window.scrollTo(0, Math.max(0, y)); }
    var head = elCfm.querySelector('.gcls-confirm__h');
    if (head) try { head.focus({ preventScroll: true }); } catch (x) {}
    if (elCfmLive) { elCfmLive.textContent = ''; setTimeout(function () { if (cfm.open && head) elCfmLive.textContent = head.textContent; }, 60); }
    document.addEventListener('keydown', cfmKey, true);
  }
  function closeConfirm(back) {
    if (!cfm.open) return;
    cfm.open = false;
    document.removeEventListener('keydown', cfmKey, true);
    elSumSlab.classList.remove('is-confirm');
    if (cfm.role) {
      if (cfm.role[0]) elSumSlab.setAttribute('role', cfm.role[0]); else elSumSlab.removeAttribute('role');
      if (cfm.role[1]) elSumSlab.setAttribute('aria-labelledby', cfm.role[1]); else elSumSlab.removeAttribute('aria-labelledby');
    }
    elSumSlab.removeAttribute('aria-modal');
    qa('.is-hl', elSumSlab).forEach(function (el) { el.classList.remove('is-hl'); });
    elCfm.hidden = true;
    if (elCfmLive) elCfmLive.textContent = '';
    if (cfm.veil) {
      cfm.veil.classList.remove('is-on');
      var v = cfm.veil;
      setTimeout(function () { if (!cfm.open) v.hidden = true; }, REDUCED ? 0 : 320);
    }
    /* back: give the focus back to what opened the check (else the main
       Add to Cart). 'auto' (after an add, or a failed one): the same, unless
       the focus has already moved on (the cart drawer took it) */
    var a = document.activeElement;
    if (back === 'auto') back = !a || a === document.body || a === document.documentElement || elSumSlab.contains(a);
    if (back) {
      var o = cfm.opener && cfm.opener.isConnected && cfm.opener.getClientRects().length ? cfm.opener : elAdd;
      if (o) try { o.focus({ preventScroll: true }); } catch (x) {}
    }
    cfm.opener = null;
  }
  /* again: the panel's "Add & build another set" (see buildAnother) */
  function afterPaint(fn) { requestAnimationFrame(function () { setTimeout(fn, 0); }); }
  function onAdd(again) {
    if (S.busy) return;
    if (again === true && cfm.open && elCfm) {
      /* the press shows at once (busy, both panel buttons stop taking presses); the checks and the cart
         read wait for the next frame, so the tap answers within one frame (INP) */
      S.busy = true;
      S.again = true;
      gcT({ name: 'order_check', surface: 'set_builder', action: 'confirm', path: 'add_another' });
      var cb = q('[data-gcls-confirm-again]', elCfm);
      if (cb) cb.setAttribute('aria-busy', 'true');
      elCfm.classList.add('is-busy');
      afterPaint(function () {
        root.classList.add('is-busy');
        if (elAdd) elAdd.setAttribute('aria-busy', 'true');
        var bad2 = validate();
        if (bad2) { gcT({ name: 'builder_blocked', builder: 'set', reason: gcWhy(bad2) }); S.again = false; cfmIdle(); closeConfirm(false); busyOff(); report(bad2); return; }
        readCart().then(send, send);
      });
      return;
    }
    var bad = validate();
    if (bad) {
      gcT({ name: 'builder_blocked', builder: 'set', reason: gcWhy(bad) });
      setTimeout(function () {
        if (!S.busy && elAdd) elAdd.removeAttribute('aria-busy');
        /* the floating bars' spinner: nothing is being added (as the personalized case's notAdding) */
        qa('[data-sticky-add-to-cart].is-loading, .cust-sticky-btn.is-loading', document).forEach(function (b) { b.classList.remove('is-loading'); });
      }, 0);
      closeConfirm(false);
      report(bad);
      return;
    }
    if (!cfm.open && elCfm && elSumSlab) { openConfirm(); return; }
    S.again = again === true;
    gcT({ name: 'order_check', surface: 'set_builder', action: 'confirm', path: S.again ? 'add_another' : 'add' });
    var ca = elCfm && q(S.again ? '[data-gcls-confirm-again]' : '[data-gcls-confirm-add]', elCfm);
    if (ca) ca.setAttribute('aria-busy', 'true');
    /* one add per press: both panel buttons stop taking presses until it is done (a double tap adds once) */
    if (elCfm) elCfm.classList.add('is-busy');
    S.busy = true;
    root.classList.add('is-busy');
    if (elAdd) elAdd.setAttribute('aria-busy', 'true');
    readCart().then(send, send);
  }
  function buildLines() {
    changed();
    var o = cur(), t = totals();
    var lines = [];
    var sid = setId();
    var ini = caseOn() ? cleanIni(S.ini) : '';
    var fee = ini ? feeFor(ini) : null;
    var link = fee ? linkId() : '';
    var lgId = logoOn() ? lgNewId() : '';
    /* line-item properties are order data for the workshop: fixed English
       names in every language; _set_id ties the pieces of one set */
    o.items.forEach(function (it) {
      var ln = { id: it.v.id, quantity: 1, properties: { _set_id: sid } };
      /* the Minimalist logo goes with the set's iPhone case (Oct 2026): "Logo: Minimalist" (the workshop's words,
         English in every language) and an id on the case line */
      if (lgId && it.kind === 'case' && !it.extra) { ln.properties.Logo = 'Minimalist'; ln.properties._logo_id = lgId; }
      if (it.kind === 'case' && !it.extra && fee) {
        ln.properties.Personalization = ini;
        ln.properties._personalization_id = link;
        lines.push(ln);
        lines.push({ id: fee.id, quantity: 1, properties: { For: ini, _personalization_link: link } });
      } else lines.push(ln);
    });
    if (t.prot) lines.push({ id: t.prot.id, quantity: 1, properties: { _set_id: sid } });
    if (D.gift && S.gift && !t.giftForced && t.giftUnits) lines.push({ id: D.gift.id, quantity: t.giftUnits });
    if (D.prio && S.prio && !(S.cart && S.cart.prioLine)) lines.push({ id: D.prio.id, quantity: 1 });
    /* and FIRST in the request its $25 line, carrying that id as _logo_link (as the product page and the builders
       send it); one request, so the pair arrives together, and assets/gc-logo-sync.js keeps it together afterwards.
       No _set_id on it: it is not a piece of the set (gc-track.js counts the pieces by _set_id) */
    if (lgId) lines.unshift({ id: LG.id, quantity: 1, properties: { _logo_link: lgId } });
    return { lines: lines, setId: sid, lgId: lgId };
  }
  function post(lines) {
    var gx = G();
    if (gx && gx.cartAdd) return gx.cartAdd(lines);
    window.currentPersonalization = null;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { window.location.href = D.cartUrl || '/cart'; return j; });
  }
  /* the panel's buttons take presses again */
  function cfmIdle() {
    if (!elCfm) return;
    elCfm.classList.remove('is-busy');
    qa('[data-gcls-confirm-add], [data-gcls-confirm-again]', elCfm).forEach(function (x) { x.removeAttribute('aria-busy'); });
  }
  function send() {
    var again = S.again;
    S.again = false;
    var bad = validate();
    if (bad) { cfmIdle(); if (again) closeConfirm(false); busyOff(); report(bad); return; }
    var b = buildLines();
    lgPending(b.lgId, true);
    msg('');
    var lbl = q('[data-gcls-add-label]');
    var ok = false;
    (again ? postQuiet(b.lines) : post(b.lines))
      .then(function () {
        ok = true;
        lgPending(b.lgId, false);
        /* build another: no note by the main button (it would move what is under it) and the cart is
           read once the builder is back at its start (buildAnother) */
        if (!again) msg(T.added);
        try { document.dispatchEvent(new CustomEvent('gcls:added', { detail: { setId: b.setId, items: b.lines, again: again, pieces: cur().items.length } })); } catch (e) {}
        return again ? null : readCart();
      })
      .catch(function (err) {
        lgBack(b.lgId);
        gcT({ name: 'builder_blocked', builder: 'set', reason: 'cart_error' });
        var m = (err && (err.description || err.message)) || T.error;
        closeConfirm('auto');
        msg(typeof m === 'string' ? m : T.error, true);
      })
      .then(function () {
        cfmIdle();
        if (again && ok) {
          closeConfirm(false);
          busyOff();
          buildAnother();
        } else {
          closeConfirm('auto');
          busyOff();
        }
        if (lbl) setText(lbl, T.cta);
        if (!again) setTimeout(renderSummary, 1200);
      });
  }

  /* ---------- Add to Cart & build another set (owner, 30 Sep 2026) ----------
     "After clicking the leather set Add to Cart, when the confirm comes up,
     add an option to add to cart & create another set, where it adds their
     current one to cart & brings them to the page again to create another."
     The check panel's second button adds exactly what its Add to Cart adds
     (buildLines: the same lines; every add has its own _set_id, so the cart
     drawer shows each set as its own group and "Remove set" takes out only
     that one), but quietly: postQuiet sends only 'cart:refresh' (theme.js
     redraws the drawer's content and the header count without opening it;
     'product:added' is what opens the drawer, custom.js / theme.js). An
     XMLHttpRequest with an {items:[...]} body, as GCX.cartAdd, so no fetch
     wrapper can stamp a drawer personalization on it.
     Then the page glides back to the top of the builder and, once there,
     the builder is the page as it opens without a choice (readUrl(true)),
     the address loses the builder's parameters, the focus goes to the
     heading and a short note confirms the add. The reset waits for the
     glide, and the picture, the summary and what follows it are redrawn
     hidden and shown at once (wide screens keep the summary on screen), so
     nothing the shopper is looking at moves. The new set is the page's own
     no-choice set (D.set.def), also after a Google Shopping ?variant= link.
     A failed add changes nothing: the panel closes and the
     usual error shows. */
  function postQuiet(lines) {
    /* the kit's quiet add (kit 1.6.0) when it is there; the same request below until then */
    var gx = G();
    if (gx && gx.cartAdd && gx.cartAdd.quiet) return gx.cartAdd(lines, { quiet: true });
    window.currentPersonalization = null;
    return new Promise(function (resolve, reject) {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var x = new XMLHttpRequest();
      x.open('POST', rootUrl + 'cart/add.js');
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        var j = null;
        try { j = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300) resolve(j); else reject(j || { status: x.status });
      };
      x.onerror = function () { reject({ status: 0 }); };
      x.send(JSON.stringify({ items: lines }));
    }).then(function (j) {
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      return j;
    });
  }
  /* what the picture shows: its pieces, their variants and the initials on the case */
  function stageSig() {
    changed();
    var o = cur();
    return o.core.map(function (c) { return c.kind + ':' + (c.v ? c.v.id : c.ck) + ':' + (c.on ? 1 : 0); }).join(',') + '|' +
      o.extras.map(function (x) { return x.p.key + ':' + x.ck; }).join(',') + '|' + S.device + '|' + cleanIni(S.ini);
  }
  function resetBuilder() {
    closeCpop(false);
    closePop(false);
    var was = stageSig();
    S.leather = ''; S.color = ''; S.device = ''; S.pick = 'cardholder';
    S.off = {}; S.dq = {}; S.pc = {}; S.ex = {};
    S.ini = ''; S.gift = false; S.prio = false; S.prot = false; S.logo = false;
    readUrl(true);
    /* a different picture is drawn hidden and shown once its photos are in, as a deep link's (reveal): the
       cards of the added set never move into the new set's places without a tap (no layout shift) */
    if (elComp && stageSig() !== was) { pend.cap = 0; elComp.classList.add('is-pending'); }
    /* the summary and what follows it: drawn hidden (gcls-set.css .is-swap) and shown once the cart has been
       re-read (it can change the summary's lines and notes), at the latest after 900 ms */
    root.classList.add('is-swap');
    S.touched = false;
    clearTimeout(urlT);
    try {
      var u = new URL(window.location.href), had = false;
      URLKEYS.forEach(function (k) { if (u.searchParams.has(k)) { u.searchParams.delete(k); had = true; } });
      if (had) history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
    if (elIni) elIni.value = '';
    msg('');
    render();
    stickyAgain();
    qa('.gcls-tiles__track, .gcls-swatches__track, .gcls-more__track, .gcls-inset__track').forEach(function (t) { if (t.scrollLeft) t.scrollLeft = 0; });
    var shown = false, st = setTimeout(swapIn, 900);
    function swapIn() {
      if (shown) return;
      shown = true;
      clearTimeout(st);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var sw = REDUCED ? [] : qa('.gcls__col > .gcls-sumslab, .gcls__col > .gcls-sumslab ~ *');
          sw.forEach(function (el) { el.classList.add('is-swapin'); });
          root.classList.remove('is-swap');
          if (sw.length) setTimeout(function () { sw.forEach(function (el) { el.classList.remove('is-swapin'); }); }, 320);
        });
      });
    }
    readCart().then(swapIn, swapIn);
  }
  function buildAnother() {
    var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var y = Math.max(0, Math.round(window.pageYOffset + root.getBoundingClientRect().top - hh));
    var done = false, tm = 0;
    function onScroll() { if (Math.abs(window.pageYOffset - y) < 2) land(); }
    function land() {
      if (done) return;
      done = true;
      clearTimeout(tm);
      window.removeEventListener('scrollend', land);
      window.removeEventListener('scroll', onScroll);
      resetBuilder();
      var h = q('.gcls__h1') || q('h1');
      if (h) {
        if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        try { h.focus({ preventScroll: true }); } catch (e) {}
      }
      setTimeout(toastLift, 400);
    }
    toast(T.againDone);
    var far = Math.abs(window.pageYOffset - y) > 2;
    if (!far || REDUCED) { if (far) window.scrollTo(0, y); land(); return; }
    window.addEventListener('scrollend', land);
    window.addEventListener('scroll', onScroll, { passive: true });
    tm = setTimeout(land, 1500);
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); land(); }
  }
  /* the note: fixed at the bottom of the screen (above a sticky bar), a polite status that exists before its
     words arrive (so it is read out), opacity and transform only */
  var toastEl = null, toastT = 0;
  function toastInit() {
    if (toastEl || !elCfm || !q('[data-gcls-confirm-again]', elCfm)) return;
    toastEl = document.createElement('div');
    toastEl.className = 'gcls-toast';
    /* the page's reading direction (the note lives outside the section, on <body>) */
    toastEl.setAttribute('dir', document.documentElement.getAttribute('dir') || getComputedStyle(root).direction || 'ltr');
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.setAttribute('aria-atomic', 'true');
    toastEl.innerHTML = '<svg class="gcls-toast__i" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M6 10.4l2.6 2.6L14 7.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="gcls-toast__t"></span>';
    toastEl.addEventListener('click', hideToast);
    document.body.appendChild(toastEl);
  }
  function hideToast() { if (toastEl) { clearTimeout(toastT); toastEl.classList.remove('is-on'); } }
  /* above a sticky add-to-cart bar showing at the bottom (measured when shown and again after the glide,
     when the bar has come in) */
  function toastLift() {
    if (!toastEl) return;
    var lift = 0, vh = window.innerHeight;
    qa('#sticky-add-to-cart-bar, .cust-sticky-btn', document).forEach(function (el) {
      var f = el;
      while (f && f !== document.body && getComputedStyle(f).position !== 'fixed') f = f.parentElement;
      if (!f || f === document.body) return;
      var r = f.getBoundingClientRect(), cs = getComputedStyle(f);
      if (r.height && r.top > vh / 2 && r.top < vh && cs.visibility !== 'hidden' && +cs.opacity > 0.1) lift = Math.max(lift, vh - r.top);
    });
    toastEl.style.setProperty('--gcls-toast-lift', Math.round(lift) + 'px');
  }
  function toast(txt) {
    toastInit();
    if (!toastEl || !txt) return;
    var t = toastEl.querySelector('.gcls-toast__t');
    t.textContent = '';
    toastLift();
    requestAnimationFrame(function () {
      toastEl.classList.add('is-on');
      setTimeout(function () { t.textContent = txt; }, 80);
    });
    clearTimeout(toastT);
    toastT = setTimeout(hideToast, 5200);
  }

  /* ---------- go ---------- */
  /* the Minimalist logo: the page's one choice (GCLogo, assets/gc-logo-spot.js) is this builder's, so anything on the
     page that reads or flips "logo inside" goes through S.logo; where its offer hangs (lgSide) is measured again
     once the indicator's stylesheet is in (it is linked without blocking the first paint) */
  if (LG && GL && GL.own) GL.own({ isOn: logoOn, toggle: function () { lgSet(!logoOn(), 'page'); } });
  if (LG) {
    var lgCss = document.querySelector('link[href*="gc-logo-spot.css"]');
    if (lgCss) lgCss.addEventListener('load', function () { setTimeout(lgSideSoon, 0); });
    window.addEventListener('load', lgSideSoon);
  }
  readUrl();
  adoptServerCards();
  root.classList.add('is-ready');
  if (S.ini && elIni) {
    elIni.value = S.ini;
    var gx0 = G();
    if (gx0 && gx0.typewriter) { var tw = gx0.typewriter(elIni); if (tw) tw.stop(); }
  }
  /* the first fit of the cards to their pieces happens without the glide */
  elComp.classList.add('is-still');
  setTimeout(function () { elComp.classList.remove('is-still'); }, 1600);
  render();
  setView('set');
  /* a deep link that changes the set: the buying column and the caption were kept hidden by snippets/gcls-layout
     (L.first) until this first render, so their texts never change in view (CLS) */
  root.classList.remove('is-dl');
  /* drawn: snippets/gcls-layout's safety reveal (L.safe) leaves the picture to this script from now on */
  elComp._gclsDrawn = true;
  if (elStage && !elComp.classList.contains('is-pending')) elStage.classList.remove('is-prep');
  ready = true;
  /* the stamp spot comes in once the picture has settled (the fonts in, the tags fitted to them and the cards'
     glide over), so it never moves while the page loads (CLS 0); at the latest after 8 s */
  (function () {
    var on = false;
    function spotOn() { if (on) return; on = true; elComp.classList.add('is-spot-on'); lgSync(); }
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () {
      requestAnimationFrame(function () { setTimeout(spotOn, 800); });
    });
    setTimeout(spotOn, 8000);
  })();
  readCart();
  toastInit();
  /* the color photos of every piece in the set, for the popovers, once the page is idle */
  (window.requestIdleCallback || function (f) { return setTimeout(f, 1200); })(function () {
    cur().core.forEach(function (c) { preloadSwatches(c.p); });
    morePieces().forEach(function (m) { preloadSwatches(m.p); });
  });
  var rt = null;
  var drawer = document.getElementById('sidebar-cart');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () { clearTimeout(rt); rt = setTimeout(function () { if (!S.busy) readCartSoft(); }, 1500); })
      .observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden && !S.busy) readCartSoft(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) readCart(); });
  document.addEventListener('cart:refresh', function () { clearTimeout(rt); rt = setTimeout(function () { if (!S.busy) readCartSoft(); }, 1500); });
  window.addEventListener('load', renderSticky);
  /* for tests and the cart drawer step: the page's own reading of the discount */
  window.__gclsState = function () { var o = cur(), t = totals(); return { leather: S.leather, color: S.color, device: S.device, pick: S.pick, pc: S.pc, items: o.items.map(function (it) { return { kind: it.kind, pid: it.p.id, vid: it.v.id, ck: it.ck, price: it.v.price }; }), blocked: o.core.filter(function (c) { return c.why; }).map(function (c) { return { kind: c.kind, why: c.why, alt: c.alt }; }), disc: t.d.kind, discHere: t.disc, list: t.list, total: t.total, eligN: t.d.eligN }; };
})();


/* Reviews of the pieces in your set (sections/gcls-reviews). Independent of
   the builder above; it listens to its "gcls:pieces" event.
   - The published reviews of each piece in the set come from Rapid Reviews'
     own public endpoint (the one its storefront widget reads), are merged
     newest first and labeled with the piece they were written for, with a
     link to that product. Nothing is copied to another product and nothing
     becomes structured data (the list is data-nosnippet, drawn here only).
   - The combined rating is the app's own counts per piece (sum of stars /
     number of published reviews), from the page data.
   - Tabs filter the list to one piece. When the endpoint does not answer,
     the per-piece cards (server-rendered) stay as they are. */
(function () {
  'use strict';
  var sec = document.querySelector('[data-gcls-rv]');
  if (!sec) return;
  var C;
  try { C = JSON.parse(sec.querySelector('[data-gcls-rv-data]').textContent); } catch (e) { return; }
  if (!C.api || !C.shop) return;
  var T = C.t || {};
  var live = sec.querySelector('[data-gcls-rv-live]');
  var listEl = sec.querySelector('[data-gcls-rv-list]');
  var tabsEl = sec.querySelector('[data-gcls-rv-tabs]');
  var moreBtn = sec.querySelector('[data-gcls-rv-more]');
  var emptyEl = sec.querySelector('[data-gcls-rv-empty]');
  var sumEl = sec.querySelector('[data-gcls-rv-sum]');
  var cardsRow = sec.querySelector('[data-gcls-rv-cards]');
  var PAGE = +C.page || 6;
  function G() { return window.GCX || null; }
  function lang() { return (document.documentElement.getAttribute('lang') || 'en').trim() || 'en'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(s, o) { return String(s == null ? '' : s).replace(/\[([a-z0-9_]+)\]|\{([a-z0-9_]+)\}/gi, function (m, a, b) { var k = a || b; return o && o[k] != null ? String(o[k]) : m; }); }
  function num(n) { var g = G(); return g && g.num ? g.num(n) : String(n); }
  function avgText(a) { return a.toFixed(1).replace('.', C.dec || '.'); }
  /* A review whose date lies in the future (a wrong date in the app, e.g. a
     2027 date on the croco case) is shown without a date and sorted by when
     it was last saved in the app, so it is never pinned to the top. The
     review itself is left as it is: its date is for the owner to correct in
     Rapid Reviews. */
  function isFuture(r) { return (+r.created_at_ts || 0) > Date.now(); }
  function when(r) {
    if (!isFuture(r)) return +r.created_at_ts || 0;
    var u = +r.updated_at_ts || 0;
    return u && u <= Date.now() ? u : 0;
  }
  function dateText(r) {
    if (isFuture(r) || !r.created_at_iso) return '';
    try { return new Date(r.created_at_iso).toLocaleDateString(lang(), { year: 'numeric', month: 'short', day: 'numeric' }); } catch (e) { return ''; }
  }
  var cache = {};
  function load(pid) {
    if (cache[pid]) return cache[pid];
    var url = String(C.api).replace(/\/+$/, '') + '/api/reviews/client/' + encodeURIComponent(C.shop) + '/by_entity_id/r/' + encodeURIComponent(pid) + '/';
    cache[pid] = fetch(url, { credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        return (j && j.data ? j.data : []).filter(function (x) { return x && x.type === 'r' && +x.published === 1 && String(x.entity_id) === String(pid) && x.rating; });
      })
      .catch(function (e) { delete cache[pid]; throw e; });
    return cache[pid];
  }

  var pieces = [], all = [], filter = 'all', shown = PAGE, tok = 0;
  function stars(r, label) {
    return '<span class="gcx-stars" style="--gcx-pct:' + Math.max(0, Math.min(100, r * 20)) + '%" role="img" aria-label="' + esc(label) + '"></span>';
  }
  function renderSum() {
    var n = 0, sum = 0;
    pieces.forEach(function (p) { if (p.rc > 0) { n += p.rc; sum += p.rs; } });
    if (!sumEl) return;
    sumEl.hidden = !n;
    if (!n) return;
    var a = sum / n;
    var txt = tpl(n === 1 && T.sumOne ? T.sumOne : T.sum, { count: num(n), avg: avgText(a) });
    sumEl.innerHTML = '<span class="gcx-rating" data-nosnippet>' + stars(a, tpl(T.aria, { avg: avgText(a) })) +
      '<span class="gcx-rating__txt"><span class="gcx-rating__val">' + esc(avgText(a)) + '</span> <span class="gcx-rating__dot" aria-hidden="true">·</span> ' + esc(txt) + '</span></span>';
  }
  /* one tab per piece, named by its short name (the stage's), never the
     product's long title; the chosen tab is scrolled fully into view */
  function renderTabs() {
    if (!tabsEl) return;
    var h = '<button type="button" class="gcls-rv__tab" aria-pressed="' + (filter === 'all') + '" data-gcls-rv-tab="all">' + esc(T.all) + '</button>';
    pieces.forEach(function (p) {
      var c = all.filter(function (r) { return String(r.entity_id) === String(p.id); }).length;
      if (!c) return;
      var lab = tpl(T.tab, { piece: p.name, count: num(p.rc || c) });
      h += '<button type="button" class="gcls-rv__tab" aria-pressed="' + (filter === String(p.id)) + '" data-gcls-rv-tab="' + p.id + '" title="' + esc(lab) + '">' + esc(lab) + '</button>';
    });
    tabsEl.innerHTML = h;
    var act = tabsEl.querySelector('[aria-pressed="true"]');
    if (act) {
      var cs = getComputedStyle(tabsEl), pad = parseFloat(cs.scrollPaddingLeft) || parseFloat(cs.paddingLeft) || 8;
      var tr = tabsEl.getBoundingClientRect(), r = act.getBoundingClientRect(), d = 0;
      if (r.left < tr.left + pad) d = r.left - tr.left - pad;
      else if (r.right > tr.right - pad) d = r.right - tr.right + pad;
      if (d) { tabsEl.style.scrollBehavior = 'auto'; tabsEl.scrollLeft += d; tabsEl.style.scrollBehavior = ''; }
    }
  }
  function renderList() {
    var ls = all.filter(function (r) { return filter === 'all' || String(r.entity_id) === filter; });
    var byId = {};
    pieces.forEach(function (p) { byId[String(p.id)] = p; });
    var h = '';
    ls.slice(0, shown).forEach(function (r) {
      var p = byId[String(r.entity_id)] || {};
      h += '<li class="gcls-rvi">' +
        '<div class="gcls-rvi__top">' + stars(+r.rating, tpl(T.stars, { n: r.rating })) +
        (dateText(r) ? '<span class="gcls-rvi__date">' + esc(dateText(r)) + '</span>' : '') + '</div>' +
        (r.title ? '<p class="gcls-rvi__title">' + esc(r.title) + '</p>' : '') +
        (r.body ? '<p class="gcls-rvi__body">' + esc(r.body) + '</p>' : '') +
        '<p class="gcls-rvi__by"><span class="gcls-rvi__name">' + esc(r.name || '') + '</span>' +
        (+r.verified === 1 ? '<span class="gcls-rvi__ver">' + esc(T.verified) + '</span>' : '') + '</p>' +
        '<a class="gcls-rvi__of" href="' + esc((p.url || '#') + (C.anchor || '')) + '">' + esc(tpl(T.of, { piece: p.mid || p.name || '' })) + '</a>' +
        '</li>';
    });
    listEl.innerHTML = h;
    if (emptyEl) emptyEl.hidden = !!ls.length;
    if (moreBtn) moreBtn.hidden = ls.length <= shown;
  }
  function run(ps) {
    pieces = [];
    var seen = {};
    (ps || []).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; pieces.push(p); } });
    renderSum();
    /* the fallback cards follow the pieces in the set */
    Array.prototype.forEach.call(sec.querySelectorAll('[data-gcls-rv-card]'), function (c) { c.hidden = !seen[c.getAttribute('data-gcls-rv-card')]; });
    var my = ++tok;
    Promise.all(pieces.map(function (p) { return load(p.id).catch(function () { return null; }); })).then(function (res) {
      if (my !== tok) return;
      if (res.every(function (x) { return x === null; })) { if (live) live.hidden = true; if (cardsRow) cardsRow.hidden = false; return; }
      all = [];
      res.forEach(function (x) { if (x) all = all.concat(x); });
      all.sort(function (a, b) { return when(b) - when(a); });
      if (filter !== 'all' && !seen[filter]) filter = 'all';
      shown = PAGE;
      if (live) live.hidden = false;
      /* the merged list works: the per-piece cards (its fallback) step aside */
      if (cardsRow) cardsRow.hidden = true;
      renderTabs();
      renderList();
      var g = G(), row = tabsEl && tabsEl.closest('[data-gcx-scroll]');
      if (g && g.scrollRow && row) g.scrollRow(row);
    });
  }
  sec.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gcls-rv-tab]');
    if (t) { filter = t.getAttribute('data-gcls-rv-tab'); shown = PAGE; renderTabs(); renderList(); var f = sec.querySelector('[data-gcls-rv-tab="' + filter + '"]'); if (f) f.focus(); return; }
    if (e.target.closest('[data-gcls-rv-more]')) { shown += PAGE; renderList(); }
  });
  /* load when the section comes near the screen, then follow the set */
  var want = window.__gclsPieces || null, started = false;
  document.addEventListener('gcls:pieces', function (e) { want = e.detail && e.detail.pieces; if (started) run(want); });
  function start() { if (started) return; started = true; if (want) run(want); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
    io.observe(sec);
  } else start();
})();

/* Examples row (sections/gcls-examples), on any page that has one. Independent of the set builder above.
   - Blur-up: a photo (or video poster) that has not loaded yet is hidden over its blurred 24px copy (CSS --lqip)
     and fades in when it has loaded.
   - Preloading: once the row is near the screen, every item that scrolls into the row loads now, and so does
     the item after it (loading=eager), so the next swipe or chevron never shows a blank frame.
   - Chevrons: the items differ in width, so one press moves exactly one item. The distance to the next (or
     previous) item's start is measured at click time and handed to the kit row as data-gcx-step (px) in the
     capture phase, before the kit's own click handler on the chevron reads it (assets/gcx-kit.js, stepSize).
   - Videos: one MP4 (short side up to 1080px), muted, looped, playsinline, preload metadata with a full-size
     poster; the slides next to the one shown load in full (preload auto). Owner's autoplay policy (29 Sep
     2026): a video plays on its own, without a click, whenever any part of it is on screen (its slide shown,
     the panel open), whatever the reduced-motion setting, and pauses off-screen, in a hidden panel and while
     the tab is hidden. A browser that refuses to start it (e.g. iOS Low Power Mode) is asked again each time it
     comes on screen and on the shopper's next tap or key anywhere on the page. The pause control is the video
     itself: a tap toggles, and a video the shopper paused stays paused. No play button over the video (the
     thumbnails keep their play glyph). */
(function () {
  'use strict';
  var secs = document.querySelectorAll('[data-gcls-ex]');
  if (!secs.length) return;
  var hasIO = 'IntersectionObserver' in window;
  function arr(l) { return Array.prototype.slice.call(l); }
  /* a refused autoplay is asked again on the shopper's next tap or key anywhere (a user gesture lets it start) */
  var retries = [];
  function retryAll(e) {
    retries.forEach(function (fn) { fn(e); });
  }
  ['click', 'touchend', 'keydown'].forEach(function (t) { document.addEventListener(t, retryAll, { capture: true, passive: true }); });

  /* The Leather Set's Photos view (data-gcls-photos) is laid out ahead, invisible, behind the set: a video in
     it plays and loads in full only while that view is shown (the set builder says so with a gcls:view event
     on every change of view). Any other examples row is always shown. */
  function panelOf(el) { return el && el.closest ? el.closest('[data-gcls-photos]') : null; }
  function panelShown(panel) { return !panel || (!panel.hidden && panel.classList.contains('is-on')); }
  function eager(slide) {
    if (!slide) return;
    arr(slide.querySelectorAll('img[loading="lazy"]')).forEach(function (im) { im.loading = 'eager'; });
    /* a video next to the one shown loads in full, so it is sharp from its first frame */
    if (panelShown(panelOf(slide))) arr(slide.querySelectorAll('video')).forEach(function (v) { if (v.preload !== 'auto') v.preload = 'auto'; });
  }
  function blurUp(pic) {
    var im = pic.querySelector('img');
    if (!im || (im.complete && im.naturalWidth)) return;
    pic.classList.add('is-loading');
    function done() { pic.classList.remove('is-loading'); }
    im.addEventListener('load', done, { once: true });
    im.addEventListener('error', done, { once: true });
  }

  function setupStep(row, track) {
    row.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.gcx-chev') : null;
      if (!b || b.parentNode !== row) return;
      var dir = b.classList.contains('gcx-chev--prev') ? -1 : 1;
      var cs = getComputedStyle(track), rtl = cs.direction === 'rtl';
      var pad = parseFloat(rtl ? cs.paddingRight : cs.paddingLeft) || 0;
      var tr = track.getBoundingClientRect(), line = rtl ? tr.right - pad : tr.left + pad;
      var best = null;
      arr(track.children).forEach(function (it) {
        if (!it.offsetWidth) return;
        var r = it.getBoundingClientRect();
        var off = rtl ? line - r.right : r.left - line;
        if (dir > 0 ? (off > 2 && (best === null || off < best)) : (off < -2 && (best === null || off > best))) best = off;
      });
      row.setAttribute('data-gcx-step', best === null ? 'item' : String(Math.max(2, Math.round(Math.abs(best)))));
    }, true);
  }

  function setupPreload(row, track) {
    var slides = arr(track.children);
    if (!hasIO) { slides.slice(0, 2).forEach(eager); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        eager(en.target);
        eager(en.target.nextElementSibling);
        eager(en.target.previousElementSibling);
      });
    }, { root: track, threshold: 0.01 });
    var outer = new IntersectionObserver(function (ents) {
      if (!ents.some(function (en) { return en.isIntersecting; })) return;
      outer.disconnect();
      slides.forEach(function (sl) { io.observe(sl); });
    }, { rootMargin: '400px 0px' });
    outer.observe(row);
  }

  function setupVideo(pic) {
    var v = pic.querySelector('video[data-gcls-video]');
    if (!v || v.__gcls) return;
    v.__gcls = 1;
    var btn = pic.querySelector('[data-gcls-vbtn]');
    /* no button over the video: the video itself is the (keyboard) control that plays and pauses it */
    if (!btn && pic.hasAttribute('data-play')) {
      btn = pic;
      pic.setAttribute('role', 'button');
      pic.tabIndex = 0;
      pic.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pic.click(); } });
    }
    var visible = !hasIO, userPause = false, refused = false, inSlider = !!pic.closest('[data-gcls-phtrack]');
    var panel = panelOf(pic);
    v.muted = true;
    function playing() { return !v.paused && !v.ended; }
    /* on screen: the intersection (below) AND, in the Leather Set, its Photos view shown (a laid-out but
       invisible panel still intersects) */
    function want() { return visible && panelShown(panel) && !document.hidden && !userPause; }
    function ui() {
      var on = playing();
      pic.classList.toggle('is-playing', on);
      pic.classList.toggle('is-idle', !on && (userPause || refused));
      if (btn) {
        var l = btn.getAttribute(on ? 'data-pause' : 'data-play') || '';
        if (btn.getAttribute('aria-label') !== l) btn.setAttribute('aria-label', l);
      }
    }
    function play() {
      var p = null;
      try { p = v.play(); } catch (e) {}
      /* a refusal (autoplay blocked, e.g. Low Power Mode) shows the poster until the next try; a play() cut
         short by our own pause() (AbortError, scrolled away) is not a refusal */
      if (p && p.then) p.then(function () { refused = false; ui(); }, function (err) { if (err && err.name === 'NotAllowedError') refused = true; ui(); });
    }
    function sync() {
      if (want()) { if (!playing()) play(); }
      else if (playing()) v.pause();
      ui();
    }
    pic.addEventListener('click', function (e) {
      e.preventDefault();
      if (playing()) { userPause = true; v.pause(); }
      else { userPause = false; play(); }
      ui();
    });
    retries.push(function (e) {
      if (!refused || playing() || !want() || (e && e.target && e.target.closest && e.target.closest('[data-gcls-exvid]') === pic)) return;
      play();
    });
    ['play', 'playing', 'pause'].forEach(function (t) { v.addEventListener(t, ui); });
    document.addEventListener('visibilitychange', sync);
    if (panel) panel.addEventListener('gcls:view', sync);
    if (btn && btn !== pic) btn.hidden = false;
    if (hasIO) {
      /* any part of the video on screen (a slide outside the photo track's window, or a hidden panel, is not) */
      new IntersectionObserver(function (ents) {
        /* in the Photos slider only the settled slide plays (a neighbor passing by mid-swipe waits) */
        ents.forEach(function (en) { visible = en.isIntersecting && en.intersectionRatio > (inSlider ? .6 : 0); });
        sync();
      }, { threshold: [0, 0.01, 0.5, 0.6, 0.9, 1] }).observe(v);
    } else sync();
    ui();
  }

  arr(secs).forEach(function (sec) {
    var row = sec.querySelector('[data-gcx-scroll]');
    var track = row && row.querySelector('[data-gcx-track]');
    arr(sec.querySelectorAll('.gcls-ex__pic')).forEach(blurUp);
    arr(sec.querySelectorAll('[data-gcls-exvid]')).forEach(setupVideo);
    if (row && track) { setupStep(row, track); setupPreload(row, track); }
  });
})();
